// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css";
// import Sidebar from "../Misc/Sidebar";
// import DashNavbar from "../Misc/DashNavbar";
// import { Table, Alert, Modal, Button, Card, Spinner, Form, InputGroup, Row, Col, Badge } from "react-bootstrap";
// import Chart from "chart.js/auto";

// // Helper function to format date
// const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     try {
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'short',
//             day: 'numeric'
//         });
//     } catch (error) {
//         return "N/A";
//     }
// };

// // --- COMPONENT: ApplicantDetailsModal ---
// const ApplicantDetailsModal = ({ show, onHide, applicant, isLoading }) => {
//     const renderField = (label, value) => (
//         <Col md={6} className="mb-2">
//             <div className="p-2 border-bottom">
//                 <small className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>{label}</small>
//                 <span className="text-dark">{value || "N/A"}</span>
//             </div>
//         </Col>
//     );

//     return (
//         <Modal show={show} onHide={onHide} size="lg" centered scrollable>
//             <Modal.Header closeButton className="bg-light">
//                 <Modal.Title className="gradient-text">
//                     <i className="fas fa-user-circle me-2"></i>
//                     {applicant ? `${applicant.first_name || ''} ${applicant.last_name || ''}` : "Applicant Profile"}
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="bg-light">
//                 {isLoading ? (
//                     <div className="text-center p-5">
//                         <Spinner animation="border" variant="primary" />
//                         <p className="mt-2">Fetching profile details...</p>
//                     </div>
//                 ) : applicant ? (
//                     <div className="px-2">
//                         {/* Personal Information */}
//                         <Card className="shadow-sm mb-3 border-0">
//                             <Card.Header className="bg-white fw-bold text-primary">Personal Details</Card.Header>
//                             <Card.Body>
//                                 <Row>
//                                     {renderField("Full Name", `${applicant.first_name || ''} ${applicant.middle_name || ''} ${applicant.last_name || ''}`)}
//                                     {renderField("Email Address", applicant.email)}
//                                     {renderField("Phone Number", applicant.phone)}
//                                     {renderField("Gender", applicant.gender)}
//                                     {renderField("Date of Birth", applicant.date_of_birth)}
//                                     {renderField("Age", applicant.age)}
//                                     {renderField("Marital Status", applicant.marital_status)}
//                                 </Row>
//                             </Card.Body>
//                         </Card>

//                         {/* Address Information */}
//                         <Card className="shadow-sm mb-3 border-0">
//                             <Card.Header className="bg-white fw-bold text-primary">Address & Location</Card.Header>
//                             <Card.Body>
//                                 <Row>
//                                     {renderField("Current Location", applicant.address_type)}
//                                     {renderField("Village/City", applicant.village)}
//                                     {renderField("Tehsil", applicant.tehsil)}
//                                     {renderField("District", applicant.district)}
//                                     {renderField("State", applicant.state)}
//                                     {renderField("Country", applicant.country)}
//                                     {renderField("Zip Code", applicant.zip_code)}
//                                 </Row>
//                             </Card.Body>
//                         </Card>

//                         {/* Professional & Education */}
//                         <Card className="shadow-sm mb-3 border-0">
//                             <Card.Header className="bg-white fw-bold text-primary">Education & Experience</Card.Header>
//                             <Card.Body>
//                                 <Row>
//                                     {renderField("Education Level", applicant.education)}
//                                     {renderField("Degree", applicant.degree)}
//                                     {renderField("Experience Type", <Badge bg={applicant.experience === 'Experienced' ? 'info' : 'secondary'}>{applicant.experience}</Badge>)}
//                                     {applicant.experience === 'Experienced' && (
//                                         <>
//                                             {renderField("Total Experience", `${applicant.Work_total_experience_year || 0} Years ${applicant.Work_total_experience_months || 0} Months`)}
//                                             {renderField("Current Company", applicant.current_comapny_name)}
//                                             {renderField("Current Designation", applicant.job_title)}
//                                             {renderField("Notice Period", `${applicant.current_notice_period_days} Days`)}
//                                         </>
//                                     )}
//                                 </Row>
//                             </Card.Body>
//                         </Card>

//                         {/* Financials (Only for Experienced) */}
//                         {applicant.experience === 'Experienced' && (
//                             <Card className="shadow-sm mb-3 border-0">
//                                 <Card.Header className="bg-white fw-bold text-primary">Financial Details & Reason for Leaving</Card.Header>
//                                 <Card.Body>
//                                     <Row>
//                                         {renderField("Current CTC", applicant.current_ctc)}
//                                         {renderField("Gross Salary", applicant.gross)}
//                                         {renderField("Net Salary", applicant.net)}
//                                         {renderField("Variables", applicant.variables)}
//                                         <Col md={12} className="mt-2">
//                                             <div className="p-2 bg-light rounded">
//                                                 <small className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Reason for Leaving</small>
//                                                 <span className="text-dark">{applicant.reason_for_leaving || "No reason provided"}</span>
//                                             </div>
//                                         </Col>
//                                     </Row>
//                                 </Card.Body>
//                             </Card>
//                         )}

//                         {/* Referral */}
//                         <Card className="shadow-sm mb-3 border-0">
//                             <Card.Header className="bg-white fw-bold text-primary">Referral & Other</Card.Header>
//                             <Card.Body>
//                                 <Row>
//                                     {renderField("Referred By", applicant.referred_by)}
//                                     {renderField("Referrer Contact", applicant.referred_contact)}
//                                     {renderField("Acknowledged", applicant.acknowledged ? "Yes" : "No")}
//                                     {renderField("Job Offered", applicant.job_offered ? <Badge bg="success">Yes</Badge> : <Badge bg="danger">No</Badge>)}
//                                 </Row>
//                             </Card.Body>
//                         </Card>
//                     </div>
//                 ) : (
//                     <div className="text-center p-4">No data found for this applicant.</div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light">
//                 <Button variant="secondary" onClick={onHide}>Close Profile</Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };

// // --- COMPONENT: ApplicantModal (Personality Charts) ---
// const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" },
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
// ];

// const ApplicantModal = ({ applicant, jobapplications, setSuccessMessage, updateJobApplication, personalityResults, onStatusUpdate }) => {
//     const [show, setShow] = useState(false);
//     const [personalityData, setPersonalityData] = useState([]);
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
//     const chartRefs = useRef({});
//     const [currentJobId, setCurrentJobId] = useState(null);
//     const [jobQuestions, setJobQuestions] = useState([]);
//     const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);
//     const [isUpdatingStatus, setIsUpdatingStatus] = useState({}); 
//     const [localJobApplications, setLocalJobApplications] = useState([]);

//     useEffect(() => {
//         if (jobapplications) {
//             setLocalJobApplications([...jobapplications]);
//         }
//     }, [jobapplications]);

//     const handleStatusChange = (jobApplicationId, newStatus) => {
//         setIsUpdatingStatus(prev => ({ ...prev, [jobApplicationId]: true }));
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${jobApplicationId}/`, { 
//                 job_status: newStatus 
//             })
//             .then(() => {
//                 setLocalJobApplications(prev => 
//                     prev.map(job => job.id === jobApplicationId ? { ...job, job_status: newStatus } : job)
//                 );
//                 updateJobApplication(jobApplicationId, newStatus);
//                 setSuccessMessage("Job status updated successfully");
//                 if (onStatusUpdate) onStatusUpdate();
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .catch((error) => {
//                 console.error("Error updating status:", error);
//                 setSuccessMessage("Failed to update status");
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .finally(() => {
//                 setIsUpdatingStatus(prev => ({ ...prev, [jobApplicationId]: false }));
//             });
//     };

//     useEffect(() => {
//         setShow(false);
//         const timer = setTimeout(() => {
//             if (applicant && jobapplications) setShow(true);
//         }, 100);
//         return () => clearTimeout(timer);
//     }, [applicant, jobapplications]);

//     useEffect(() => {
//         if (personalityResults) {
//             const processedResults = personalityResults.map(res => ({ 
//                 ...res,
//                 job_title: undefined,
//                 job_id: res.posting_id || res.object_id
//             }));
//             setPersonalityData(processedResults);
//         } else if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant, personalityResults]);

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
//             const response = await axios.get(personalityUrl);
//             const data = Array.isArray(response.data) ? response.data : [];
//             setPersonalityData(data.map(res => ({ ...res, job_id: res.posting_id || res.object_id })));
//         } catch (error) {
//             setPersonalityData([]);
//         }
//     };

//     useEffect(() => {
//         if (personalityData.length > 0 && applicant?.id) {
//             const fetchJobTitles = async () => {
//                 try {
//                     const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//                     const jobTitlesMap = (response.data || []).reduce((acc, job) => {
//                         const jobId = job.job_id || job.posting_id;
//                         if (jobId) acc[jobId] = job.job_title;
//                         return acc;
//                     }, {});
//                     setPersonalityJobTitles(personalityData.map(data => jobTitlesMap[data.posting_id || data.object_id] || `ID: ${data.posting_id || data.object_id}`));
//                 } catch (error) {
//                     setPersonalityJobTitles(personalityData.map(data => `ID: ${data.posting_id || data.object_id}`));
//                 }
//             };
//             fetchJobTitles();
//         }
//     }, [personalityData, applicant?.id]);

//     useEffect(() => {
//         const createdCharts = {};
//         personalityData.forEach((data, index) => {
//             const chartId = `personalityChart-${applicant?.id}-${index}`;
//             const chartElement = document.getElementById(chartId);
//             if (chartElement) {
//                 const ctx = chartElement.getContext("2d");
//                 createdCharts[index] = new Chart(ctx, {
//                     type: 'doughnut',
//                     data: {
//                         labels: [`Correct (${data.correct_count})`, `Wrong (${data.wrong_count})`],
//                         datasets: [{ data: [data.correct_count, data.wrong_count], backgroundColor: ['#28a745b3', '#dc3545b3'] }]
//                     },
//                     options: { responsive: true, maintainAspectRatio: false, cutout: '60%' }
//                 });
//             }
//         });
//         return () => Object.values(createdCharts).forEach(chart => chart?.destroy());
//     }, [personalityData, applicant?.id]);

//     const handleShowSubmittedAnswers = async (applicantId, jobId, postingType) => {
//         setCurrentJobId(jobId);
//         setIsLoadingAnswers(true);
//         try {
//             const type = postingType || "Job_Opening";
//             const res = await axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${type}/${jobId}/?applicant_id=${applicantId}`);
//             setJobQuestions(res.data?.questions || []);
//         } catch (error) {
//             console.error(error);
//         } finally {
//             setIsLoadingAnswers(false);
//         }
//     };

//     const renderAnswerOptions = (question) => {
//         const userAns = question.user_selected_answer;
//         if (!userAns) return <div className="text-muted small">No answer data</div>;
//         return (
//             <div>
//                 {question.answers.map((opt, idx) => (
//                     <div key={idx} className="small">
//                         <span className={idx === userAns.selected_index ? (userAns.is_correct === "correct" ? 'text-success fw-bold' : 'text-danger fw-bold') : (idx === question.correct_answer_index ? 'text-success' : '')}>
//                             {String.fromCharCode(65 + idx)}. {opt}
//                         </span>
//                     </div>
//                 ))}
//             </div>
//         );
//     };

//     return (
//         <Modal show={show} onHide={() => setShow(false)} dialogClassName="modal-xl" centered scrollable>
//             <Modal.Header closeButton><Modal.Title className="gradient-text">{applicant?.first_name} Details</Modal.Title></Modal.Header>
//             <Modal.Body className="p-4">
//                 <Table striped bordered hover responsive size="sm" className="mb-4">
//                     <thead className="table-light"><tr><th>Job Title</th><th>Status</th><th>Applied Date</th></tr></thead>
//                     <tbody>
//                         {localJobApplications.map(job => (
//                             <tr key={job.id}>
//                                 <td>{job.job_title}</td>
//                                 <td>
//                                     <Form.Select size="sm" value={job.job_status} onChange={(e) => handleStatusChange(job.id, e.target.value)} disabled={isUpdatingStatus[job.id]}>
//                                         {jobStatusOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//                                     </Form.Select>
//                                 </td>
//                                 <td>{formatDate(job.applied_date)}</td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </Table>
//                 <div className="d-flex flex-wrap gap-3">
//                     {personalityData.map((data, index) => (
//                         <Card key={index} style={{ width: '260px' }}>
//                             <Card.Header className="small fw-bold">{personalityJobTitles[index]}</Card.Header>
//                             <Card.Body className="text-center">
//                                 <div style={{ height: '120px' }}><canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas></div>
//                                 <Button size="sm" className="mt-2" variant="outline-info" onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id, data.opening_post)}>View Answers</Button>
//                             </Card.Body>
//                         </Card>
//                     ))}
//                 </div>
//                 {currentJobId && (
//                     <Card className="mt-4">
//                         <Card.Header className="d-flex justify-content-between">Answers <Button variant="close" onClick={() => setCurrentJobId(null)} /></Card.Header>
//                         <Card.Body>
//                             <Table size="sm">
//                                 <thead><tr><th>Question</th><th>Options</th><th>Result</th></tr></thead>
//                                 <tbody>
//                                     {jobQuestions.map((q, i) => (
//                                         <tr key={i}>
//                                             <td>{q.question_text}</td>
//                                             <td>{renderAnswerOptions(q)}</td>
//                                             <td><Badge bg={q.user_selected_answer?.is_correct === "correct" ? "success" : "danger"}>{q.user_selected_answer?.is_correct.toUpperCase()}</Badge></td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                         </Card.Body>
//                     </Card>
//                 )}
//             </Modal.Body>
//         </Modal>
//     );
// };

// // --- MAIN DASHBOARD COMPONENT ---
// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([]);
//     const [activeTab, setActiveTab] = useState('Job_Opening');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [recordsPerPage, setRecordsPerPage] = useState(10);
//     const [jobapplications, setJobApplications] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedApplicant, setSelectedApplicant] = useState(null);
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null);
//     const [filterJobTitle, setFilterJobTitle] = useState("");
//     const [filterLocation, setFilterLocation] = useState("");
//     const [isLoading, setIsLoading] = useState(true);
//     const [isDetailsLoading, setIsDetailsLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const fetchApplicants = () => {
//         setIsLoading(true);
//         axios.get("https://raasbackend.vetrinahealthcare.com/applicants_alt/")
//             .then((response) => {
//                 const data = Array.isArray(response.data) ? response.data : [];
//                 const fetchAllJobData = async () => {
//                     const enriched = await Promise.all(data.map(async (applicant) => {
//                         try {
//                             const res = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//                             return { ...applicant, job_titles: (res.data || []).map(j => j.job_title).filter(Boolean) };
//                         } catch { return { ...applicant, job_titles: [] }; }
//                     }));
//                     setApplicationList(enriched);
//                     setIsLoading(false);
//                 };
//                 fetchAllJobData();
//             })
//             .catch(() => { setError("Failed to load applicants."); setIsLoading(false); });
//     };

//     useEffect(() => { fetchApplicants(); }, []);

//     const handleViewDetails = async (applicant) => {
//         setSelectedApplicant(applicant);
//         setShowModal(true);
//         try {
//             const res = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//             setJobApplications((res.data || []).map(j => ({ id: j.id || j.job_id, job_title: j.job_title, applied_date: j.applied_date, job_status: j.job_status || 'applied' })));
//         } catch { setJobApplications([]); }
//     };

//     // FIXED: Fetch from the base list API and find the ID manually because the /id/ endpoint returns 404
//     const handleViewApplicantDetails = async (applicantId) => {
//         setShowDetailsModal(true);
//         setIsDetailsLoading(true);
//         setSelectedApplicantDetails(null);
//         try {
//             // We hit the endpoint that you confirmed works
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/applicants/`);
//             if (Array.isArray(response.data)) {
//                 const detailedUser = response.data.find(app => Number(app.id) === Number(applicantId));
//                 setSelectedApplicantDetails(detailedUser);
//             }
//         } catch (error) {
//             console.error("Error details:", error);
//             setSelectedApplicantDetails(applicationList.find(app => app.id === applicantId));
//         } finally {
//             setIsDetailsLoading(false);
//         }
//     };

//     const handleDownloadResume = (id, fileName) => {
//         window.open(`https://raasbackend.vetrinahealthcare.com/media/${fileName}`, '_blank');
//     };

//     const tabFilteredApplications = useMemo(() => {
//         return applicationList.filter(app => {
//             const results = app.action?.personality_results || [];
//             if (results.length === 0) return activeTab === 'Job_Opening';
//             return results.some(r => r.opening_post === activeTab);
//         });
//     }, [applicationList, activeTab]);

//     const filteredApplications = useMemo(() => {
//         return tabFilteredApplications.filter(app => {
//             const query = searchQuery.toLowerCase();
//             const fullName = `${app.first_name} ${app.last_name}`.toLowerCase();
//             return fullName.includes(query) && (!filterJobTitle || app.job_titles?.some(t => t.includes(filterJobTitle)));
//         });
//     }, [tabFilteredApplications, searchQuery, filterJobTitle]);

//     const currentRecords = filteredApplications.slice((currentPage - 1) * recordsPerPage, currentPage * recordsPerPage);
//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <main className="main p-3">
//                     <div className="container-fluid">
//                         {successMessage && <Alert variant="success" className="position-fixed top-0 end-0 m-3" style={{ zIndex: 9999 }}>{successMessage}</Alert>}
//                         <Card className="shadow-sm">
//                             <Card.Header className="bg-light d-flex justify-content-between">
//                                 <h1 className="h4 mb-0 gradient-text">Applicant Management</h1>
//                             </Card.Header>
//                             <Card.Body>
//                                 <ul className="nav nav-pills mb-3">
//                                     {['Job_Opening', 'Business_Opportunity', 'Technical_Consultant'].map(tab => (
//                                         <li key={tab} className="nav-item">
//                                             <button className={`nav-link ${activeTab === tab ? 'active' : ''}`} onClick={() => setActiveTab(tab)}>{tab.replace('_', ' ')}</button>
//                                         </li>
//                                     ))}
//                                 </ul>
//                                 <Row className="mb-3">
//                                     <Col md={4}><Form.Control size="sm" placeholder="Search..." onChange={(e) => setSearchQuery(e.target.value)} /></Col>
//                                     <Col md={2}><Button size="sm" variant="outline-secondary" onClick={fetchApplicants}><i className="fas fa-sync" /></Button></Col>
//                                 </Row>
//                                 <div className="table-responsive">
//                                     <Table striped hover size="sm">
//                                         <thead className="table-dark">
//                                             <tr><th>Sr.</th><th>First Name</th><th>Last Name</th><th>Email</th><th>Applied Date</th><th className="text-center">Resume</th><th className="text-center">Actions</th></tr>
//                                         </thead>
//                                         <tbody>
//                                             {isLoading ? <tr><td colSpan="7" className="text-center p-5"><Spinner animation="border" /></td></tr> :
//                                                 currentRecords.map((app, index) => (
//                                                     <tr key={app.id}>
//                                                         <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
//                                                         <td>{app.first_name}</td>
//                                                         <td>{app.last_name}</td>
//                                                         <td>{app.email}</td>
//                                                         <td>{formatDate(app.applied_date)}</td>
//                                                         <td className="text-center">{app.resume ? <Button variant="link" size="sm" onClick={() => handleDownloadResume(app.id, app.resume)}><i className="fas fa-download" /></Button> : '-'}</td>
//                                                         <td className="text-center">
//                                                             <Button variant="info" size="sm" className="me-2" onClick={() => handleViewDetails(app)}><i className="fas fa-clipboard-check" /></Button>
//                                                             <Button variant="secondary" size="sm" onClick={() => handleViewApplicantDetails(app.id)}><i className="fas fa-user" /></Button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             }
//                                         </tbody>
//                                     </Table>
//                                 </div>
//                                 <div className="d-flex justify-content-between mt-2">
//                                     <span className="small">Showing {currentRecords.length} records</span>
//                                     <div>
//                                         {[...Array(totalPages)].map((_, i) => <Button key={i} size="sm" variant={currentPage === i + 1 ? "primary" : "outline-primary"} className="ms-1" onClick={() => setCurrentPage(i + 1)}>{i + 1}</Button>)}
//                                     </div>
//                                 </div>
//                             </Card.Body>
//                         </Card>
//                     </div>
//                     {showModal && <ApplicantModal applicant={selectedApplicant} jobapplications={jobapplications} setSuccessMessage={setSuccessMessage} updateJobApplication={(id, status) => setApplicationList(prev => prev.map(a => a.id === id ? { ...a, job_status: status } : a))} personalityResults={selectedApplicant?.action?.personality_results} onStatusUpdate={fetchApplicants} />}
//                     <ApplicantDetailsModal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} applicant={selectedApplicantDetails} isLoading={isDetailsLoading} />
//                 </main>
//             </div>
//         </>
//     );
// }





import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/dash.css";
import Sidebar from "../Misc/Sidebar";
import DashNavbar from "../Misc/DashNavbar";
import { Table, Alert, Modal, Button, Card, Spinner, Form, InputGroup, Row, Col, Badge } from "react-bootstrap";
import Chart from "chart.js/auto";

// Helper function to format date
const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    } catch (error) {
        return "N/A";
    }
};

// --- NEW COMPONENT: ApplicantDetailsModal ---
const ApplicantDetailsModal = ({ show, onHide, applicant, isLoading }) => {
    const renderField = (label, value) => (
        <Col md={6} className="mb-2">
            <div className="p-2 border-bottom">
                <small className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>{label}</small>
                <span className="text-dark">{value || "N/A"}</span>
            </div>
        </Col>
    );

    return (
        <Modal show={show} onHide={onHide} size="lg" centered scrollable>
            <Modal.Header closeButton className="bg-light">
                <Modal.Title className="gradient-text">
                    <i className="fas fa-user-circle me-2"></i>
                    {applicant ? `${applicant.first_name || ''} ${applicant.last_name || ''}` : "Applicant Profile"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light">
                {isLoading ? (
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-2">Fetching profile details...</p>
                    </div>
                ) : applicant ? (
                    <div className="px-2">
                        {/* Personal Information */}
                        <Card className="shadow-sm mb-3 border-0">
                            <Card.Header className="bg-white fw-bold text-primary">Personal Details</Card.Header>
                            <Card.Body>
                                <Row>
                                    {renderField("Full Name", `${applicant.first_name || ''} ${applicant.middle_name || ''} ${applicant.last_name || ''}`)}
                                    {renderField("Email Address", applicant.email)}
                                    {renderField("Phone Number", applicant.phone)}
                                    {renderField("Gender", applicant.gender)}
                                    {renderField("Date of Birth", applicant.date_of_birth)}
                                    {renderField("Age", applicant.age)}
                                    {renderField("Marital Status", applicant.marital_status)}
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Address Information */}
                        <Card className="shadow-sm mb-3 border-0">
                            <Card.Header className="bg-white fw-bold text-primary">Address & Location</Card.Header>
                            <Card.Body>
                                <Row>
                                    {renderField("Current Location", applicant.address_type)}
                                    {renderField("Village/City", applicant.village)}
                                    {renderField("Tehsil", applicant.tehsil)}
                                    {renderField("District", applicant.district)}
                                    {renderField("State", applicant.state)}
                                    {renderField("Country", applicant.country)}
                                    {renderField("Zip Code", applicant.zip_code)}
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Professional & Education */}
                        <Card className="shadow-sm mb-3 border-0">
                            <Card.Header className="bg-white fw-bold text-primary">Education & Experience</Card.Header>
                            <Card.Body>
                                <Row>
                                    {renderField("Education Level", applicant.education)}
                                    {renderField("Degree", applicant.degree)}
                                    {renderField("Experience Type", <Badge bg={applicant.experience === 'Experienced' ? 'info' : 'secondary'}>{applicant.experience}</Badge>)}
                                    {applicant.experience === 'Experienced' && (
                                        <>
                                            {renderField("Total Experience", `${applicant.Work_total_experience_year || 0} Years ${applicant.Work_total_experience_months || 0} Months`)}
                                            {renderField("Current Company", applicant.current_comapny_name)}
                                            {renderField("Current Designation", applicant.job_title)}
                                            {renderField("Notice Period", `${applicant.current_notice_period_days} Days`)}
                                        </>
                                    )}
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Financials (Only for Experienced) */}
                        {applicant.experience === 'Experienced' && (
                            <Card className="shadow-sm mb-3 border-0">
                                <Card.Header className="bg-white fw-bold text-primary">Financial Details & Reason for Leaving</Card.Header>
                                <Card.Body>
                                    <Row>
                                        {renderField("Current CTC", applicant.current_ctc)}
                                        {renderField("Gross Salary", applicant.gross)}
                                        {renderField("Net Salary", applicant.net)}
                                        {renderField("Variables", applicant.variables)}
                                        <Col md={12} className="mt-2">
                                            <div className="p-2 bg-light rounded">
                                                <small className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Reason for Leaving</small>
                                                <span className="text-dark">{applicant.reason_for_leaving || "No reason provided"}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        )}

                        {/* Referral */}
                        <Card className="shadow-sm mb-3 border-0">
                            <Card.Header className="bg-white fw-bold text-primary">Referral & Other</Card.Header>
                            <Card.Body>
                                <Row>
                                    {renderField("Referred By", applicant.referred_by)}
                                    {renderField("Referrer Contact", applicant.referred_contact)}
                                    {renderField("Acknowledged", applicant.acknowledged ? "Yes" : "No")}
                                    {renderField("Job Offered", applicant.job_offered ? <Badge bg="success">Yes</Badge> : <Badge bg="danger">No</Badge>)}
                                </Row>
                            </Card.Body>
                        </Card>
                    </div>
                ) : (
                    <div className="text-center p-4">No data found for this applicant.</div>
                )}
            </Modal.Body>
            <Modal.Footer className="bg-light">
                <Button variant="secondary" onClick={onHide}>Close Profile</Button>
            </Modal.Footer>
        </Modal>
    );
};

// --- EXISTING COMPONENT: ApplicantModal (Personality Charts) ---
const jobStatusOptions = [
    { value: "applied", label: "Applied", bgColor: "bg-info" },
    { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
    { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" },
    { value: "selected", label: "Selected", bgColor: "bg-success" },
    { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
];

const ApplicantModal = ({ applicant, jobapplications, setSuccessMessage, updateJobApplication, personalityResults, onStatusUpdate }) => {
    const [show, setShow] = useState(false);
    const [personalityData, setPersonalityData] = useState([]);
    const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
    const chartRefs = useRef({});
    const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
    const [currentJobId, setCurrentJobId] = useState(null);
    const [jobQuestions, setJobQuestions] = useState([]);
    const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);
    const [isUpdatingStatus, setIsUpdatingStatus] = useState({}); // Track status updates per job
    const [localJobApplications, setLocalJobApplications] = useState([]);
    // Initialize local job applications when prop changes
    useEffect(() => {
        if (jobapplications) {
            setLocalJobApplications([...jobapplications]);
        }
    }, [jobapplications]);

    const handleStatusChange = (jobApplicationId, newStatus) => {
        // Set loading state for this specific job
        setIsUpdatingStatus(prev => ({ ...prev, [jobApplicationId]: true }));
        
        axios
            .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${jobApplicationId}/`, { 
                job_status: newStatus 
            })
            .then(() => {
                // Update local state immediately
                setLocalJobApplications(prev => 
                    prev.map(job => 
                        job.id === jobApplicationId 
                            ? { ...job, job_status: newStatus } 
                            : job
                    )
                );
                
                // Update parent component state
                updateJobApplication(jobApplicationId, newStatus);
                
                setSuccessMessage("Job status updated successfully");
                
                // Call the refresh function if provided (for full data refresh)
                if (onStatusUpdate) {
                    onStatusUpdate();
                }
                
                setTimeout(() => setSuccessMessage(""), 5000);
            })
            .catch((error) => {
                console.error("Error updating job status:", error);
                setSuccessMessage("Failed to update status");
                setTimeout(() => setSuccessMessage(""), 5000);
            })
            .finally(() => {
                // Clear loading state
                setIsUpdatingStatus(prev => ({ ...prev, [jobApplicationId]: false }));
            });
    };

    useEffect(() => {
        setShow(false);
        const timer = setTimeout(() => {
            if (applicant && jobapplications) {
                setShow(true);
            }
        }, 100);
        return () => {
            clearTimeout(timer);
            Object.values(chartRefs.current).forEach(chart => chart?.destroy());
        };
    }, [applicant, jobapplications]);

    useEffect(() => {
        if (personalityResults) {
            // Remove job_title from personality results to avoid duplicates
            const processedResults = personalityResults.map(res => ({ 
                ...res,
                job_title: undefined, // Remove job_title
                job_id: res.posting_id || res.object_id
            }));
            setPersonalityData(processedResults);
        } else if (show && applicant?.id) {
            fetchPersonalityData(applicant.id);
        }
    }, [show, applicant, personalityResults]);

    const fetchPersonalityData = async (applicantId) => {
        try {
            const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
            const personalityResponse = await axios.get(personalityUrl);
            const data = Array.isArray(personalityResponse.data) ? personalityResponse.data : [];
            
            // Remove job_title to avoid duplicates
            const processed = data.map(res => ({ 
                ...res,
                job_title: undefined, // Remove job_title
                job_id: res.posting_id || res.object_id
            }));
            
            setPersonalityData(processed);
        } catch (error) {
            console.error("Error fetching personality data:", error);
            setPersonalityData([]);
        }
    };

    useEffect(() => {
        if (personalityData.length > 0 && applicant?.id) {
            const fetchJobTitles = async () => {
                try {
                    // Use ONLY the job-title API
                    const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`;
                    const jobTitleResponse = await axios.get(jobTitleUrl);
                    const jobTitlesMap = (jobTitleResponse.data || []).reduce((acc, job) => {
                        // Use job_id or posting_id to match with personality data
                        const jobId = job.job_id || job.posting_id;
                        if (jobId && job.job_title) {
                            acc[jobId] = job.job_title;
                        }
                        return acc;
                    }, {});
                    
                    // Map job titles to personality data
                    const titles = personalityData.map(data => {
                        const jobId = data.posting_id || data.object_id;
                        return jobTitlesMap[jobId] || `ID: ${jobId}`;
                    });
                    
                    setPersonalityJobTitles(titles);
                } catch (error) {
                    console.error("Error fetching job titles:", error);
                    // If API fails, use only IDs (not job_title from personality results)
                    setPersonalityJobTitles(personalityData.map(data => 
                        `ID: ${data.posting_id || data.object_id}`
                    ));
                }
            };
            fetchJobTitles();
        }
    }, [personalityData, applicant?.id]);

    useEffect(() => {
        const createdCharts = {};
        if (Array.isArray(personalityData)) {
            personalityData.forEach((data, index) => {
                const chartId = `personalityChart-${applicant?.id}-${index}`;
                const chartElement = document.getElementById(chartId);
                if (chartElement && data && data.job_id) {
                    const newChart = createDonutChart(data, chartId);
                    if (newChart) createdCharts[index] = newChart;
                }
            });
        }
        chartRefs.current = createdCharts;
        return () => Object.values(createdCharts).forEach(chart => chart?.destroy());
    }, [personalityData, applicant?.id]);

    const onHide = () => setShow(false);

    const createDonutChart = (data, chartId) => {
        if (!data || typeof data.correct_count !== 'number' || typeof data.wrong_count !== 'number') return null;
        const ctx = document.getElementById(chartId)?.getContext("2d");
        if (!ctx) return null;
        return new Chart(ctx, {
            type: 'doughnut', 
            data: {
                labels: [`Correct (${data.correct_count})`, `Wrong (${data.wrong_count})`],
                datasets: [{ 
                    data: [data.correct_count, data.wrong_count], 
                    backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'], 
                    borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'], 
                    borderWidth: 1 
                }]
            }, 
            options: { 
                responsive: true, 
                maintainAspectRatio: false, 
                cutout: '60%', 
                plugins: { 
                    legend: { 
                        display: true, 
                        position: 'bottom', 
                        labels: { 
                            boxWidth: 10, 
                            padding: 15, 
                            font: { size: 10 } 
                        } 
                    } 
                } 
            }
        });
    };

    const handleShowSubmittedAnswers = async (applicantId, jobId, postingType) => {
        setCurrentJobId(jobId);
        setIsLoadingAnswers(true);
        setJobQuestions([]);
        
        // Find by posting_id or job_id
        const specificResult = personalityData.find(item => 
            item.posting_id === jobId || item.job_id === jobId
        );
        
        setFilteredSubmittedAnswers(specificResult || null);
        const type = postingType || "Job_Opening";
        
        // Use the jobId directly (e.g., "job-004")
        let formattedPathId = jobId;
        
        try {
            const questionResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${type}/${formattedPathId}/?applicant_id=${applicantId}`);
            setJobQuestions(questionResponse.data?.questions || []);
        } catch (error) {
            console.error("Error fetching questions:", error);
        } finally {
            setIsLoadingAnswers(false);
        }
    };

    // Simple function to render answer options
    const renderAnswerOptions = (question, index) => {
        const userAnswer = question.user_selected_answer;
        
        if (!userAnswer) {
            return <div className="text-muted small">No answer data</div>;
        }

        const selectedIndex = userAnswer.selected_index;
        const isCorrect = userAnswer.is_correct === "correct";
        const correctIndex = question.correct_answer_index;
        const options = question.answers;

        return (
            <div>
                {/* Simple list of options */}
                <div className="mb-2">
                    {options.map((option, idx) => {
                        const isSelected = idx === selectedIndex;
                        const isCorrectOpt = idx === correctIndex;
                        
                        return (
                            <div key={idx} className="d-flex align-items-center mb-1">
                                {/* Option letter */}
                                <div className={`me-2 fw-bold ${isSelected ? (isCorrect ? 'text-success' : 'text-danger') : isCorrectOpt ? 'text-success' : ''}`}>
                                    {String.fromCharCode(65 + idx)}.
                                </div>
                                
                                {/* Option text */}
                                <div className="flex-grow-1">
                                    {option}
                                </div>
                                
                                {/* Status indicator */}
                                {isSelected && (
                                    <div className={`badge ${isCorrect ? 'bg-success' : 'bg-danger'} ms-2`}>
                                        {isCorrect ? '✓ Selected' : '✗ Selected'}
                                    </div>
                                )}
                                {!isSelected && isCorrectOpt && (
                                    <div className="badge bg-success ms-2">✓ Correct</div>
                                )}
                            </div>
                        );
                    })}
                </div>
                
                {/* Result summary */}
                <div className={`small p-2 rounded text-center ${isCorrect ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'}`}>
                    {isCorrect ? (
                        <span>✓ Correct! Selected Option {String.fromCharCode(65 + selectedIndex)}</span>
                    ) : (
                        <span>✗ Wrong. Selected Option {String.fromCharCode(65 + selectedIndex)}, Correct is Option {String.fromCharCode(65 + correctIndex)}</span>
                    )}
                </div>
            </div>
        );
    };

    return (
        <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
            <Modal.Header closeButton><Modal.Title className="gradient-text">{applicant?.first_name || 'Applicant'} Details</Modal.Title></Modal.Header>
            <Modal.Body className="p-4">
                <Card className="mb-4 shadow-sm">
                    <Card.Header className="bg-light"><h5 className="mb-0">Job Applications</h5></Card.Header>
                    <Card.Body className="p-0">
                        <Table striped bordered hover responsive size="sm" className="mb-0">
                            <thead className="table-light"><tr><th style={{ width: '40%' }}>Job Title</th><th style={{ width: '40%' }}>Status</th><th style={{ width: '20%' }}>Applied On</th></tr></thead>
                            <tbody>
                                {localJobApplications?.length > 0 ? localJobApplications.map((jobApp) => {
                                    const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
                                    const isUpdating = isUpdatingStatus[jobApp.id];
                                    
                                    return (
                                        <tr key={jobApp.id}>
                                            <td>{jobApp.job_title || 'N/A'}</td>
                                            <td>
                                                {isUpdating ? (
                                                    <div className="d-flex align-items-center justify-content-center" style={{ height: '38px' }}>
                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                        <span className="small">Updating...</span>
                                                    </div>
                                                ) : (
                                                    <Form.Select 
                                                        size="sm" 
                                                        className={`${statusOption?.bgColor || 'bg-light'}`} 
                                                        value={jobApp.job_status || 'applied'} 
                                                        onChange={(e) => handleStatusChange(jobApp.id, e.target.value)} 
                                                        style={{ 
                                                            color: statusOption?.bgColor.includes('text-dark') ? '#212529' : '#fff', 
                                                            fontWeight: 500 
                                                        }}
                                                        disabled={isUpdating}
                                                    >
                                                        {jobStatusOptions.map((option) => (
                                                            <option key={option.value} value={option.value} style={{ backgroundColor: '#fff', color: '#000' }}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                )}
                                            </td>
                                            <td>{formatDate(jobApp.applied_date)}</td>
                                        </tr>
                                    );
                                }) : <tr><td colSpan="3" className="text-center text-muted p-3">No applications found.</td></tr>}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
                <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
                <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
                    {personalityData?.map((data, index) => {
                        const score = typeof data.status === 'number' ? data.status : 0;
                        const isPassed = (data.result === 'T' || data.result === 'A') && score > 0;
                        
                        // Get job title from the API response
                        const jobTitle = personalityJobTitles[index] || `ID: ${data.posting_id || data.object_id}`;
                        
                        return (
                            <Card key={`${data.job_id}-${index}`} className="text-center shadow-sm" style={{ minWidth: '260px', flex: '1 1 260px' }}>
                                <Card.Header className="bg-light">
                                    <Card.Title as="h6" className="mb-0 text-truncate" title={jobTitle}>
                                        {jobTitle}
                                    </Card.Title>
                                </Card.Header>
                                <Card.Body className="d-flex flex-column p-2">
                                    <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}>
                                        <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
                                    </div>
                                    <div className="mt-auto">
                                        <p className="mb-1">
                                            <strong>Score:</strong> 
                                            <b className="gradient-text">
                                                {typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}
                                            </b>
                                        </p>
                                        <p className="mb-2">
                                            <strong>Result:</strong> 
                                            {isPassed ? (
                                                <span className="badge bg-success">Passed</span>
                                            ) : (
                                                <span className="badge bg-danger">Failed</span>
                                            )}
                                        </p>
                                        <Button 
                                            variant="outline-info" 
                                            size="sm" 
                                            onClick={() => handleShowSubmittedAnswers(applicant.id, data.posting_id || data.job_id, data.opening_post)}
                                            disabled={isLoadingAnswers && currentJobId === (data.posting_id || data.job_id)}
                                        >
                                            {isLoadingAnswers && currentJobId === (data.posting_id || data.job_id) ? 
                                                <Spinner animation="border" size="sm" /> : 
                                                <><i className="fas fa-receipt me-1"></i> View Answers</>
                                            }
                                        </Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        );
                    })}
                </div>
                
                {/* Only show questions and answers when View Answers is clicked */}
                {currentJobId && jobQuestions.length > 0 && (
                    <div className="mt-4">
                        <Card className="shadow-sm">
                            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">
                                    Answers for: {personalityJobTitles[personalityData.findIndex(p => (p.posting_id || p.job_id) === currentJobId)] || currentJobId}
                                </h5>
                                <Button variant="close" onClick={() => setCurrentJobId(null)}></Button>
                            </Card.Header>
                            <Card.Body>
                                {isLoadingAnswers ? (
                                    <div className="text-center p-4">
                                        <Spinner animation="border" variant="primary" />
                                        <p className="mt-2">Loading answers...</p>
                                    </div>
                                ) : (
                                    <Table striped bordered hover responsive size="sm">
                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width: '5%' }}>#</th>
                                                <th style={{ width: '35%' }}>Question</th>
                                                <th style={{ width: '45%' }}>Options & Choices</th>
                                                <th style={{ width: '15%' }} className="text-center">Result</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {jobQuestions.map((question, index) => {
                                                const userAnswer = question.user_selected_answer;
                                                const isCorrect = userAnswer?.is_correct === "correct";
                                                
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td className="small fw-bold">{question.question_text}</td>
                                                        <td className="text-start align-middle">
                                                            {renderAnswerOptions(question, index)}
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <span className={`badge ${isCorrect ? 'bg-success' : 'bg-danger'} px-3 py-2`}>
                                                                {isCorrect ? 'CORRECT' : 'WRONG'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                )}
                            </Card.Body>
                        </Card>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className="bg-light"><Button variant="secondary" onClick={onHide}>Close</Button></Modal.Footer>
        </Modal>
    );
};

// --- MAIN DASHBOARD COMPONENT ---
export default function Jobapplicationresult() {
    const [applicationList, setApplicationList] = useState([]);
    const [activeTab, setActiveTab] = useState('Job_Opening');
    const [currentPage, setCurrentPage] = useState(1);
    const [successMessage, setSuccessMessage] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [jobapplications, setJobApplications] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedApplicant, setSelectedApplicant] = useState(null);
    const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null);
    const [filterJobTitle, setFilterJobTitle] = useState("");
    const [filterLocation, setFilterLocation] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isDetailsLoading, setIsDetailsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchApplicants = () => {
        setIsLoading(true);
        axios.get("https://raasbackend.vetrinahealthcare.com/applicants_alt/")
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data : [];
                console.log("Total applicants fetched:", data.length);
                
                // Fetch job titles for each applicant
                const fetchAllJobData = async () => {
                    const applicantsWithJobTitles = await Promise.all(
                        data.map(async (applicant) => {
                            try {
                                const jobResponse = await axios.get(
                                    `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`
                                );
                                const jobTitles = (jobResponse.data || [])
                                    .map(job => job.job_title)
                                    .filter(Boolean);
                                
                                return {
                                    ...applicant,
                                    job_titles: jobTitles
                                };
                            } catch (error) {
                                console.error(`Error fetching jobs for applicant ${applicant.id}:`, error);
                                return { ...applicant, job_titles: [] };
                            }
                        })
                    );
                    
                    setApplicationList(applicantsWithJobTitles);
                    setIsLoading(false);
                };
                
                fetchAllJobData();
            })
            .catch((error) => {
                console.error("Error fetching applicants:", error);
                setError("Failed to load applicants.");
                setIsLoading(false);
            });
    };

    useEffect(() => { fetchApplicants(); }, []);

    const handleViewDetails = async (applicant) => {
        setSelectedApplicant(applicant);
        setJobApplications([]);
        setShowModal(true);
        
        try {
            // Use ONLY the job-title API, not personality results
            const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
            if (response.data && Array.isArray(response.data)) {
                console.log("Jobs from job-title API:", response.data);
                
                // Format the data properly
                const apiJobs = response.data.map(job => ({
                    id: job.id || job.job_id,
                    job_title: job.job_title || 'N/A',
                    applied_date: job.applied_date,
                    job_status: job.job_status || 'applied'
                }));
                
                setJobApplications(apiJobs);
            }
        } catch (error) { 
            console.error("Error fetching job applications:", error);
            // If API fails, show empty list
            setJobApplications([]);
        }
    };
// FIXED: Fetch from the base list API and find the ID manually because the /id/ endpoint returns 404
    const handleViewApplicantDetails = async (applicantId) => {
        setShowDetailsModal(true);
        setIsDetailsLoading(true);
        setSelectedApplicantDetails(null);
        try {
            // Hitting the base endpoint that returns the full detailed list
            const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/applicants/`);
            
            if (Array.isArray(response.data)) {
                // Find the specific applicant in the detailed list
                const detailedUser = response.data.find(app => Number(app.id) === Number(applicantId));
                
                if (detailedUser) {
                    setSelectedApplicantDetails(detailedUser);
                } else {
                    // Fallback to basic list if not found in detailed list
                    setSelectedApplicantDetails(applicationList.find(app => app.id === applicantId));
                }
            }
        } catch (error) {
            console.error("Error fetching details:", error);
            // Fallback to basic list on API error
            setSelectedApplicantDetails(applicationList.find(app => app.id === applicantId));
        } finally {
            setIsDetailsLoading(false);
        }
    };
    const handleDownloadResume = async (applicantId, resumeFileName) => {
        if (!resumeFileName) {
            alert("No resume available for download");
            return;
        }
        
        try {
            // Construct the full URL to the resume
            const resumeUrl = `https://raasbackend.vetrinahealthcare.com/media/${resumeFileName}`;
            window.open(resumeUrl, '_blank');
        } catch (error) { 
            console.error("Error downloading resume:", error);
            alert("Failed to download resume."); 
        }
    };

    // CORRECTED FILTER LOGIC
    const tabFilteredApplications = useMemo(() => {
        console.log("Filtering for tab:", activeTab);
        console.log("Total applicants:", applicationList.length);
        
        const filtered = applicationList.filter(app => {
            // If applicant has no personality results at all, show in Job_Opening tab
            const personalityResults = app.action?.personality_results || [];
            
            if (personalityResults.length === 0) {
                // Show in Job_Opening tab by default if no personality results
                return activeTab === 'Job_Opening';
            }
            
            // Check if applicant has any result for the active tab
            const hasTabResult = personalityResults.some(result => {
                if (!result.opening_post) return false;
                
                // Map the opening_post to our tab names
                const tabMapping = {
                    'Job_Opening': 'Job_Opening',
                    'Business_Opportunity': 'Business_Opportunity', 
                    'Technical_Consultant': 'Technical_Consultant'
                };
                
                // Check if this result's opening_post matches the active tab
                return tabMapping[result.opening_post] === activeTab;
            });
            
            return hasTabResult;
        });
        
        console.log(`Filtered for ${activeTab}:`, filtered.length);
        return filtered;
    }, [applicationList, activeTab]);

    const filteredApplications = useMemo(() => {
        return tabFilteredApplications.filter((app) => {
            const query = searchQuery.toLowerCase();
            const fullName = `${app.first_name || ''} ${app.middle_name || ''} ${app.last_name || ''}`.toLowerCase();
            const matchesSearch = !searchQuery || 
                fullName.includes(query) || 
                (app.email && app.email.toLowerCase().includes(query)) ||
                (app.phone && app.phone.toString().includes(query));
            
            // Updated job title filter - use job_titles array
            const matchesJobTitle = !filterJobTitle || 
                (app.job_titles && app.job_titles.some(title => 
                    title.toLowerCase().includes(filterJobTitle.toLowerCase())
                ));
            
            const matchesLocation = !filterLocation || 
                (app.location && app.location.toLowerCase().includes(filterLocation.toLowerCase()));
            
            return matchesSearch && matchesJobTitle && matchesLocation;
        });
    }, [tabFilteredApplications, searchQuery, filterJobTitle, filterLocation]);

    const currentRecords = filteredApplications.slice((currentPage - 1) * recordsPerPage, currentPage * recordsPerPage);
    const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

    // Get unique job titles for filter dropdown
    const uniqueJobTitles = useMemo(() => {
        const titles = new Set();
        applicationList.forEach(app => {
            // Use the job_titles array from the API
            if (app.job_titles && Array.isArray(app.job_titles)) {
                app.job_titles.forEach(title => {
                    if (title) titles.add(title);
                });
            }
        });
        return Array.from(titles).sort();
    }, [applicationList]);

    // Debug logging
    useEffect(() => {
        console.log("Current tab:", activeTab);
        console.log("Total applicants:", applicationList.length);
        console.log("Tab filtered:", tabFilteredApplications.length);
        console.log("Search filtered:", filteredApplications.length);
        console.log("Current page records:", currentRecords.length);
    }, [activeTab, applicationList, tabFilteredApplications, filteredApplications, currentRecords]);

    return (
        <>
            <DashNavbar />
            <div className="wrapper">
                <Sidebar />
                <main className="main p-3">
                    <div className="container-fluid">
                        {successMessage && <Alert variant="success" className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1056, top: '60px' }}>{successMessage}</Alert>}
                        <Card className="shadow-sm mb-4">
                            <Card.Header className="bg-light p-3">
                                <h1 className="h4 gradient-text mb-0">Applicant Management</h1>
                                <small className="text-muted">
                                    Showing {filteredApplications.length} of {applicationList.length} total applicants
                                </small>
                            </Card.Header>
                            <Card.Body className="p-3">
                                <ul className="nav nav-pills mb-3">
                                    {['Job_Opening', 'Business_Opportunity', 'Technical_Consultant'].map(tab => (
                                        <li key={tab} className="nav-item me-2">
                                            <button 
                                                className={`nav-link ${activeTab === tab ? 'active' : ''}`} 
                                                onClick={() => { 
                                                    setActiveTab(tab); 
                                                    setCurrentPage(1); 
                                                    console.log("Switched to tab:", tab);
                                                }}
                                            >
                                                {tab.replace('_', ' ')}
                                                <Badge bg="secondary" className="ms-2">
                                                    {applicationList.filter(app => {
                                                        const results = app.action?.personality_results || [];
                                                        return results.some(result => {
                                                            const tabMapping = {
                                                                'Job_Opening': 'Job_Opening',
                                                                'Business_Opportunity': 'Business_Opportunity',
                                                                'Technical_Consultant': 'Technical_Consultant'
                                                            };
                                                            return result.opening_post && tabMapping[result.opening_post] === tab;
                                                        });
                                                    }).length}
                                                </Badge>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                                <Row className="g-2 mb-3">
                                    <Col md={3}>
                                        <InputGroup size="sm">
                                            <InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text>
                                            <Form.Control 
                                                placeholder="Search by name, email, phone..." 
                                                value={searchQuery} 
                                                onChange={(e) => setSearchQuery(e.target.value)} 
                                            />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Select size="sm" value={filterJobTitle} onChange={(e) => setFilterJobTitle(e.target.value)}>
                                            <option value="">All Job Titles</option>
                                            {uniqueJobTitles.map((title, index) => (
                                                <option key={index} value={title}>{title}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col md={3}>
                                        <InputGroup size="sm">
                                            <InputGroup.Text><i className="fas fa-map-marker-alt"></i></InputGroup.Text>
                                            <Form.Control 
                                                placeholder="Filter by location..." 
                                                value={filterLocation} 
                                                onChange={(e) => setFilterLocation(e.target.value)} 
                                            />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3} className="d-flex align-items-center">
                                        <Button 
                                            variant="outline-secondary" 
                                            size="sm" 
                                            onClick={fetchApplicants}
                                            title="Refresh data"
                                        >
                                            <i className="fas fa-sync-alt"></i>
                                        </Button>
                                    </Col>
                                </Row>
                                <div className="table-responsive">
                                    <Table striped bordered hover size="sm" className="align-middle">
                                        <thead className="table-dark">
                                            <tr>
                                                <th>Sr.</th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Email</th>
                                                <th>Phone</th>
                                                <th>Applied Date</th>
                                                <th>Location</th>
                                                <th className="text-center">Resume</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading ? (
                                                <tr>
                                                    <td colSpan="9" className="text-center p-4">
                                                        <Spinner animation="border" variant="primary" />
                                                        <p className="mt-2">Loading applicants...</p>
                                                    </td>
                                                </tr>
                                            ) : error ? (
                                                <tr>
                                                    <td colSpan="9" className="text-center p-4 text-danger">
                                                        {error}
                                                    </td>
                                                </tr>
                                            ) : currentRecords.length === 0 ? (
                                                <tr>
                                                    <td colSpan="9" className="text-center p-4 text-muted">
                                                        No applicants found for the selected filters.
                                                    </td>
                                                </tr>
                                            ) : (
                                                currentRecords.map((app, index) => (
                                                    <tr key={app.id || index}>
                                                        <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                                        <td>{app.first_name || 'N/A'}</td>
                                                        <td>{app.last_name || 'N/A'}</td>
                                                        <td>{app.email || 'N/A'}</td>
                                                        <td>{app.phone || 'N/A'}</td>
                                                        <td>{formatDate(app.applied_date)}</td>
                                                        <td>{app.location || 'N/A'}</td>
                                                        <td className="text-center">
                                                            {app.resume ? (
                                                                <Button 
                                                                    variant="link" 
                                                                    size="sm"
                                                                    onClick={() => handleDownloadResume(app.id, app.resume)}
                                                                    title="Download Resume"
                                                                >
                                                                    <i className="fas fa-download text-primary"></i>
                                                                </Button>
                                                            ) : '-'}
                                                        </td>
                                                        <td className="text-center">
                                                            {/* Assessment Action - Show only if applicant has personality results */}
                                                            {app.action?.personality_results?.some(result => result.quiz_taken) ? (
                                                                <Button 
                                                                    variant="info" 
                                                                    size="sm" 
                                                                    className="me-2" 
                                                                    onClick={() => handleViewDetails(app)}
                                                                    title="View Assessment Results"
                                                                >
                                                                    <i className="fas fa-clipboard-check"></i>
                                                                </Button>
                                                            ) : (
                                                                <Button 
                                                                    variant="outline-info" 
                                                                    size="sm" 
                                                                    className="me-2" 
                                                                    disabled
                                                                    title="No assessment taken"
                                                                >
                                                                    <i className="fas fa-clipboard-check"></i>
                                                                </Button>
                                                            )}
                                                            {/* Profile Detail Action */}
                                                            <Button 
                                                                variant="secondary" 
                                                                size="sm" 
                                                                onClick={() => handleViewApplicantDetails(app.id)}
                                                                title="View Profile Details"
                                                            >
                                                                <i className="fas fa-user"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="d-flex justify-content-between mt-3">
                                    <div>
                                        <Form.Select 
                                            size="sm" 
                                            style={{ width: 'auto' }} 
                                            value={recordsPerPage} 
                                            onChange={e => setRecordsPerPage(Number(e.target.value))}
                                        >
                                            <option value="10">10 per page</option>
                                            <option value="20">20 per page</option>
                                            <option value="50">50 per page</option>
                                        </Form.Select>
                                    </div>
                                    <div>
                                        <span className="me-3 align-middle">
                                            Showing {Math.min(currentRecords.length, recordsPerPage)} of {filteredApplications.length} applicants
                                        </span>
                                        {Array.from({ length: totalPages }, (_, i) => (
                                            <Button 
                                                key={i} 
                                                size="sm" 
                                                variant={currentPage === i + 1 ? "primary" : "outline-primary"} 
                                                className="ms-1" 
                                                onClick={() => setCurrentPage(i + 1)}
                                            >
                                                {i + 1}
                                            </Button>
                                        ))}
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>

                    {/* Modals */}
                    {showModal && (
                        <ApplicantModal 
                            applicant={selectedApplicant} 
                            jobapplications={jobapplications} 
                            setSuccessMessage={setSuccessMessage} 
                            updateJobApplication={(id, status) => setApplicationList(prev => prev.map(a => a.id === id ? { ...a, job_status: status } : a))} 
                            personalityResults={selectedApplicant?.action?.personality_results} 
                            onStatusUpdate={fetchApplicants}
                        />
                    )}
                    
                    <ApplicantDetailsModal 
                        show={showDetailsModal} 
                        onHide={() => setShowDetailsModal(false)} 
                        applicant={selectedApplicantDetails} 
                        isLoading={isDetailsLoading} 
                    />
                </main>
            </div>
        </>
    );
}






// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css";
// import Sidebar from "../Misc/Sidebar";
// import DashNavbar from "../Misc/DashNavbar";
// import { Table, Alert, Modal, Button, Card, Spinner, Form, InputGroup } from "react-bootstrap";
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "./ApplicantDetailsModal";

// const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" },
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
// ];

// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
//     personalityResults,
// }) => {
//     const [show, setShow] = useState(false);
//     const [personalityData, setPersonalityData] = useState([]);
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
//     const chartRefs = useRef({});
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
//     const [currentJobId, setCurrentJobId] = useState(null);
//     const [jobQuestions, setJobQuestions] = useState([]);
//     const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);

//     const handleStatusChange = (jobApplicationId, newStatus) => {
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${jobApplicationId}/`, { job_status: newStatus })
//             .then(() => {
//                 setSuccessMessage("Job status updated successfully");
//                 updateJobApplication(jobApplicationId, newStatus);
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error);
//             });
//     };

//     useEffect(() => {
//         setShow(false);
//         const timer = setTimeout(() => {
//             if (applicant && jobapplications) {
//                 setShow(true);
//             }
//         }, 100);

//         return () => {
//             clearTimeout(timer);
//             Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//         };
//     }, [applicant, jobapplications]);

//     useEffect(() => {
//         if (personalityResults) {
//             const processedResults = personalityResults.map(res => ({
//                 ...res,
//                 job_id: res.object_id,
//             }));
//             setPersonalityData(processedResults);
//         } else if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant, personalityResults]);

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
//             const personalityResponse = await axios.get(personalityUrl);
//             const data = Array.isArray(personalityResponse.data) ? personalityResponse.data : [];
//             const processed = data.map(res => ({ ...res, job_id: res.object_id }));
//             setPersonalityData(processed);
//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//             setPersonalityData([]);
//         }
//     };

//     useEffect(() => {
//         if (personalityData.length > 0 && applicant?.id) {
//             const fetchJobTitles = async () => {
//                 try {
//                     const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`;
//                     const jobTitleResponse = await axios.get(jobTitleUrl);
//                     const jobTitlesMap = (jobTitleResponse.data || []).reduce((acc, job) => {
//                         if (job.job_id) acc[job.job_id] = job.job_title;
//                         return acc;
//                     }, {});
//                     const titles = personalityData.map(data => jobTitlesMap[data.job_id] || data.job_title || `ID: ${data.job_id}`);
//                     setPersonalityJobTitles(titles);
//                 } catch (error) {
//                     setPersonalityJobTitles(personalityData.map(data => data.job_title || `ID: ${data.job_id}`));
//                 }
//             };
//             fetchJobTitles();
//         } else {
//             setPersonalityJobTitles([]);
//         }
//     }, [personalityData, applicant?.id]);

//     useEffect(() => {
//         const createdCharts = {};
//         if (Array.isArray(personalityData)) {
//             personalityData.forEach((data, index) => {
//                 const chartId = `personalityChart-${applicant?.id}-${index}`;
//                 const chartElement = document.getElementById(chartId);
//                 if (chartElement && data && data.job_id) {
//                     const newChart = createDonutChart(data, chartId);
//                     if (newChart) createdCharts[index] = newChart;
//                 }
//             });
//         }
//         chartRefs.current = createdCharts;

//         return () => {
//             Object.values(createdCharts).forEach(chart => chart.destroy());
//         };
//     }, [personalityData, applicant?.id]);

//     const onHide = () => setShow(false);

//     const createDonutChart = (data, chartId) => {
//         if (!data || typeof data.correct_count !== 'number' || typeof data.wrong_count !== 'number') {
//             return null;
//         }
//         const { correct_count, wrong_count } = data;
//         const ctx = document.getElementById(chartId)?.getContext("2d");
//         if (!ctx) return null;

//         return new Chart(ctx, {
//             type: 'doughnut', data: {
//                 labels: [`Correct (${correct_count})`, `Wrong (${wrong_count})`],
//                 datasets: [{ data: [correct_count, wrong_count], backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'], borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'], borderWidth: 1 }]
//             }, options: {
//                 responsive: true, maintainAspectRatio: false, cutout: '60%', plugins: {
//                     legend: { display: true, position: 'bottom', labels: { boxWidth: 10, padding: 15, font: { size: 10 } } },
//                     tooltip: {
//                         callbacks: {
//                             label: function (context) {
//                                 const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                                 const percentage = total > 0 ? ((context.parsed / total) * 100).toFixed(1) + '%' : '0%';
//                                 return `${context.label}: ${context.parsed} (${percentage})`;
//                             }
//                         }
//                     }
//                 }
//             }
//         });
//     };

//     const handleShowSubmittedAnswers = async (applicantId, numericId, postingType) => {
//         setCurrentJobId(numericId);
//         setIsLoadingAnswers(true);
//         setJobQuestions([]);
        
//         const specificResult = personalityData.find(item => item.job_id === numericId);
//         setFilteredSubmittedAnswers(specificResult || null);

//         const type = postingType || "Job_Opening";
//         const formattedIdNum = String(numericId).padStart(3, '0');
//         let formattedPathId = "";

//         if (type === "Business_Opportunity") {
//             formattedPathId = `business-${formattedIdNum}`;
//         } else if (type === "Job_Opening") {
//             formattedPathId = `job-${formattedIdNum}`;
//         } else if (type === "Technical_Consultant") {
//             formattedPathId = `consultant-${formattedIdNum}`;
//         } else {
//             formattedPathId = formattedIdNum;
//         }
        
//         try {
//             const questionResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${type}/${formattedPathId}/`);
//             setJobQuestions(questionResponse.data?.questions || []);
//         } catch (error) {
//             console.error("Error fetching questions:", error);
//             setJobQuestions([]);
//         } finally {
//             setIsLoadingAnswers(false);
//         }
//     };

//     return (
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
//             <Modal.Header closeButton>
//                 <Modal.Title className="gradient-text">{applicant?.first_name || applicant?.email || 'Applicant'} Details</Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-4">
//                 <Card className="mb-4 shadow-sm">
//                     <Card.Header className="bg-light"><h5 className="mb-0">Job Applications</h5></Card.Header>
//                     <Card.Body className="p-0">
//                         <Table striped bordered hover responsive size="sm" className="mb-0">
//                             <thead className="table-light">
//                                 <tr>
//                                     <th style={{ width: '40%' }}>Job Title</th>
//                                     <th style={{ width: '40%' }}>Status</th>
//                                     <th style={{ width: '20%' }}>Applied On</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobapplications && jobapplications.length > 0 ? (
//                                     jobapplications.map((jobApp) => {
//                                         const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
//                                         return (
//                                             <tr key={jobApp.id}>
//                                                 <td>{jobApp.job_title || 'N/A'}</td>
//                                                 <td>
//                                                     <Form.Select
//                                                         size="sm"
//                                                         className={`${statusOption?.bgColor || 'bg-light'}`}
//                                                         value={jobApp.job_status || 'applied'}
//                                                         onChange={(e) => handleStatusChange(jobApp.id, e.target.value)}
//                                                         style={{
//                                                             color: statusOption?.bgColor.includes('text-dark') ? '#212529' : '#fff',
//                                                             fontWeight: 500
//                                                         }}
//                                                     >
//                                                         {jobStatusOptions.map((option) => (
//                                                             <option key={option.value} value={option.value} style={{ backgroundColor: '#fff', color: '#000' }}>
//                                                                 {option.label}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </td>
//                                                 <td>{jobApp.applied_date ? new Date(jobApp.applied_date).toLocaleDateString() : 'N/A'}</td>
//                                             </tr>
//                                         );
//                                     })
//                                 ) : personalityResults && personalityResults.length > 0 ? (
//                                     personalityResults.map((result, index) => (
//                                         <tr key={result.object_id || index}>
//                                             <td>{result.job_title || 'N/A'}</td>
//                                             <td>
//                                                 <span className="badge bg-secondary">Status N/A</span>
//                                             </td>
//                                             <td><span className="text-muted">N/A</span></td>
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr><td colSpan="3" className="text-center text-muted p-3">No job applications found.</td></tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                     </Card.Body>
//                 </Card>

//                 <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
//                 <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
//                     {personalityData?.length > 0 ? (
//                         personalityData.map((data, index) => (
//                             data?.job_id ? (
//                                 <Card key={`${data.job_id}-${index}`} className="text-center shadow-sm" style={{ minWidth: '260px', flex: '1 1 260px' }}>
//                                     <Card.Header className="bg-light">
//                                         <Card.Title as="h6" className="mb-0 text-truncate">{personalityJobTitles[index] || `Assessment ID: ${data.job_title}`}</Card.Title>
//                                     </Card.Header>
//                                     <Card.Body className="d-flex flex-column p-2">
//                                         <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}>
//                                             <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
//                                         </div>
//                                         <div className="mt-auto">
//                                             <p className="mb-1"><strong>Score:</strong> <b className="gradient-text">{typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}</b></p>
//                                             <p className="mb-2"><strong>Result:</strong> {data.result === 'T' || data.result === 'A' ? <span className="badge bg-success">Passed</span> : <span className="badge bg-danger">Failed</span>}</p>
//                                             <Button variant="outline-info" size="sm" onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id, data.opening_post)} disabled={isLoadingAnswers && currentJobId === data.job_id}>
//                                                 {isLoadingAnswers && currentJobId === data.job_id ? <Spinner as="span" animation="border" size="sm" /> : <i className="fas fa-receipt me-1"></i>} View Answers
//                                             </Button>
//                                         </div>
//                                     </Card.Body>
//                                 </Card>
//                             ) : null
//                         ))
//                     ) : (
//                         <p className="text-center text-muted w-100">No personality assessment data available.</p>
//                     )}
//                 </div>

//                 {currentJobId && (
//                     <div className="mt-4">
//                         <Card className="shadow-sm">
//                             <Card.Header className="bg-light d-flex justify-content-between align-items-center">
//                                 <h5 className="mb-0">Submitted Answers for: {personalityJobTitles[personalityData.findIndex(p => p.job_id === currentJobId)] || `ID ${currentJobId}`}</h5>
//                                 <Button variant="close" onClick={() => setCurrentJobId(null)}></Button>
//                             </Card.Header>
//                             <Card.Body>
//                                 {isLoadingAnswers ? (
//                                     <div className="text-center p-4"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0">Loading answers...</p></div>
//                                 ) : filteredSubmittedAnswers && jobQuestions?.length > 0 ? (
//                                     <Table striped bordered hover responsive size="sm">
//                                         <thead className="table-light">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>#</th>
//                                                 <th style={{ width: '40%' }}>Question</th>
//                                                 <th style={{ width: '40%' }}>Options & Choices</th>
//                                                 <th style={{ width: '15%' }} className="text-center">Overall Result</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {jobQuestions.map((question, index) => {
//                                                 const answerKey = `Q${index + 1}`;
//                                                 const statusResult = filteredSubmittedAnswers.selected_answers?.[answerKey];
//                                                 const userChoiceIndex = filteredSubmittedAnswers.user_responses?.[answerKey];
                                                
//                                                 return (
//                                                     <tr key={question.id || index}>
//                                                         <td className="text-muted">{index + 1}</td>
//                                                         <td className="small fw-bold">{question.question_text}</td>
//                                                         <td>
//                                                             <ul className="list-unstyled mb-0 small">
//                                                                 {question.answers && question.answers.map((ans, ansIdx) => {
//                                                                     const isCorrectAns = ansIdx === question.correct_answer_index;
//                                                                     const isUserChoice = userChoiceIndex !== undefined ? ansIdx === userChoiceIndex : false;
                                                                    
//                                                                     let textColor = "";
//                                                                     let icon = null;

//                                                                     if (isCorrectAns) {
//                                                                         textColor = "text-success fw-bold";
//                                                                         icon = <i className="fas fa-check-circle me-1"></i>;
//                                                                     } else if (isUserChoice && statusResult === 'wrong') {
//                                                                         textColor = "text-danger fw-bold";
//                                                                         icon = <i className="fas fa-times-circle me-1"></i>;
//                                                                     }

//                                                                     return (
//                                                                         <li key={ansIdx} className={`${textColor} mb-1 p-1 rounded ${isUserChoice ? 'bg-light border' : ''}`}>
//                                                                             {icon} {ans}
//                                                                         </li>
//                                                                     );
//                                                                 })}
//                                                             </ul>
//                                                         </td>
//                                                         <td className="text-center align-middle">
//                                                             {statusResult === 'correct' ? 
//                                                                 <span className="badge bg-success px-3 py-2">Correct</span> : 
//                                                                 (statusResult === 'wrong' ? 
//                                                                     <span className="badge bg-danger px-3 py-2">Wrong</span> : 
//                                                                     <span className="badge bg-secondary">N/A</span>
//                                                                 )
//                                                             }
//                                                         </td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </Table>
//                                 ) : (
//                                     <p className="text-center text-muted p-3">Could not load answers for this assessment.</p>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light"><Button variant="secondary" onClick={onHide}>Close</Button></Modal.Footer>
//         </Modal>
//     );
// };

// const handleDownloadResume = async (applicantId, resumeFileName) => {
//     if (!applicantId || !resumeFileName) return;
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, { responseType: "arraybuffer" });
//         const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/octet-stream" });
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         const safeFileName = resumeFileName.replace(/[^a-zA-Z0-9._-]/g, '_');
//         link.setAttribute("download", safeFileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error("Error downloading resume:", error);
//         alert("Failed to download resume.");
//     }
// };

// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([]);
//     const [activeTab, setActiveTab] = useState('Job_Opening');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [recordsPerPage, setRecordsPerPage] = useState(10);
//     const [jobapplications, setJobApplications] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedApplicant, setSelectedApplicant] = useState(null);
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null);
//     const [filterJobTitle, setFilterJobTitle] = useState("");
//     const [filterLocation, setFilterLocation] = useState("");
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);

//     const fetchApplicants = () => {
//         setIsLoading(true);
//         setError(null);
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants_alt/")
//             .then((response) => setApplicationList(response.data || []))
//             .catch((error) => {
//                 console.error("Error fetching applicants list:", error);
//                 setError("Failed to load applicant data. Please try refreshing the page.");
//                 setApplicationList([]);
//             })
//             .finally(() => setIsLoading(false));
//     };

//     useEffect(() => {
//         fetchApplicants();
//     }, []);

//     const updateJobApplicationStatusInList = (jobApplicationId, newStatus) => {
//         setJobApplications(prevApps =>
//             prevApps.map(app =>
//                 app.id === jobApplicationId ? { ...app, job_status: newStatus } : app
//             )
//         );
//     };

//     const tabFilteredApplications = useMemo(() => {
//         return applicationList.filter(app => {
//             const primaryType = app.job_opening || app.action?.personality_results?.[0]?.opening_post || 'Job_Opening';
//             return primaryType === activeTab;
//         });
//     }, [applicationList, activeTab]);

//     const filteredApplications = useMemo(() => {
//         return tabFilteredApplications.filter((application) => {
//             if (!application) return false;
//             const lowerCaseQuery = searchQuery.toLowerCase();
//             const matchesSearch = !searchQuery ||
//                 `${application.first_name} ${application.middle_name} ${application.last_name} ${application.email}`.toLowerCase().includes(lowerCaseQuery);
//             const matchesJobTitle = !filterJobTitle ||
//                 application.action?.personality_results?.some(res => res.job_title?.toLowerCase().includes(filterJobTitle.toLowerCase()));
//             const matchesLocation = !filterLocation ||
//                 application.location?.toLowerCase().includes(filterLocation.toLowerCase());
//             return matchesSearch && matchesJobTitle && matchesLocation;
//         });
//     }, [tabFilteredApplications, searchQuery, filterJobTitle, filterLocation]);

//     const currentRecords = useMemo(() => {
//         const indexOfLastRecord = currentPage * recordsPerPage;
//         const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//         return filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
//     }, [filteredApplications, currentPage, recordsPerPage]);

//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     const handlePageChange = (page) => setCurrentPage(page);

//     const handleRecordsPerPageChange = (e) => {
//         setRecordsPerPage(Number(e.target.value));
//         setCurrentPage(1);
//     };

//     const handleViewDetails = async (applicant) => {
//         setSelectedApplicant(applicant);
//         setJobApplications([]);
//         setShowModal(true);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//             setJobApplications(response.data || []);
//         } catch (error) {
//             console.error(`Error fetching job apps for ${applicant.id}:`, error);
//         }
//     };

//     const handleViewApplicantDetails = async (applicantId) => {
//         setShowDetailsModal(true);
//         setSelectedApplicantDetails(null);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//             setSelectedApplicantDetails(response.data);
//         } catch (error) {
//             console.error("Error fetching applicant details:", error);
//             setError("Could not fetch full applicant details.");
//         }
//     };

//     const uniqueJobTitles = useMemo(() => {
//         const titles = tabFilteredApplications.flatMap(app => app.action?.personality_results?.map(res => res.job_title).filter(Boolean) || []);
//         return [...new Set(titles)].sort();
//     }, [tabFilteredApplications]);

//     const uniqueLocations = useMemo(() => {
//         const locations = tabFilteredApplications.map(app => app.location).filter(Boolean);
//         return [...new Set(locations)].sort();
//     }, [tabFilteredApplications]);

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <main className="main p-3">
//                     <div className="container-fluid">
//                         {successMessage && <Alert variant="success" onClose={() => setSuccessMessage("")} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1056, top: '60px' }}><i className="fas fa-check-circle me-2"></i>{successMessage}</Alert>}
//                         {error && <Alert variant="danger" onClose={() => setError(null)} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1055, top: '60px' }}><i className="fas fa-exclamation-triangle me-2"></i> {error}</Alert>}

//                         <Card className="shadow-sm mb-4">
//                             <Card.Header className="bg-light p-3"><h1 className="h4 gradient-text mb-0">Applicant Management</h1></Card.Header>
//                             <Card.Body className="p-3">
//                                 <ul className="nav nav-pills mb-3">
//                                     <li className="nav-item"><button type="button" className={`nav-link ${activeTab === 'Job_Opening' ? 'active' : ''}`} onClick={() => { setActiveTab('Job_Opening'); setCurrentPage(1); }}>Jobs</button></li>
//                                     <li className="nav-item ms-2"><button type="button" className={`nav-link ${activeTab === 'Business_Opportunity' ? 'active' : ''}`} onClick={() => { setActiveTab('Business_Opportunity'); setCurrentPage(1); }}>Business</button></li>
//                                     <li className="nav-item ms-2"><button type="button" className={`nav-link ${activeTab === 'Technical_Consultant' ? 'active' : ''}`} onClick={() => { setActiveTab('Technical_Consultant'); setCurrentPage(1); }}>Consultants</button></li>
//                                 </ul>
//                                 <div className="row g-2 mb-3 align-items-center">
//                                     <div className="col-md-3"><InputGroup size="sm"><InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text><Form.Control type="search" placeholder="Search..." value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }} /></InputGroup></div>
//                                     <div className="col-md-2 col-6"><Form.Select size="sm" value={filterJobTitle} onChange={(e) => { setFilterJobTitle(e.target.value); setCurrentPage(1); }}><option value="">All Job Titles</option>{uniqueJobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}</Form.Select></div>
//                                     <div className="col-md-2 col-6"><Form.Select size="sm" value={filterLocation} onChange={(e) => { setFilterLocation(e.target.value); setCurrentPage(1); }}><option value="">All Locations</option>{uniqueLocations.map((loc) => (<option key={loc} value={loc}>{loc}</option>))}</Form.Select></div>
//                                     <div className="col-md-3 col-6 text-md-end"><Button variant="outline-secondary" size="sm" onClick={() => { setSearchQuery(''); setFilterJobTitle(''); setFilterLocation(''); setCurrentPage(1); }}><i className="fas fa-undo me-1"></i> Reset</Button></div>
//                                 </div>
//                                 <div className="table-responsive">
//                                     <Table striped bordered hover size="sm" className="align-middle">
//                                         <thead className="table-dark">
//                                             <tr>
//                                                 <th>Sr. No.</th><th>First Name</th><th>Middle Name</th><th>Last Name</th><th>Email</th><th>Phone</th><th>Location</th><th className="text-center">Resume</th><th className="text-center">Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {isLoading ? (
//                                                 <tr><td colSpan="9" className="text-center p-5"><Spinner animation="border" /><p className="mt-2 mb-0">Loading...</p></td></tr>
//                                             ) : currentRecords.length > 0 ? (
//                                                 currentRecords.map((app, index) => (
//                                                     <tr key={app.id}>
//                                                         <td>{app.sr_no || (currentPage - 1) * recordsPerPage + index + 1}</td>
//                                                         <td>{app.first_name || '-'}</td><td>{app.middle_name || ''}</td><td>{app.last_name || '-'}</td>
//                                                         <td>{app.email || '-'}</td><td>{app.phone || '-'}</td><td>{app.location || '-'}</td>
//                                                         <td className="text-center">{app.resume ? <Button variant="outline-primary" size="sm" className="p-1" onClick={() => handleDownloadResume(app.id, app.resume)}><i className="fas fa-download fa-fw"></i></Button> : <span className="text-muted small">N/A</span>}</td>
//                                                         <td className="text-center">
//                                                             <Button variant="info" size="sm" className="me-2 p-2" onClick={() => handleViewDetails(app)}><i className="fas fa-clipboard-check fa-fw"></i></Button>
//                                                             <Button variant="secondary" size="sm" className="p-2" onClick={() => handleViewApplicantDetails(app.id)}><i className="fas fa-user fa-fw"></i></Button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr><td colSpan="9" className="text-center text-muted p-4">No applicants match the current filters.</td></tr>
//                                             )}
//                                         </tbody>
//                                     </Table>
//                                 </div>
//                                 {filteredApplications.length > 0 && !isLoading && (
//                                     <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-3">
//                                         <div className="d-flex align-items-center"><span className="me-2 small text-muted">Show</span><Form.Select size="sm" style={{ width: 'auto' }} value={recordsPerPage} onChange={handleRecordsPerPageChange}><option value="10">10</option><option value="20">20</option><option value="50">50</option><option value="100">100</option></Form.Select><span className="ms-2 small text-muted">entries</span></div>
//                                         {totalPages > 1 && (<div className="d-flex justify-content-end flex-wrap"><Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>« Prev</Button>{[...Array(totalPages).keys()].map((p) => (<Button key={p + 1} variant={currentPage === p + 1 ? "primary" : "outline-primary"} size="sm" className="mx-1" onClick={() => handlePageChange(p + 1)}>{p + 1}</Button>))}<Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next »</Button></div>)}
//                                     </div>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>

//                     {showModal && <ApplicantModal applicant={selectedApplicant} jobapplications={jobapplications} setSuccessMessage={setSuccessMessage} updateJobApplication={updateJobApplicationStatusInList} personalityResults={selectedApplicant.action?.personality_results} key={`modal-${selectedApplicant.id}`} />}
//                     {showDetailsModal && <ApplicantDetailsModal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} applicant={selectedApplicantDetails} isLoading={!selectedApplicantDetails} />}
//                 </main>
//             </div>
//         </>
//     );
// }




// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css";
// import Sidebar from "../Misc/Sidebar";
// import DashNavbar from "../Misc/DashNavbar";
// import { Table, Alert, Modal, Button, Card, Spinner, Form, InputGroup } from "react-bootstrap";
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "./ApplicantDetailsModal";

// const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" },
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
// ];

// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
//     personalityResults,
// }) => {
//     const [show, setShow] = useState(false);
//     const [personalityData, setPersonalityData] = useState([]);
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
//     const chartRefs = useRef({});
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
//     const [currentJobId, setCurrentJobId] = useState(null);
//     const [jobQuestions, setJobQuestions] = useState([]);
//     const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);

//     const handleStatusChange = (jobApplicationId, newStatus) => {
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${jobApplicationId}/`, { job_status: newStatus })
//             .then(() => {
//                 setSuccessMessage("Job status updated successfully");
//                 updateJobApplication(jobApplicationId, newStatus);
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error);
//             });
//     };

//     useEffect(() => {
//         setShow(false);
//         const timer = setTimeout(() => {
//             if (applicant && jobapplications) {
//                 setShow(true);
//             }
//         }, 100);

//         return () => {
//             clearTimeout(timer);
//             Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//         };
//     }, [applicant, jobapplications]);

//     useEffect(() => {
//         if (personalityResults) {
//             const processedResults = personalityResults.map(res => ({
//                 ...res,
//                 job_id: res.object_id,
//             }));
//             setPersonalityData(processedResults);
//         } else if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant, personalityResults]);

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
//             const personalityResponse = await axios.get(personalityUrl);
//             const data = Array.isArray(personalityResponse.data) ? personalityResponse.data : [];
//             const processed = data.map(res => ({ ...res, job_id: res.object_id }));
//             setPersonalityData(processed);
//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//             setPersonalityData([]);
//         }
//     };

//     useEffect(() => {
//         if (personalityData.length > 0 && applicant?.id) {
//             const fetchJobTitles = async () => {
//                 try {
//                     const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`;
//                     const jobTitleResponse = await axios.get(jobTitleUrl);
//                     const jobTitlesMap = (jobTitleResponse.data || []).reduce((acc, job) => {
//                         if (job.job_id) acc[job.job_id] = job.job_title;
//                         return acc;
//                     }, {});
//                     const titles = personalityData.map(data => jobTitlesMap[data.job_id] || data.job_title || `ID: ${data.job_id}`);
//                     setPersonalityJobTitles(titles);
//                 } catch (error) {
//                     setPersonalityJobTitles(personalityData.map(data => data.job_title || `ID: ${data.job_id}`));
//                 }
//             };
//             fetchJobTitles();
//         } else {
//             setPersonalityJobTitles([]);
//         }
//     }, [personalityData, applicant?.id]);

//     useEffect(() => {
//         const createdCharts = {};
//         if (Array.isArray(personalityData)) {
//             personalityData.forEach((data, index) => {
//                 const chartId = `personalityChart-${applicant?.id}-${index}`;
//                 const chartElement = document.getElementById(chartId);
//                 if (chartElement && data && data.job_id) {
//                     const newChart = createDonutChart(data, chartId);
//                     if (newChart) createdCharts[index] = newChart;
//                 }
//             });
//         }
//         chartRefs.current = createdCharts;

//         return () => {
//             Object.values(createdCharts).forEach(chart => chart.destroy());
//         };
//     }, [personalityData, applicant?.id]);

//     const onHide = () => setShow(false);

//     const createDonutChart = (data, chartId) => {
//         if (!data || typeof data.correct_count !== 'number' || typeof data.wrong_count !== 'number') {
//             return null;
//         }
//         const { correct_count, wrong_count } = data;
//         const ctx = document.getElementById(chartId)?.getContext("2d");
//         if (!ctx) return null;

//         return new Chart(ctx, {
//             type: 'doughnut', data: {
//                 labels: [`Correct (${correct_count})`, `Wrong (${wrong_count})`],
//                 datasets: [{ data: [correct_count, wrong_count], backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'], borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'], borderWidth: 1 }]
//             }, options: {
//                 responsive: true, maintainAspectRatio: false, cutout: '60%', plugins: {
//                     legend: { display: true, position: 'bottom', labels: { boxWidth: 10, padding: 15, font: { size: 10 } } },
//                     tooltip: {
//                         callbacks: {
//                             label: function (context) {
//                                 const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                                 const percentage = total > 0 ? ((context.parsed / total) * 100).toFixed(1) + '%' : '0%';
//                                 return `${context.label}: ${context.parsed} (${percentage})`;
//                             }
//                         }
//                     }
//                 }
//             }
//         });
//     };

//     const handleShowSubmittedAnswers = async (applicantId, numericId, postingType) => {
//         setCurrentJobId(numericId);
//         setIsLoadingAnswers(true);
//         setJobQuestions([]);
        
//         const specificResult = personalityData.find(item => item.job_id === numericId);
//         setFilteredSubmittedAnswers(specificResult || null);

//         const type = postingType || "Job_Opening";
//         const formattedIdNum = String(numericId).padStart(3, '0');
//         let formattedPathId = "";

//         if (type === "Business_Opportunity") {
//             formattedPathId = `business-${formattedIdNum}`;
//         } else if (type === "Job_Opening") {
//             formattedPathId = `job-${formattedIdNum}`;
//         } else if (type === "Technical_Consultant") {
//             formattedPathId = `consultant-${formattedIdNum}`;
//         } else {
//             formattedPathId = formattedIdNum;
//         }
        
//         try {
//             const questionResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${type}/${formattedPathId}/`);
//             setJobQuestions(questionResponse.data?.questions || []);
//         } catch (error) {
//             console.error("Error fetching questions:", error);
//             setJobQuestions([]);
//         } finally {
//             setIsLoadingAnswers(false);
//         }
//     };

//     return (
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
//             <Modal.Header closeButton>
//                 <Modal.Title className="gradient-text">{applicant?.first_name || applicant?.email || 'Applicant'} Details</Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-4">
//                 <Card className="mb-4 shadow-sm">
//                     <Card.Header className="bg-light"><h5 className="mb-0">Job Applications</h5></Card.Header>
//                     <Card.Body className="p-0">
//                         <Table striped bordered hover responsive size="sm" className="mb-0">
//                             <thead className="table-light">
//                                 <tr>
//                                     <th style={{ width: '40%' }}>Job Title</th>
//                                     <th style={{ width: '40%' }}>Status</th>
//                                     <th style={{ width: '20%' }}>Applied On</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobapplications && jobapplications.length > 0 ? (
//                                     jobapplications.map((jobApp) => {
//                                         const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
//                                         return (
//                                             <tr key={jobApp.id}>
//                                                 <td>{jobApp.job_title || 'N/A'}</td>
//                                                 <td>
//                                                     <Form.Select
//                                                         size="sm"
//                                                         className={`${statusOption?.bgColor || 'bg-light'}`}
//                                                         value={jobApp.job_status || 'applied'}
//                                                         onChange={(e) => handleStatusChange(jobApp.id, e.target.value)}
//                                                         style={{
//                                                             color: statusOption?.bgColor.includes('text-dark') ? '#212529' : '#fff',
//                                                             fontWeight: 500
//                                                         }}
//                                                     >
//                                                         {jobStatusOptions.map((option) => (
//                                                             <option key={option.value} value={option.value} style={{ backgroundColor: '#fff', color: '#000' }}>
//                                                                 {option.label}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </td>
//                                                 <td>{jobApp.applied_date ? new Date(jobApp.applied_date).toLocaleDateString() : 'N/A'}</td>
//                                             </tr>
//                                         );
//                                     })
//                                 ) : personalityResults && personalityResults.length > 0 ? (
//                                     personalityResults.map((result, index) => (
//                                         <tr key={result.object_id || index}>
//                                             <td>{result.job_title || 'N/A'}</td>
//                                             <td>
//                                                 <span className="badge bg-secondary">Status N/A</span>
//                                             </td>
//                                             <td><span className="text-muted">N/A</span></td>
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr><td colSpan="3" className="text-center text-muted p-3">No job applications found.</td></tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                     </Card.Body>
//                 </Card>

//                 <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
//                 <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
//                     {personalityData?.length > 0 ? (
//                         personalityData.map((data, index) => (
//                             data?.job_id ? (
//                                 <Card key={`${data.job_id}-${index}`} className="text-center shadow-sm" style={{ minWidth: '260px', flex: '1 1 260px' }}>
//                                     <Card.Header className="bg-light">
//                                         <Card.Title as="h6" className="mb-0 text-truncate">{personalityJobTitles[index] || `Assessment ID: ${data.job_title}`}</Card.Title>
//                                     </Card.Header>
//                                     <Card.Body className="d-flex flex-column p-2">
//                                         <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}>
//                                             <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
//                                         </div>
//                                         <div className="mt-auto">
//                                             <p className="mb-1"><strong>Score:</strong> <b className="gradient-text">{typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}</b></p>
//                                             <p className="mb-2"><strong>Result:</strong> {data.result === 'T' || data.result === 'A' ? <span className="badge bg-success">Passed</span> : <span className="badge bg-danger">Failed</span>}</p>
//                                             <Button variant="outline-info" size="sm" onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id, data.opening_post)} disabled={isLoadingAnswers && currentJobId === data.job_id}>
//                                                 {isLoadingAnswers && currentJobId === data.job_id ? <Spinner as="span" animation="border" size="sm" /> : <i className="fas fa-receipt me-1"></i>} View Answers
//                                             </Button>
//                                         </div>
//                                     </Card.Body>
//                                 </Card>
//                             ) : null
//                         ))
//                     ) : (
//                         <p className="text-center text-muted w-100">No personality assessment data available.</p>
//                     )}
//                 </div>

//                 {currentJobId && (
//                     <div className="mt-4">
//                         <Card className="shadow-sm">
//                             <Card.Header className="bg-light"><h5 className="mb-0">Submitted Answers for: {personalityJobTitles[personalityData.findIndex(p => p.job_id === currentJobId)] || `ID ${currentJobId}`}</h5></Card.Header>
//                             <Card.Body>
//                                 {isLoadingAnswers ? (
//                                     <div className="text-center p-4"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0">Loading answers...</p></div>
//                                 ) : filteredSubmittedAnswers && jobQuestions?.length > 0 ? (
//                                     <Table striped bordered hover responsive size="sm">
//                                         <thead className="table-light">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>#</th>
//                                                 <th style={{ width: '65%' }}>Question</th>
//                                                 <th style={{ width: '30%' }} className="text-center">Result</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {jobQuestions.map((question, index) => {
//                                                 const answerKey = `Q${index + 1}`;
//                                                 const result = filteredSubmittedAnswers.selected_answers?.[answerKey];
//                                                 const resultDisplay = result === 'correct' ? <span className="badge bg-success">Correct</span> : (result ? <span className="badge bg-danger">Wrong</span> : <span className="badge bg-secondary">Not Answered</span>);
//                                                 return (
//                                                     <tr key={question.id || index}>
//                                                         <td className="text-muted">{index + 1}</td>
//                                                         <td className="small">{question.question_text}</td>
//                                                         <td className="text-center align-middle">{resultDisplay}</td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </Table>
//                                 ) : (
//                                     <p className="text-center text-muted p-3">Could not load answers for this assessment.</p>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light"><Button variant="secondary" onClick={onHide}>Close</Button></Modal.Footer>
//         </Modal>
//     );
// };

// const handleDownloadResume = async (applicantId, resumeFileName) => {
//     if (!applicantId || !resumeFileName) return;
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, { responseType: "arraybuffer" });
//         const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/octet-stream" });
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         const safeFileName = resumeFileName.replace(/[^a-zA-Z0-9._-]/g, '_');
//         link.setAttribute("download", safeFileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error("Error downloading resume:", error);
//         alert("Failed to download resume.");
//     }
// };

// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([]);
//     const [activeTab, setActiveTab] = useState('Job_Opening');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [recordsPerPage, setRecordsPerPage] = useState(10);
//     const [jobapplications, setJobApplications] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedApplicant, setSelectedApplicant] = useState(null);
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null);
//     const [filterJobTitle, setFilterJobTitle] = useState("");
//     const [filterLocation, setFilterLocation] = useState("");
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);

//     const fetchApplicants = () => {
//         setIsLoading(true);
//         setError(null);
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants_alt/")
//             .then((response) => setApplicationList(response.data || []))
//             .catch((error) => {
//                 console.error("Error fetching applicants list:", error);
//                 setError("Failed to load applicant data. Please try refreshing the page.");
//                 setApplicationList([]);
//             })
//             .finally(() => setIsLoading(false));
//     };

//     useEffect(() => {
//         fetchApplicants();
//     }, []);

//     const updateJobApplicationStatusInList = (jobApplicationId, newStatus) => {
//         setJobApplications(prevApps =>
//             prevApps.map(app =>
//                 app.id === jobApplicationId ? { ...app, job_status: newStatus } : app
//             )
//         );
//     };

//     const tabFilteredApplications = useMemo(() => {
//         return applicationList.filter(app => {
//             const primaryType = app.job_opening || app.action?.personality_results?.[0]?.opening_post || 'Job_Opening';
//             return primaryType === activeTab;
//         });
//     }, [applicationList, activeTab]);

//     const filteredApplications = useMemo(() => {
//         return tabFilteredApplications.filter((application) => {
//             if (!application) return false;
//             const lowerCaseQuery = searchQuery.toLowerCase();
//             const matchesSearch = !searchQuery ||
//                 `${application.first_name} ${application.middle_name} ${application.last_name} ${application.email}`.toLowerCase().includes(lowerCaseQuery);
//             const matchesJobTitle = !filterJobTitle ||
//                 application.action?.personality_results?.some(res => res.job_title?.toLowerCase().includes(filterJobTitle.toLowerCase()));
//             const matchesLocation = !filterLocation ||
//                 application.location?.toLowerCase().includes(filterLocation.toLowerCase());
//             return matchesSearch && matchesJobTitle && matchesLocation;
//         });
//     }, [tabFilteredApplications, searchQuery, filterJobTitle, filterLocation]);

//     const currentRecords = useMemo(() => {
//         const indexOfLastRecord = currentPage * recordsPerPage;
//         const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//         return filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
//     }, [filteredApplications, currentPage, recordsPerPage]);

//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     const handlePageChange = (page) => setCurrentPage(page);

//     const handleRecordsPerPageChange = (e) => {
//         setRecordsPerPage(Number(e.target.value));
//         setCurrentPage(1);
//     };

//     const handleViewDetails = async (applicant) => {
//         setSelectedApplicant(applicant);
//         setJobApplications([]);
//         setShowModal(true);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//             setJobApplications(response.data || []);
//         } catch (error) {
//             console.error(`Error fetching job apps for ${applicant.id}:`, error);
//         }
//     };

//     const handleViewApplicantDetails = async (applicantId) => {
//         setShowDetailsModal(true);
//         setSelectedApplicantDetails(null);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//             setSelectedApplicantDetails(response.data);
//         } catch (error) {
//             console.error("Error fetching applicant details:", error);
//             setError("Could not fetch full applicant details.");
//         }
//     };

//     const uniqueJobTitles = useMemo(() => {
//         const titles = tabFilteredApplications.flatMap(app => app.action?.personality_results?.map(res => res.job_title).filter(Boolean) || []);
//         return [...new Set(titles)].sort();
//     }, [tabFilteredApplications]);

//     const uniqueLocations = useMemo(() => {
//         const locations = tabFilteredApplications.map(app => app.location).filter(Boolean);
//         return [...new Set(locations)].sort();
//     }, [tabFilteredApplications]);

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <main className="main p-3">
//                     <div className="container-fluid">
//                         {successMessage && <Alert variant="success" onClose={() => setSuccessMessage("")} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1056, top: '60px' }}><i className="fas fa-check-circle me-2"></i>{successMessage}</Alert>}
//                         {error && <Alert variant="danger" onClose={() => setError(null)} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1055, top: '60px' }}><i className="fas fa-exclamation-triangle me-2"></i> {error}</Alert>}

//                         <Card className="shadow-sm mb-4">
//                             <Card.Header className="bg-light p-3"><h1 className="h4 gradient-text mb-0">Applicant Management</h1></Card.Header>
//                             <Card.Body className="p-3">
//                                 <ul className="nav nav-pills mb-3">
//                                     <li className="nav-item"><button type="button" className={`nav-link ${activeTab === 'Job_Opening' ? 'active' : ''}`} onClick={() => { setActiveTab('Job_Opening'); setCurrentPage(1); }}>Jobs</button></li>
//                                     <li className="nav-item ms-2"><button type="button" className={`nav-link ${activeTab === 'Business_Opportunity' ? 'active' : ''}`} onClick={() => { setActiveTab('Business_Opportunity'); setCurrentPage(1); }}>Business</button></li>
//                                     <li className="nav-item ms-2"><button type="button" className={`nav-link ${activeTab === 'Technical_Consultant' ? 'active' : ''}`} onClick={() => { setActiveTab('Technical_Consultant'); setCurrentPage(1); }}>Consultants</button></li>
//                                 </ul>
//                                 <div className="row g-2 mb-3 align-items-center">
//                                     <div className="col-md-3"><InputGroup size="sm"><InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text><Form.Control type="search" placeholder="Search..." value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }} /></InputGroup></div>
//                                     <div className="col-md-2 col-6"><Form.Select size="sm" value={filterJobTitle} onChange={(e) => { setFilterJobTitle(e.target.value); setCurrentPage(1); }}><option value="">All Job Titles</option>{uniqueJobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}</Form.Select></div>
//                                     <div className="col-md-2 col-6"><Form.Select size="sm" value={filterLocation} onChange={(e) => { setFilterLocation(e.target.value); setCurrentPage(1); }}><option value="">All Locations</option>{uniqueLocations.map((loc) => (<option key={loc} value={loc}>{loc}</option>))}</Form.Select></div>
//                                     <div className="col-md-3 col-6 text-md-end"><Button variant="outline-secondary" size="sm" onClick={() => { setSearchQuery(''); setFilterJobTitle(''); setFilterLocation(''); setCurrentPage(1); }}><i className="fas fa-undo me-1"></i> Reset</Button></div>
//                                 </div>
//                                 <div className="table-responsive">
//                                     <Table striped bordered hover size="sm" className="align-middle">
//                                         <thead className="table-dark">
//                                             <tr>
//                                                 <th>Sr. No.</th><th>First Name</th><th>Middle Name</th><th>Last Name</th><th>Email</th><th>Phone</th><th>Location</th><th className="text-center">Resume</th><th className="text-center">Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {isLoading ? (
//                                                 <tr><td colSpan="9" className="text-center p-5"><Spinner animation="border" /><p className="mt-2 mb-0">Loading...</p></td></tr>
//                                             ) : currentRecords.length > 0 ? (
//                                                 currentRecords.map((app, index) => (
//                                                     <tr key={app.id}>
//                                                         <td>{app.sr_no || (currentPage - 1) * recordsPerPage + index + 1}</td>
//                                                         <td>{app.first_name || '-'}</td><td>{app.middle_name || ''}</td><td>{app.last_name || '-'}</td>
//                                                         <td>{app.email || '-'}</td><td>{app.phone || '-'}</td><td>{app.location || '-'}</td>
//                                                         <td className="text-center">{app.resume ? <Button variant="outline-primary" size="sm" className="p-1" onClick={() => handleDownloadResume(app.id, app.resume)}><i className="fas fa-download fa-fw"></i></Button> : <span className="text-muted small">N/A</span>}</td>
//                                                         <td className="text-center">
//                                                             <Button variant="info" size="sm" className="me-2 p-2" onClick={() => handleViewDetails(app)}><i className="fas fa-clipboard-check fa-fw"></i></Button>
//                                                             <Button variant="secondary" size="sm" className="p-2" onClick={() => handleViewApplicantDetails(app.id)}><i className="fas fa-user fa-fw"></i></Button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr><td colSpan="9" className="text-center text-muted p-4">No applicants match the current filters.</td></tr>
//                                             )}
//                                         </tbody>
//                                     </Table>
//                                 </div>
//                                 {filteredApplications.length > 0 && !isLoading && (
//                                     <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-3">
//                                         <div className="d-flex align-items-center"><span className="me-2 small text-muted">Show</span><Form.Select size="sm" style={{ width: 'auto' }} value={recordsPerPage} onChange={handleRecordsPerPageChange}><option value="10">10</option><option value="20">20</option><option value="50">50</option><option value="100">100</option></Form.Select><span className="ms-2 small text-muted">entries</span></div>
//                                         {totalPages > 1 && (<div className="d-flex justify-content-end flex-wrap"><Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>« Prev</Button>{[...Array(totalPages).keys()].map((p) => (<Button key={p + 1} variant={currentPage === p + 1 ? "primary" : "outline-primary"} size="sm" className="mx-1" onClick={() => handlePageChange(p + 1)}>{p + 1}</Button>))}<Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next »</Button></div>)}
//                                     </div>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>

//                     {showModal && <ApplicantModal applicant={selectedApplicant} jobapplications={jobapplications} setSuccessMessage={setSuccessMessage} updateJobApplication={updateJobApplicationStatusInList} personalityResults={selectedApplicant.action?.personality_results} key={`modal-${selectedApplicant.id}`} />}
//                     {showDetailsModal && <ApplicantDetailsModal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} applicant={selectedApplicantDetails} isLoading={!selectedApplicantDetails} />}
//                 </main>
//             </div>
//         </>
//     );
// }




// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css"; // Make sure this path is correct
// import Sidebar from "../Misc/Sidebar"; // Make sure this path is correct
// import DashNavbar from "../Misc/DashNavbar"; // Make sure this path is correct
// import { Table, Alert, Modal, Button, Card, Spinner, InputGroup, Form } from "react-bootstrap";
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "./ApplicantDetailsModal"; // Make sure this path is correct

// // --- Define Job Status Options Globally ---
// // This array drives the functionality and appearance of the status dropdown.
// const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" }, // text-dark for light backgrounds
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
// ];

// // --- ApplicantModal Component ---
// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
//     personalityResults,
// }) => {
//     const [show, setShow] = useState(false);
//     const [personalityData, setPersonalityData] = useState([]);
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
//     const chartRefs = useRef({});
//     const [allSubmittedAnswers, setAllSubmittedAnswers] = useState(null);
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
//     const [currentJobId, setCurrentJobId] = useState(null);
//     const [jobQuestions, setJobQuestions] = useState(null);
//     const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);

//     // This function is called when a new status is selected from the dropdown
//     const handleStatusChange = (jobApplicationId, newStatus) => {
//         // Make an API call to persist the status change in the database
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${jobApplicationId}/`, { job_status: newStatus })
//             .then(() => {
//                 setSuccessMessage("Job status updated successfully");
//                 // This function updates the state in the parent component to reflect the change instantly
//                 updateJobApplication(jobApplicationId, newStatus);
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error);
//                 // Optionally, show an error message to the user
//             });
//     };

//     useEffect(() => {
//         setShow(false);
//         const timer = setTimeout(() => {
//             if (applicant && jobapplications) {
//                 setShow(true);
//             }
//         }, 100);

//         return () => {
//             clearTimeout(timer);
//             Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//         };
//     }, [applicant, jobapplications]);

//     useEffect(() => {
//         if (personalityResults) {
//             const processedResults = personalityResults.map(res => ({
//                 ...res,
//                 job_id: res.object_id,
//             }));
//             setPersonalityData(processedResults);
//         } else if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant, personalityResults]);

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
//             const personalityResponse = await axios.get(personalityUrl);
//             setPersonalityData(personalityResponse.data || []);
//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//             setPersonalityData([]);
//         }
//     };

//     useEffect(() => {
//         if (personalityData.length > 0 && applicant?.id) {
//             const fetchJobTitles = async () => {
//                 try {
//                     const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`;
//                     const jobTitleResponse = await axios.get(jobTitleUrl);
//                     const jobTitlesMap = (jobTitleResponse.data || []).reduce((acc, job) => {
//                         if (job.job_id) acc[job.job_id] = job.job_title;
//                         return acc;
//                     }, {});
//                     const titles = personalityData.map(data => jobTitlesMap[data.job_id] || data.job_title || `Job ID: ${data.job_id}`);
//                     setPersonalityJobTitles(titles);
//                 } catch (error) {
//                     setPersonalityJobTitles(personalityData.map(data => data.job_title || `Job ID: ${data.job_id}`));
//                 }
//             };
//             fetchJobTitles();
//         } else {
//             setPersonalityJobTitles([]);
//         }
//     }, [personalityData, applicant?.id]);

//     useEffect(() => {
//         const createdCharts = {};
//         if (Array.isArray(personalityData)) {
//             personalityData.forEach((data, index) => {
//                 const chartId = `personalityChart-${applicant?.id}-${index}`;
//                 const chartElement = document.getElementById(chartId);
//                 if (chartElement && data && data.job_id) {
//                     const newChart = createDonutChart(data, chartId);
//                     if (newChart) createdCharts[index] = newChart;
//                 }
//             });
//         }
//         chartRefs.current = createdCharts;

//         return () => {
//             Object.values(createdCharts).forEach(chart => chart.destroy());
//         };
//     }, [personalityData, applicant?.id]);

//     const onHide = () => setShow(false);

//     const createDonutChart = (data, chartId) => {
//         if (!data || typeof data.correct_count !== 'number' || typeof data.wrong_count !== 'number') {
//             const ctx = document.getElementById(chartId)?.getContext("2d");
//             if (ctx) {
//                 ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
//                 ctx.font = "12px Arial"; ctx.textAlign = "center";
//                 ctx.fillText("Data unavailable", ctx.canvas.width / 2, ctx.canvas.height / 2);
//             }
//             return null;
//         }
//         const { correct_count, wrong_count } = data;
//         const ctx = document.getElementById(chartId)?.getContext("2d");
//         if (!ctx) return null;

//         return new Chart(ctx, {
//             type: 'doughnut', data: {
//                 labels: [`Correct (${correct_count})`, `Wrong (${wrong_count})`],
//                 datasets: [{ data: [correct_count, wrong_count], backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'], borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'], borderWidth: 1 }]
//             }, options: {
//                 responsive: true, maintainAspectRatio: false, cutout: '60%', plugins: {
//                     legend: { display: true, position: 'bottom', labels: { boxWidth: 10, padding: 15, font: { size: 10 } } },
//                     tooltip: {
//                         callbacks: {
//                             label: function (context) {
//                                 const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                                 const percentage = total > 0 ? ((context.parsed / total) * 100).toFixed(1) + '%' : '0%';
//                                 return `${context.label}: ${context.parsed} (${percentage})`;
//                             }
//                         }
//                     }
//                 }
//             }
//         });
//     };

//     const handleShowSubmittedAnswers = async (applicantId, jobId) => {
//         setCurrentJobId(jobId);
//         setIsLoadingAnswers(true);
//         try {
//             const [answersResponse, questionResponse] = await Promise.all([
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`),
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${jobId}/`)
//             ]);
//             setAllSubmittedAnswers(answersResponse.data);
//             setJobQuestions(questionResponse.data || []);
//         } catch (error) {
//             console.error("Error fetching submitted answers or questions:", error);
//         } finally {
//             setIsLoadingAnswers(false);
//         }
//     };

//     useEffect(() => {
//         if (allSubmittedAnswers && currentJobId !== null) {
//             const processedAnswers = allSubmittedAnswers.map(res => ({ ...res, job_id: res.object_id }));
//             const filtered = processedAnswers.find(item => item.job_id === currentJobId);
//             setFilteredSubmittedAnswers(filtered || null);
//         } else {
//             setFilteredSubmittedAnswers(null);
//         }
//     }, [allSubmittedAnswers, currentJobId]);

//     return (
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
//             <Modal.Header closeButton>
//                 <Modal.Title className="gradient-text">{applicant?.first_name || applicant?.email || 'Applicant'} Details</Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-4">
//                 <Card className="mb-4 shadow-sm">
//                     <Card.Header className="bg-light"><h5 className="mb-0">Job Applications</h5></Card.Header>
//                     <Card.Body className="p-0">
//                         <Table striped bordered hover responsive size="sm" className="mb-0">
//                             <thead className="table-light">
//                                 <tr>
//                                     <th style={{ width: '40%' }}>Job Title</th>
//                                     <th style={{ width: '40%' }}>Status</th>
//                                     <th style={{ width: '20%' }}>Applied On</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobapplications && jobapplications.length > 0 ? (
//                                     jobapplications.map((jobApp) => {
//                                         const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
//                                         return (
//                                             <tr key={jobApp.id}>
//                                                 <td>{jobApp.job_title || 'N/A'}</td>
//                                                 <td>
//                                                     <Form.Select
//                                                         size="sm"
//                                                         className={`${statusOption?.bgColor || 'bg-light'}`}
//                                                         value={jobApp.job_status || 'applied'}
//                                                         onChange={(e) => handleStatusChange(jobApp.id, e.target.value)}
//                                                         style={{
//                                                             color: statusOption?.bgColor.includes('text-dark') ? '#212529' : '#fff',
//                                                             fontWeight: 500
//                                                         }}
//                                                     >
//                                                         {jobStatusOptions.map((option) => (
//                                                             <option key={option.value} value={option.value} style={{ backgroundColor: '#fff', color: '#000' }}>
//                                                                 {option.label}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </td>
//                                                 <td>{jobApp.applied_date ? new Date(jobApp.applied_date).toLocaleDateString() : 'N/A'}</td>
//                                             </tr>
//                                         );
//                                     })
//                                 ) : personalityResults && personalityResults.length > 0 ? (
//                                     personalityResults.map((result, index) => (
//                                         <tr key={result.object_id || index}>
//                                             <td>{result.job_title || 'N/A'}</td>
//                                             <td>
//                                                 <span className="badge bg-secondary">Status N/A</span>
//                                             </td>
//                                             <td><span className="text-muted">N/A</span></td>
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr><td colSpan="3" className="text-center text-muted p-3">No job applications found.</td></tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                     </Card.Body>
//                 </Card>

//                 <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
//                 <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
//                     {personalityData?.length > 0 ? (
//                         personalityData.map((data, index) => (
//                             data?.job_id ? (
//                                 <Card key={`${data.job_id}-${index}`} className="text-center shadow-sm" style={{ minWidth: '260px', flex: '1 1 260px' }}>
//                                     <Card.Header className="bg-light">
//                                         <Card.Title as="h6" className="mb-0 text-truncate">{personalityJobTitles[index] || `Assessment ID: ${data.job_title}`}</Card.Title>
//                                     </Card.Header>
//                                     <Card.Body className="d-flex flex-column p-2">
//                                         <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}>
//                                             <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
//                                         </div>
//                                         <div className="mt-auto">
//                                             <p className="mb-1"><strong>Score:</strong> <b className="gradient-text">{typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}</b></p>
//                                             <p className="mb-2"><strong>Result:</strong> {data.result === 'T' || data.result === 'A' ? <span className="badge bg-success">Passed</span> : <span className="badge bg-danger">Failed</span>}</p>
//                                             <Button variant="outline-info" size="sm" onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id)} disabled={isLoadingAnswers && currentJobId === data.job_id}>
//                                                 {isLoadingAnswers && currentJobId === data.job_id ? <Spinner as="span" animation="border" size="sm" /> : <i className="fas fa-receipt me-1"></i>} View Answers
//                                             </Button>
//                                         </div>
//                                     </Card.Body>
//                                 </Card>
//                             ) : null
//                         ))
//                     ) : (
//                         <p className="text-center text-muted w-100">No personality assessment data available.</p>
//                     )}
//                 </div>

//                 {currentJobId && (
//                     <div className="mt-4">
//                         <Card className="shadow-sm">
//                             <Card.Header className="bg-light"><h5 className="mb-0">Submitted Answers for: {personalityJobTitles[personalityData.findIndex(p => p.job_id === currentJobId)] || `ID ${currentJobId}`}</h5></Card.Header>
//                             <Card.Body>
//                                 {isLoadingAnswers ? (
//                                     <div className="text-center p-4"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0">Loading answers...</p></div>
//                                 ) : filteredSubmittedAnswers && jobQuestions?.length > 0 ? (
//                                     <Table striped bordered hover responsive size="sm">
//                                         <thead className="table-light">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>#</th>
//                                                 <th style={{ width: '65%' }}>Question</th>
//                                                 <th style={{ width: '30%' }} className="text-center">Result</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {jobQuestions.map((question, index) => {
//                                                 const answerKey = `Q${index + 1}`;
//                                                 const result = filteredSubmittedAnswers.selected_answers?.[answerKey];
//                                                 const resultDisplay = result === 'correct' ? <span className="badge bg-success">Correct</span> : (result ? <span className="badge bg-danger">Wrong</span> : <span className="badge bg-secondary">Not Answered</span>);
//                                                 return (
//                                                     <tr key={question.id || index}>
//                                                         <td className="text-muted">{index + 1}</td>
//                                                         <td className="small">{question.question_text}</td>
//                                                         <td className="text-center align-middle">{resultDisplay}</td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </Table>
//                                 ) : (
//                                     <p className="text-center text-muted p-3">Could not load answers for this assessment.</p>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light"><Button variant="secondary" onClick={onHide}>Close</Button></Modal.Footer>
//         </Modal>
//     );
// };

// const handleDownloadResume = async (applicantId, resumeFileName) => {
//     if (!applicantId || !resumeFileName) return;
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, { responseType: "arraybuffer" });
//         const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/octet-stream" });
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         const safeFileName = resumeFileName.replace(/[^a-zA-Z0-9._-]/g, '_');
//         link.setAttribute("download", safeFileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error("Error downloading resume:", error);
//         alert("Failed to download resume.");
//     }
// };

// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([]);
//     const [activeTab, setActiveTab] = useState('Job_Opening');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [recordsPerPage, setRecordsPerPage] = useState(10);
//     const [jobapplications, setJobApplications] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedApplicant, setSelectedApplicant] = useState(null);
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null);
//     const [filterJobTitle, setFilterJobTitle] = useState("");
//     const [filterJobStatus, setFilterJobStatus] = useState("");
//     const [filterLocation, setFilterLocation] = useState("");
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);

//     const fetchApplicants = () => {
//         setIsLoading(true);
//         setError(null);
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants_alt/")
//             .then((response) => setApplicationList(response.data || []))
//             .catch((error) => {
//                 console.error("Error fetching applicants list:", error);
//                 setError("Failed to load applicant data. Please try refreshing the page.");
//                 setApplicationList([]);
//             })
//             .finally(() => setIsLoading(false));
//     };

//     useEffect(() => {
//         fetchApplicants();
//     }, []);

//     const updateJobApplicationStatusInList = (jobApplicationId, newStatus) => {
//         setJobApplications(prevApps =>
//             prevApps.map(app =>
//                 app.id === jobApplicationId ? { ...app, job_status: newStatus } : app
//             )
//         );
//     };

//     const tabFilteredApplications = useMemo(() => {
//         return applicationList.filter(app => {
//             const primaryType = app.job_opening || app.action?.personality_results?.[0]?.opening_post || 'Job_Opening';
//             return primaryType === activeTab;
//         });
//     }, [applicationList, activeTab]);

//     const filteredApplications = useMemo(() => {
//         return tabFilteredApplications.filter((application) => {
//             if (!application) return false;
//             const lowerCaseQuery = searchQuery.toLowerCase();
//             const matchesSearch = !searchQuery ||
//                 `${application.first_name} ${application.middle_name} ${application.last_name} ${application.email}`.toLowerCase().includes(lowerCaseQuery);
//             const matchesJobTitle = !filterJobTitle ||
//                 application.action?.personality_results?.some(res => res.job_title?.toLowerCase().includes(filterJobTitle.toLowerCase()));
//             const matchesLocation = !filterLocation ||
//                 application.location?.toLowerCase().includes(filterLocation.toLowerCase());
//             return matchesSearch && matchesJobTitle && matchesLocation;
//         });
//     }, [tabFilteredApplications, searchQuery, filterJobTitle, filterJobStatus, filterLocation]);

//     const currentRecords = useMemo(() => {
//         const indexOfLastRecord = currentPage * recordsPerPage;
//         const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//         return filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
//     }, [filteredApplications, currentPage, recordsPerPage]);

//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     const handlePageChange = (page) => setCurrentPage(page);

//     const handleRecordsPerPageChange = (e) => {
//         setRecordsPerPage(Number(e.target.value));
//         setCurrentPage(1);
//     };

//     const handleViewDetails = async (applicant) => {
//         setSelectedApplicant(applicant);
//         setJobApplications([]);
//         setShowModal(true);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//             setJobApplications(response.data || []);
//         } catch (error) {
//             console.error(`Error fetching job apps for ${applicant.id}:`, error);
//         }
//     };

//     const handleViewApplicantDetails = async (applicantId) => {
//         setShowDetailsModal(true);
//         setSelectedApplicantDetails(null);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//             setSelectedApplicantDetails(response.data);
//         } catch (error) {
//             console.error("Error fetching applicant details:", error);
//             setError("Could not fetch full applicant details.");
//         }
//     };

//     const uniqueJobTitles = useMemo(() => {
//         const titles = tabFilteredApplications.flatMap(app => app.action?.personality_results?.map(res => res.job_title).filter(Boolean) || []);
//         return [...new Set(titles)].sort();
//     }, [tabFilteredApplications]);

//     const uniqueLocations = useMemo(() => {
//         const locations = tabFilteredApplications.map(app => app.location).filter(Boolean);
//         return [...new Set(locations)].sort();
//     }, [tabFilteredApplications]);

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <main className="main p-3">
//                     <div className="container-fluid">
//                         {successMessage && <Alert variant="success" onClose={() => setSuccessMessage("")} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1056, top: '60px' }}><i className="fas fa-check-circle me-2"></i>{successMessage}</Alert>}
//                         {error && <Alert variant="danger" onClose={() => setError(null)} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1055, top: '60px' }}><i className="fas fa-exclamation-triangle me-2"></i> {error}</Alert>}

//                         <Card className="shadow-sm mb-4">
//                             <Card.Header className="bg-light p-3"><h1 className="h4 gradient-text mb-0">Applicant Management</h1></Card.Header>
//                             <Card.Body className="p-3">
//                                 <ul className="nav nav-pills mb-3">
//                                     <li className="nav-item"><button type="button" className={`nav-link ${activeTab === 'Job_Opening' ? 'active' : ''}`} onClick={() => { setActiveTab('Job_Opening'); setCurrentPage(1); }}>Jobs</button></li>
//                                     <li className="nav-item ms-2"><button type="button" className={`nav-link ${activeTab === 'Business_Opportunity' ? 'active' : ''}`} onClick={() => { setActiveTab('Business_Opportunity'); setCurrentPage(1); }}>Business</button></li>
//                                     <li className="nav-item ms-2"><button type="button" className={`nav-link ${activeTab === 'Technical_Consultant' ? 'active' : ''}`} onClick={() => { setActiveTab('Technical_Consultant'); setCurrentPage(1); }}>Consultants</button></li>
//                                 </ul>
//                                 <div className="row g-2 mb-3 align-items-center">
//                                     <div className="col-md-3"><InputGroup size="sm"><InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text><Form.Control type="search" placeholder="Search..." value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }} /></InputGroup></div>
//                                     <div className="col-md-2 col-6"><Form.Select size="sm" value={filterJobTitle} onChange={(e) => { setFilterJobTitle(e.target.value); setCurrentPage(1); }}><option value="">All Job Titles</option>{uniqueJobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}</Form.Select></div>
//                                     <div className="col-md-2 col-6"><Form.Select size="sm" value={filterJobStatus} onChange={(e) => { setFilterJobStatus(e.target.value); setCurrentPage(1); }}><option value="">All Statuses</option>{jobStatusOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}</Form.Select></div>
//                                     <div className="col-md-2 col-6"><Form.Select size="sm" value={filterLocation} onChange={(e) => { setFilterLocation(e.target.value); setCurrentPage(1); }}><option value="">All Locations</option>{uniqueLocations.map((loc) => (<option key={loc} value={loc}>{loc}</option>))}</Form.Select></div>
//                                     <div className="col-md-3 col-6 text-md-end"><Button variant="outline-secondary" size="sm" onClick={() => { setSearchQuery(''); setFilterJobTitle(''); setFilterJobStatus(''); setFilterLocation(''); setCurrentPage(1); }}><i className="fas fa-undo me-1"></i> Reset</Button></div>
//                                 </div>
//                                 <div className="table-responsive">
//                                     <Table striped bordered hover size="sm" className="align-middle">
//                                         <thead className="table-dark">
//                                             <tr>
//                                                 <th>Sr. No.</th><th>First Name</th><th>Middle Name</th><th>Last Name</th><th>Email</th><th>Phone</th><th>Location</th><th className="text-center">Resume</th><th className="text-center">Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {isLoading ? (
//                                                 <tr><td colSpan="9" className="text-center p-5"><Spinner animation="border" /><p className="mt-2 mb-0">Loading...</p></td></tr>
//                                             ) : currentRecords.length > 0 ? (
//                                                 currentRecords.map((app, index) => (
//                                                     <tr key={app.id}>
//                                                         <td>{app.sr_no || (currentPage - 1) * recordsPerPage + index + 1}</td>
//                                                         <td>{app.first_name || '-'}</td><td>{app.middle_name || ''}</td><td>{app.last_name || '-'}</td>
//                                                         <td>{app.email || '-'}</td><td>{app.phone || '-'}</td><td>{app.location || '-'}</td>
//                                                         <td className="text-center">{app.resume ? <Button variant="outline-primary" size="sm" className="p-1" onClick={() => handleDownloadResume(app.id, app.resume)}><i className="fas fa-download fa-fw"></i></Button> : <span className="text-muted small">N/A</span>}</td>
//                                                         <td className="text-center">
//                                                             <Button variant="info" size="sm" className="me-2 p-2" onClick={() => handleViewDetails(app)}><i className="fas fa-clipboard-check fa-fw"></i></Button>
//                                                             <Button variant="secondary" size="sm" className="p-2" onClick={() => handleViewApplicantDetails(app.id)}><i className="fas fa-user fa-fw"></i></Button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr><td colSpan="9" className="text-center text-muted p-4">No applicants match the current filters.</td></tr>
//                                             )}
//                                         </tbody>
//                                     </Table>
//                                 </div>
//                                 {filteredApplications.length > 0 && !isLoading && (
//                                     <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-3">
//                                         <div className="d-flex align-items-center"><span className="me-2 small text-muted">Show</span><Form.Select size="sm" style={{ width: 'auto' }} value={recordsPerPage} onChange={handleRecordsPerPageChange}><option value="10">10</option><option value="20">20</option><option value="50">50</option><option value="100">100</option></Form.Select><span className="ms-2 small text-muted">entries</span></div>
//                                         {totalPages > 1 && (<div className="d-flex justify-content-end flex-wrap"><Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>« Prev</Button>{[...Array(totalPages).keys()].map((p) => (<Button key={p + 1} variant={currentPage === p + 1 ? "primary" : "outline-primary"} size="sm" className="mx-1" onClick={() => handlePageChange(p + 1)}>{p + 1}</Button>))}<Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next »</Button></div>)}
//                                     </div>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>

//                     {showModal && <ApplicantModal applicant={selectedApplicant} jobapplications={jobapplications} setSuccessMessage={setSuccessMessage} updateJobApplication={updateJobApplicationStatusInList} personalityResults={selectedApplicant.action?.personality_results} key={`modal-${selectedApplicant.id}`} />}
//                     {showDetailsModal && <ApplicantDetailsModal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} applicant={selectedApplicantDetails} isLoading={!selectedApplicantDetails} />}
//                 </main>
//             </div>
//         </>
//     );
// }




// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css"; // Make sure this path is correct
// import Sidebar from "../Misc/Sidebar"; // Make sure this path is correct
// import DashNavbar from "../Misc/DashNavbar"; // Make sure this path is correct
// import { Table, Alert, Modal, Button, Card, Spinner, InputGroup, Form } from "react-bootstrap";
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "./ApplicantDetailsModal"; // Make sure this path is correct

// // --- Define Job Status Options Globally ---
// const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" }, // Added text-dark
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
// ];

// // --- ApplicantModal Component (Unchanged) ---
// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
// }) => {
//     // ... (This component remains the same as your previous version, so it's omitted for brevity)
//     const [show, setShow] = useState(false);
//     const [personalityData, setPersonalityData] = useState([]);
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
//     const chartRefs = useRef({});
//     const [allSubmittedAnswers, setAllSubmittedAnswers] = useState(null);
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
//     const [currentJobId, setCurrentJobId] = useState(null);
//     const [jobQuestions, setJobQuestions] = useState(null);
//     const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);

//     const handleStatusChange = (id, newStatus) => {
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus })
//             .then(() => {
//                 setSuccessMessage("Job status updated successfully");
//                 updateJobApplication(id, newStatus);
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error);
//             });
//     };

//     useEffect(() => {
//         setShow(false);
//         const timer = setTimeout(() => {
//             if (applicant && jobapplications) {
//                 setShow(true);
//             }
//         }, 100);

//         return () => {
//             clearTimeout(timer);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//             setCurrentJobId(null);
//             Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//             chartRefs.current = {};
//         };
//     }, [applicant, jobapplications]);

//     useEffect(() => {
//         if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant]);

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
//             const personalityResponse = await axios.get(personalityUrl);
//             const fetchedPersonalityData = personalityResponse.data || [];
//             setPersonalityData(fetchedPersonalityData);

//             if (fetchedPersonalityData.length > 0) {
//                 const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicantId}/`;
//                 const jobTitleResponse = await axios.get(jobTitleUrl);
//                 const jobTitlesMap = (jobTitleResponse.data || []).reduce((acc, job) => {
//                     if (job.job_id) acc[job.job_id] = job.job_title;
//                     return acc;
//                 }, {});
//                 const jobTitles = fetchedPersonalityData.map(data => jobTitlesMap[data.job_id] || `Job ID: ${data.job_id}`);
//                 setPersonalityJobTitles(jobTitles);
//             } else {
//                 setPersonalityJobTitles([]);
//             }

//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//         }
//     };

//     useEffect(() => {
//         Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//         chartRefs.current = {};

//         if (Array.isArray(personalityData)) {
//             personalityData.forEach((data, index) => {
//                 const chartId = `personalityChart-${applicant?.id}-${index}`;
//                 const chartElement = document.getElementById(chartId);
//                 if (chartElement && data && data.job_id) {
//                     try {
//                         const newChart = createDonutChart(data, chartId, data.status);
//                         if (newChart) {
//                             chartRefs.current[index] = newChart;
//                         }
//                     } catch (chartError) {
//                         console.error("Error creating chart:", chartError, "for data:", data);
//                     }
//                 }
//             });
//         }
//     }, [personalityData, applicant?.id]);

//     const onHide = () => {
//         setShow(false);
//     };

//     const createDonutChart = (data, chartId, status) => {
//         if (!data || typeof data.correct_count !== 'number' || typeof data.all_count !== 'number' || typeof data.wrong_count !== 'number' || data.all_count === 0) {
//             console.warn(`Invalid chart data for ${chartId}`, data);
//             const ctx = document.getElementById(chartId)?.getContext("2d");
//             if (ctx) {
//                 ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
//                 ctx.font = "12px Arial";
//                 ctx.textAlign = "center";
//                 ctx.fillText("Data unavailable", ctx.canvas.width / 2, ctx.canvas.height / 2);
//             }
//             return null;
//         }
//         const { correct_count, all_count, wrong_count } = data;
//         const ctx = document.getElementById(chartId)?.getContext("2d");

//         if (!ctx) {
//             console.error(`Canvas element with id ${chartId} not found`);
//             return null;
//         }

//         return new Chart(ctx, {
//             type: 'doughnut',
//             data: {
//                 labels: [`Correct (${correct_count})`, `Wrong (${wrong_count})`],
//                 datasets: [{
//                     data: [correct_count, wrong_count],
//                     backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'],
//                     borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'],
//                     borderWidth: 1,
//                 }]
//             },
//             options: {
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 cutout: '60%',
//                 plugins: {
//                     legend: { display: true, position: 'bottom', labels: { boxWidth: 10, padding: 15, font: { size: 10 } } },
//                     title: { display: false },
//                     tooltip: {
//                         callbacks: {
//                             label: function (context) {
//                                 let label = context.label || '';
//                                 if (label) { label += ': '; }
//                                 const value = context.parsed;
//                                 const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                                 const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%';
//                                 label += `${value} (${percentage})`;
//                                 return label;
//                             }
//                         }
//                     }
//                 }
//             }
//         });
//     };

//     const handleShowSubmittedAnswers = async (applicantId, jobId) => {
//         setCurrentJobId(jobId);
//         setFilteredSubmittedAnswers(null);
//         setJobQuestions(null);
//         setAllSubmittedAnswers(null);
//         setIsLoadingAnswers(true);

//         try {
//             const [answersResponse, questionResponse] = await Promise.all([
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`),
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${jobId}/`)
//             ]);
//             setAllSubmittedAnswers(answersResponse.data);
//             setJobQuestions(questionResponse.data || []);
//         } catch (error) {
//             console.error("Error fetching submitted answers or questions:", error);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//         } finally {
//             setIsLoadingAnswers(false);
//         }
//     };

//     useEffect(() => {
//         if (allSubmittedAnswers && currentJobId !== null) {
//             const filtered = allSubmittedAnswers.find(item => item.job_id === currentJobId);
//             setFilteredSubmittedAnswers(filtered || null);
//         } else {
//             setFilteredSubmittedAnswers(null);
//         }
//     }, [allSubmittedAnswers, currentJobId]);
//     return (
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
//             <Modal.Header closeButton>
//                 <Modal.Title className="gradient-text">
//                     {applicant?.first_name || applicant?.email || 'Applicant'} Details
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-4">
//                 {/* --- Job Applications Section --- */}
//                 <Card className="mb-4 shadow-sm">
//                     <Card.Header className="bg-light">
//                         <h5 className="mb-0">Job Applications</h5>
//                     </Card.Header>
//                     <Card.Body className="p-0">
//                         <Table striped bordered hover responsive size="sm" className="mb-0">
//                             <thead className="table-light">
//                                 <tr>
//                                     <th style={{ width: '40%' }}>Job Title</th>
//                                     <th style={{ width: '40%' }}>Status</th>
//                                     <th style={{ width: '20%' }}>Applied On</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobapplications && jobapplications.length > 0 ? (
//                                     jobapplications.map((jobApp) => {
//                                         // Use the globally defined jobStatusOptions
//                                         const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
//                                         return (
//                                             <tr key={jobApp.id}>
//                                                 <td>{jobApp.job_title || 'N/A'}</td>
//                                                 <td>
//                                                     <Form.Select
//                                                         size="sm"
//                                                         className={`${statusOption?.bgColor || 'bg-light'}`}
//                                                         value={jobApp.job_status}
//                                                         onChange={(e) => handleStatusChange(jobApp.id, e.target.value)}
//                                                         aria-label={`Job status for ${jobApp.job_title}`}
//                                                         style={{ minWidth: '150px', color: statusOption?.bgColor.includes('text-dark') ? '#000' : '#fff' }} // Updated color logic slightly
//                                                     >
//                                                         {/* Use the globally defined jobStatusOptions */}
//                                                         {jobStatusOptions.map((option) => (
//                                                             <option key={option.value} value={option.value} style={{ backgroundColor: '#fff', color: '#000' }}>
//                                                                 {option.label}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </td>
//                                                 <td>{jobApp.applied_date ? new Date(jobApp.applied_date).toLocaleDateString() : 'N/A'}</td>
//                                             </tr>
//                                         );
//                                     })
//                                 ) : (
//                                     <tr><td colSpan="3" className="text-center text-muted p-3">No job applications found.</td></tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                     </Card.Body>
//                 </Card>

//                 {/* --- Personality Assessments Section --- */}
//                 <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
//                 <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
//                     {Array.isArray(personalityData) && personalityData.length > 0 ? (
//                         personalityData.map((data, index) => (
//                             data && data.job_id ? (
//                                 <Card key={`${data.job_id}-${index}`} className="text-center shadow-sm" style={{ minWidth: '260px', maxWidth: '300px', flex: '1 1 260px' }}>
//                                     <Card.Header className="bg-light">
//                                         <Card.Title as="h6" className="mb-0 text-truncate">{personalityJobTitles[index] || `Assessment for Job ID: ${data.job_titles}`}</Card.Title>
//                                     </Card.Header>
//                                     <Card.Body className="d-flex flex-column p-2">
//                                         <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}>
//                                             <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
//                                         </div>
//                                         <div className="mt-auto">
//                                             <p className="mb-1">
//                                                 <strong>Score:</strong> <b className="gradient-text">{typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}</b>
//                                             </p>
//                                             <p className="mb-2">
//                                                 <strong>Result:</strong> {data.result === 'T' ? <span className="badge bg-success">Passed</span> : <span className="badge bg-danger">Failed</span>}
//                                             </p>
//                                             <Button
//                                                 variant="outline-info"
//                                                 size="sm"
//                                                 onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id)}
//                                                 disabled={isLoadingAnswers && currentJobId === data.job_id}
//                                             >
//                                                 {isLoadingAnswers && currentJobId === data.job_id ? (
//                                                     <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
//                                                 ) : (
//                                                     <i className="fas fa-receipt me-1"></i>
//                                                 )}
//                                                 View Answers
//                                             </Button>
//                                         </div>
//                                     </Card.Body>
//                                 </Card>
//                             ) : null
//                         ))
//                     ) : (
//                         <p className="text-center text-muted w-100">No personality assessment data available.</p>
//                     )}
//                 </div>

//                 {/* --- Submitted Answers Section (Conditional) --- */}
//                 {currentJobId && (
//                     <div className="mt-4">
//                         <Card className="shadow-sm">
//                             <Card.Header className="bg-light">
//                                 <h5 className="mb-0">Submitted Answers for Job: {personalityJobTitles[personalityData.findIndex(p => p.job_id === currentJobId)] || `ID ${currentJobId}`}</h5>
//                             </Card.Header>
//                             <Card.Body>
//                                 {isLoadingAnswers ? (
//                                     <div className="text-center p-4">
//                                         <Spinner animation="border" variant="primary" />
//                                         <p className="mt-2 mb-0">Loading answers...</p>
//                                     </div>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length > 0 ? (
//                                     <Table striped bordered hover responsive size="sm">
//                                         <thead className="table-light">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>#</th>
//                                                 <th style={{ width: '45%' }}>Question</th>
//                                                 <th style={{ width: '35%' }}>Your Answer(s)</th>
//                                                 <th style={{ width: '15%' }} className="text-center">Result</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {jobQuestions.map((question, index) => {
//                                                 const submittedAnswer = filteredSubmittedAnswers.selected_answers?.find(
//                                                     ans => ans.question_id === question.id
//                                                 );

//                                                 let yourAnswerDisplay = <i className="text-muted">Not Answered</i>;
//                                                 let resultDisplay = <span className="badge bg-secondary">N/A</span>;
//                                                 let resultText = "Not Answered";

//                                                 const isMultipleChoice = question.answers && question.answers.length > 0 && question.correct_answer_index !== null && question.correct_answer_index !== undefined;

//                                                 if (submittedAnswer) {
//                                                     if (isMultipleChoice && submittedAnswer.selected_answer_index !== null && submittedAnswer.selected_answer_index !== undefined) {
//                                                         const selectedIndex = submittedAnswer.selected_answer_index;
//                                                         const correctIndex = question.correct_answer_index;

//                                                         yourAnswerDisplay = (
//                                                             <ul className="list-unstyled mb-0 small">
//                                                                 {question.answers.map((answerText, ansIndex) => (
//                                                                     <li key={ansIndex}
//                                                                         className={`${selectedIndex === ansIndex ? 'fw-bold' : ''} ${correctIndex === ansIndex ? 'text-success' : (selectedIndex === ansIndex && selectedIndex !== correctIndex ? 'text-danger' : '')}`}
//                                                                         title={correctIndex === ansIndex ? 'Correct Answer' : (selectedIndex === ansIndex ? 'Selected Answer' : '')}
//                                                                     >
//                                                                         {selectedIndex === ansIndex && <i className="fas fa-check text-primary me-1"></i>}
//                                                                         {correctIndex === ansIndex && <i className="fas fa-star text-success me-1" style={{ fontSize: '0.7em' }}></i>}
//                                                                         {answerText}
//                                                                     </li>
//                                                                 ))}
//                                                             </ul>
//                                                         );

//                                                         if (selectedIndex === correctIndex) {
//                                                             resultDisplay = <span className="badge bg-success">Correct</span>; resultText = "Correct";
//                                                         } else {
//                                                             resultDisplay = <span className="badge bg-danger">Wrong</span>; resultText = "Wrong";
//                                                         }
//                                                     } else if (submittedAnswer.selected_answer_text !== null && submittedAnswer.selected_answer_text !== undefined) {
//                                                         yourAnswerDisplay = <span className="fst-italic">{submittedAnswer.selected_answer_text}</span>;
//                                                         resultDisplay = <span className="badge bg-info text-dark">Manual Check</span>; resultText = "Manual Check";
//                                                     }
//                                                 }

//                                                 let rowClass = '';
//                                                 if (resultText === "Correct") rowClass = 'table-success-light';
//                                                 else if (resultText === "Wrong") rowClass = 'table-danger-light';
//                                                 else if (resultText === "Not Answered") rowClass = 'table-warning-light';

//                                                 return (
//                                                     <tr key={question.id || index} className={rowClass}>
//                                                         <td className="text-muted">{index + 1}</td>
//                                                         <td className="small">{question.question_text}</td>
//                                                         <td>{yourAnswerDisplay}</td>
//                                                         <td className="text-center align-middle">{resultDisplay}</td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </Table>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length === 0 ? (
//                                     <p className="text-center text-muted p-3">No questions were found for this assessment.</p>
//                                 ) : !filteredSubmittedAnswers ? (
//                                     <p className="text-center text-muted p-3">Could not load answers for this assessment.</p>
//                                 ) : null}
//                             </Card.Body>
//                         </Card>
//                     </div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light">
//                 <Button variant="secondary" onClick={onHide}>Close</Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };
// // --- Utility Functions (Outside Components) ---
// const handleDownloadResume = async (applicantId, resumeFileName) => {
//     // ... (This function remains the same as your previous version)
//     if (!applicantId || !resumeFileName) return;
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, {
//             responseType: "arraybuffer",
//         });
//         const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/octet-stream" });
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         const safeFileName = resumeFileName.replace(/[^a-zA-Z0-9._-]/g, '_');
//         link.setAttribute("download", safeFileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error("Error downloading resume:", error);
//         alert("Failed to download resume. Please check console for details.");
//     }
// };

// // --- Main Component: Jobapplicationresult ---
// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([]);
//     const [activeTab, setActiveTab] = useState('Job_Opening'); // 'Job_Opening' | 'Business_Opportunity' | 'Technical_Consultant'
//     const [currentPage, setCurrentPage] = useState(1);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [recordsPerPage, setRecordsPerPage] = useState(10);
//     const [jobapplications, setJobApplications] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedApplicant, setSelectedApplicant] = useState(null);
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null);
//     const [filterJobTitle, setFilterJobTitle] = useState("");
//     const [filterJobStatus, setFilterJobStatus] = useState("");
//     const [filterLocation, setFilterLocation] = useState("");
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [isDownloadingBank, setIsDownloadingBank] = useState(false);

//     // --- Data Fetching and Processing ---
//     // MODIFIED: This function now uses the new API endpoint and has simplified data processing.
//     const fetchApplicants = () => {
//         setIsLoading(true);
//         setError(null);
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants-alt/") // MODIFIED: Using the new API endpoint
//             .then((response) => {
//                 // MODIFIED: Simplified data handling for the new API response structure
//                 setApplicationList(response.data || []);
//             })
//             .catch((error) => {
//                 console.error("Error fetching applicants list:", error);
//                 setError("Failed to load applicant data. Please try refreshing the page.");
//                 setApplicationList([]);
//             })
//             .finally(() => {
//                 setIsLoading(false);
//             });
//     };


//     useEffect(() => {
//         fetchApplicants();
//     }, []);

//     const updateJobApplicationStatusInList = (jobApplicationId, newStatus) => {
//         setJobApplications(prev =>
//             prev.map(app =>
//                 app.id === jobApplicationId ? { ...app, job_status: newStatus } : app
//             )
//         );
//         // This part of the logic might need adjustments depending on how status updates
//         // should reflect on the main list, which no longer has detailed status arrays.
//         // For now, it updates the modal's state. A full refresh might be needed for the main list.
//         fetchApplicants(); // A simple way to ensure the list is fresh after an update.
//     };

//     // First, filter by selected opportunity tab. This logic now works with the `job_opening` key.
//     const tabFilteredApplications = useMemo(() => {
//         const selected = activeTab;
//         return applicationList.filter(app => {
//             // This now correctly filters based on the `job_opening` field from the new API
//             const type = app?.job_opening || 'Job_Opening';
//             return type === selected;
//         });
//     }, [applicationList, activeTab]);

//     const filteredApplications = useMemo(() => {
//         // This function filters based on search and other dropdowns.
//         // Note: Filtering by job title and status may not work as the new API doesn't provide this data in the list.
//         return tabFilteredApplications.filter((application) => {
//             if (!application) return false;

//             const searchQueryLower = searchQuery.toLowerCase();
//             const filterJobTitleLower = filterJobTitle.toLowerCase();
//             const filterLocationLower = filterLocation.toLowerCase();

//             const matchesSearchQuery = searchQuery
//                 ? ((application.first_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.middle_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.last_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.email || '').toLowerCase().includes(searchQueryLower))
//                 : true;

//             // This logic is preserved but may not be effective if `job_titles` isn't in the API response.
//             let matchesJobTitle = true;
//             if (filterJobTitle) {
//                 if (application.job_titles && Array.isArray(application.job_titles)) {
//                     matchesJobTitle = application.job_titles.some(title => title?.toLowerCase().includes(filterJobTitleLower));
//                 } else {
//                     matchesJobTitle = false; // No job titles to match against
//                 }
//             }
            
//             // This logic is preserved but may not be effective if `job_status` isn't in the API response.
//             let matchesJobStatus = true;
//             if (filterJobStatus) {
//                 if (application.job_status && Array.isArray(application.job_status)) {
//                     matchesJobStatus = application.job_status.some(status => status === filterJobStatus);
//                 } else {
//                     matchesJobStatus = false; // No statuses to match against
//                 }
//             }

//             const matchesLocation = filterLocation
//                 ? (application.location || '').toLowerCase().includes(filterLocationLower)
//                 : true;

//             return matchesSearchQuery && matchesJobTitle && matchesJobStatus && matchesLocation;
//         });
//     }, [tabFilteredApplications, searchQuery, filterJobTitle, filterJobStatus, filterLocation]);

//     // --- Pagination Logic (Now dynamic based on recordsPerPage state) ---
//     const indexOfLastRecord = currentPage * recordsPerPage;
//     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//     const currentRecords = filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     const handlePageChange = (pageNumber) => {
//         if (pageNumber >= 1 && pageNumber <= totalPages) {
//             setCurrentPage(pageNumber);
//         }
//     };

//     const handleRecordsPerPageChange = (event) => {
//         setRecordsPerPage(Number(event.target.value));
//         setCurrentPage(1); // Reset to the first page to avoid invalid page numbers
//     };

//     const handleViewDetails = async (applicant) => {
//         // ... (This function remains the same)
//         if (!applicant || !applicant.id) return;
//         setSelectedApplicant(applicant);
//         setJobApplications([]);
//         setShowModal(true);

//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//             setJobApplications(response.data || []);
//         } catch (error) {
//             console.error(`Error fetching job apps for ${applicant.id}:`, error);
//             setJobApplications([]);
//             setError(`Could not load job applications for ${applicant.first_name || applicant.email}.`);
//         }
//     };

//     const handleViewApplicantDetails = async (applicantId) => {
//         // ... (This function remains the same)
//         if (!applicantId) return;
//         setSelectedApplicantDetails(null);
//         setShowDetailsModal(true);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//             setSelectedApplicantDetails(response.data);
//         } catch (error) {
//             console.error("Error fetching applicant details:", error);
//             setShowDetailsModal(false);
//             setError("Could not fetch full applicant details.");
//             setSelectedApplicantDetails(null);
//         }
//     };

//     const uniqueJobTitles = useMemo(() => {
//         // This will now likely result in an empty array unless `job_titles` is added to the new API
//         const titles = tabFilteredApplications.flatMap(app => app.job_titles || []);
//         return [...new Set(titles)].sort();
//     }, [tabFilteredApplications]);

//     const jobStatusOptionsForFilter = useMemo(() => [
//         { value: "", label: "All Statuses" },
//         ...jobStatusOptions.map(opt => ({ value: opt.value, label: opt.label }))
//     ], []);

//     const uniqueLocations = useMemo(() => {
//         const locations = tabFilteredApplications.map(app => app.location).filter(Boolean);
//         return [...new Set(locations)].sort();
//     }, [tabFilteredApplications]);

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <main className="main p-3">
//                     <div className="container-fluid">
//                         {/* Alerts remain the same */}
//                         {successMessage && <Alert variant="success" onClose={() => setSuccessMessage("")} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1056, minWidth: '300px', top: '60px' }}><i className="fas fa-check-circle me-2"></i>{successMessage}</Alert>}
//                         {error && <Alert variant="danger" onClose={() => setError(null)} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1055, minWidth: '300px', top: successMessage ? '120px' : '60px' }}><i className="fas fa-exclamation-triangle me-2"></i> {error}</Alert>}

//                         <Card className="shadow-sm mb-4">
//                             <Card.Header className="bg-light d-flex flex-column flex-md-row justify-content-between align-items-md-center p-3">
//                                 <h1 className="h4 gradient-text mb-2 mb-md-0">Applicant Management</h1>
//                             </Card.Header>
//                             <Card.Body className="p-3">
//                                 {/* Opportunity Type Tabs */}
//                                 <ul className="nav nav-pills mb-3">
//                                     <li className="nav-item">
//                                         <button
//                                             type="button"
//                                             className={`nav-link ${activeTab === 'Job_Opening' ? 'active' : ''}`}
//                                             onClick={() => { setActiveTab('Job_Opening'); setCurrentPage(1); }}
//                                         >Jobs</button>
//                                     </li>
//                                     <li className="nav-item ms-2">
//                                         <button
//                                             type="button"
//                                             className={`nav-link ${activeTab === 'Business_Opportunity' ? 'active' : ''}`}
//                                             onClick={() => { setActiveTab('Business_Opportunity'); setCurrentPage(1); }}
//                                         >Business</button>
//                                     </li>
//                                     <li className="nav-item ms-2">
//                                         <button
//                                             type="button"
//                                             className={`nav-link ${activeTab === 'Technical_Consultant' ? 'active' : ''}`}
//                                             onClick={() => { setActiveTab('Technical_Consultant'); setCurrentPage(1); }}
//                                         >Consultants</button>
//                                     </li>
//                                 </ul>
//                                 {/* Search and Filters Row remains the same */}
//                                 <div className="row g-2 mb-3 align-items-center">
//                                     <div className="col-md-3">
//                                         <InputGroup size="sm">
//                                             <InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text>
//                                             <Form.Control type="search" placeholder="Search Name or Email..." value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }} aria-label="Search Applicants" />
//                                         </InputGroup>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterJobTitle} onChange={(e) => { setFilterJobTitle(e.target.value); setCurrentPage(1); }} aria-label="Filter by Job Title">
//                                             <option value="">All Job Titles</option>
//                                             {uniqueJobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterJobStatus} onChange={(e) => { setFilterJobStatus(e.target.value); setCurrentPage(1); }} aria-label="Filter by Job Status">
//                                             {jobStatusOptionsForFilter.map((option) => (<option key={option.value} value={option.value}>{option.label}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterLocation} onChange={(e) => { setFilterLocation(e.target.value); setCurrentPage(1); }} aria-label="Filter by Location (City)">
//                                             <option value="">All Locations</option>
//                                             {uniqueLocations.map((loc) => (<option key={loc} value={loc}>{loc}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-3 col-6 text-md-end">
//                                         <Button variant="outline-secondary" size="sm" onClick={() => { setSearchQuery(''); setFilterJobTitle(''); setFilterJobStatus(''); setFilterLocation(''); setCurrentPage(1); }}>
//                                             <i className="fas fa-undo me-1"></i> Reset Filters
//                                         </Button>
//                                     </div>
//                                 </div>

//                                 {/* Table Section remains the same */}
//                                 <div className="table-responsive">
//                                     <Table striped bordered hover size="sm" className="align-middle">
//                                         <thead className="table-dark">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>Sr. No.</th>
//                                                 <th>First Name</th>
//                                                 <th>Middle Name</th>
//                                                 <th>Last Name</th>
//                                                 <th>Email</th>
//                                                 <th>Phone</th>
//                                                 <th>Location</th>
//                                                 <th className="text-center">Resume</th>
//                                                 <th className="text-center" style={{ minWidth: '100px' }}>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {isLoading ? (
//                                                 <tr><td colSpan="9" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0">Loading Applicants...</p></td></tr>
//                                             ) : currentRecords.length > 0 ? (
//                                                 currentRecords.map((application, index) => (
//                                                     <tr key={application.id}>
//                                                         <td>{indexOfFirstRecord + index + 1}</td>
//                                                         <td>{application.first_name || '-'}</td>
//                                                         <td>{application.middle_name || ''}</td>
//                                                         <td>{application.last_name || '-'}</td>
//                                                         <td>{application.email || '-'}</td>
//                                                         <td>{application.phone || '-'}</td>
//                                                         <td>{application.location || '-'}</td>
//                                                         <td className="text-center">
//                                                             {application.resume ? (<Button variant="outline-primary" size="sm" className="p-1" onClick={() => handleDownloadResume(application.id, application.resume)} title={`Download ${application.resume}`}><i className="fas fa-download fa-fw"></i></Button>) : (<span className="text-muted small">N/A</span>)}
//                                                         </td>
//                                                         <td className="text-center">
//                                                             <Button variant="info" size="sm" className="me-2 p-2 mb-1 " onClick={() => handleViewDetails(application)} title="Check Results & Status"><i className="fas fa-clipboard-check fa-fw"></i></Button>
//                                                             <Button variant="secondary" size="sm" className="p-2" onClick={() => handleViewApplicantDetails(application.id)} title="View Full Applicant Details"><i className="fas fa-user fa-fw"></i></Button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr><td colSpan="9" className="text-center text-muted p-4">{applicationList.length === 0 && !isLoading ? "No applicants found." : "No applicants match the current filters."}</td></tr>
//                                             )}
//                                         </tbody>
//                                     </Table>
//                                 </div>

//                                 {/* --- MODIFIED: Pagination and View Options --- */}
//                                 {filteredApplications.length > 0 && !isLoading && (
//                                     <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-3">
//                                         {/* NEW: Dropdown to select records per page */}
//                                         <div className="d-flex align-items-center">
//                                             <span className="me-2 small text-muted">Show</span>
//                                             <Form.Select
//                                                 size="sm"
//                                                 style={{ width: 'auto' }}
//                                                 value={recordsPerPage}
//                                                 onChange={handleRecordsPerPageChange}
//                                                 aria-label="Select number of records per page"
//                                             >
//                                                 <option value="10">10</option>
//                                                 <option value="20">20</option>
//                                                 <option value="50">50</option>
//                                                 <option value="100">100</option>
//                                             </Form.Select>
//                                             <span className="ms-2 small text-muted">entries</span>
//                                         </div>

//                                         {/* Pagination buttons */}
//                                         {totalPages > 1 && (
//                                             <div className="d-flex justify-content-end flex-wrap">
//                                                 <Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="me-1 mb-1"> « Prev </Button>
//                                                 {[...Array(totalPages).keys()].map((page) => (
//                                                     <Button key={page + 1} variant={currentPage === page + 1 ? "primary" : "outline-primary"} size="sm" className="mx-1 mb-1" onClick={() => handlePageChange(page + 1)}> {page + 1} </Button>
//                                                 ))}
//                                                 <Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="ms-1 mb-1"> Next » </Button>
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>

//                     {/* Modals remain the same */}
//                     {showModal && selectedApplicant && <ApplicantModal applicant={selectedApplicant} jobapplications={jobapplications} setSuccessMessage={setSuccessMessage} updateJobApplication={updateJobApplicationStatusInList} key={`modal-${selectedApplicant.id}-${jobapplications.length}`} />}
//                     {showDetailsModal && <ApplicantDetailsModal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} applicant={selectedApplicantDetails} isLoading={!selectedApplicantDetails && showDetailsModal} />}
//                 </main>
//             </div>
//         </>
//     );
// }

// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css"; // Make sure this path is correct
// import Sidebar from "../Misc/Sidebar"; // Make sure this path is correct
// import DashNavbar from "../Misc/DashNavbar"; // Make sure this path is correct
// import { Table, Alert, Modal, Button, Card, Spinner, InputGroup, Form } from "react-bootstrap";
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "./ApplicantDetailsModal"; // Make sure this path is correct

// // --- Define Job Status Options Globally ---
// const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" }, // Added text-dark
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
// ];

// // --- ApplicantModal Component (Unchanged) ---
// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
// }) => {
//     // ... (This component remains the same as your previous version, so it's omitted for brevity)
//     const [show, setShow] = useState(false);
//     const [personalityData, setPersonalityData] = useState([]);
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
//     const chartRefs = useRef({});
//     const [allSubmittedAnswers, setAllSubmittedAnswers] = useState(null);
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
//     const [currentJobId, setCurrentJobId] = useState(null);
//     const [jobQuestions, setJobQuestions] = useState(null);
//     const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);

//     const handleStatusChange = (id, newStatus) => {
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus })
//             .then(() => {
//                 setSuccessMessage("Job status updated successfully");
//                 updateJobApplication(id, newStatus);
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error);
//             });
//     };

//     useEffect(() => {
//         setShow(false);
//         const timer = setTimeout(() => {
//             if (applicant && jobapplications) {
//                 setShow(true);
//             }
//         }, 100);

//         return () => {
//             clearTimeout(timer);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//             setCurrentJobId(null);
//             Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//             chartRefs.current = {};
//         };
//     }, [applicant, jobapplications]);

//     useEffect(() => {
//         if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant]);

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
//             const personalityResponse = await axios.get(personalityUrl);
//             const fetchedPersonalityData = personalityResponse.data || [];
//             setPersonalityData(fetchedPersonalityData);

//             if (fetchedPersonalityData.length > 0) {
//                 const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicantId}/`;
//                 const jobTitleResponse = await axios.get(jobTitleUrl);
//                 const jobTitlesMap = (jobTitleResponse.data || []).reduce((acc, job) => {
//                     if (job.job_id) acc[job.job_id] = job.job_title;
//                     return acc;
//                 }, {});
//                 const jobTitles = fetchedPersonalityData.map(data => jobTitlesMap[data.job_id] || `Job ID: ${data.job_id}`);
//                 setPersonalityJobTitles(jobTitles);
//             } else {
//                 setPersonalityJobTitles([]);
//             }

//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//         }
//     };

//     useEffect(() => {
//         Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//         chartRefs.current = {};

//         if (Array.isArray(personalityData)) {
//             personalityData.forEach((data, index) => {
//                 const chartId = `personalityChart-${applicant?.id}-${index}`;
//                 const chartElement = document.getElementById(chartId);
//                 if (chartElement && data && data.job_id) {
//                     try {
//                         const newChart = createDonutChart(data, chartId, data.status);
//                         if (newChart) {
//                             chartRefs.current[index] = newChart;
//                         }
//                     } catch (chartError) {
//                         console.error("Error creating chart:", chartError, "for data:", data);
//                     }
//                 }
//             });
//         }
//     }, [personalityData, applicant?.id]);

//     const onHide = () => {
//         setShow(false);
//     };

//     const createDonutChart = (data, chartId, status) => {
//         if (!data || typeof data.correct_count !== 'number' || typeof data.all_count !== 'number' || typeof data.wrong_count !== 'number' || data.all_count === 0) {
//             console.warn(`Invalid chart data for ${chartId}`, data);
//             const ctx = document.getElementById(chartId)?.getContext("2d");
//             if (ctx) {
//                 ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
//                 ctx.font = "12px Arial";
//                 ctx.textAlign = "center";
//                 ctx.fillText("Data unavailable", ctx.canvas.width / 2, ctx.canvas.height / 2);
//             }
//             return null;
//         }
//         const { correct_count, all_count, wrong_count } = data;
//         const ctx = document.getElementById(chartId)?.getContext("2d");

//         if (!ctx) {
//             console.error(`Canvas element with id ${chartId} not found`);
//             return null;
//         }

//         return new Chart(ctx, {
//             type: 'doughnut',
//             data: {
//                 labels: [`Correct (${correct_count})`, `Wrong (${wrong_count})`],
//                 datasets: [{
//                     data: [correct_count, wrong_count],
//                     backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'],
//                     borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'],
//                     borderWidth: 1,
//                 }]
//             },
//             options: {
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 cutout: '60%',
//                 plugins: {
//                     legend: { display: true, position: 'bottom', labels: { boxWidth: 10, padding: 15, font: { size: 10 } } },
//                     title: { display: false },
//                     tooltip: {
//                         callbacks: {
//                             label: function (context) {
//                                 let label = context.label || '';
//                                 if (label) { label += ': '; }
//                                 const value = context.parsed;
//                                 const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                                 const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%';
//                                 label += `${value} (${percentage})`;
//                                 return label;
//                             }
//                         }
//                     }
//                 }
//             }
//         });
//     };

//     const handleShowSubmittedAnswers = async (applicantId, jobId) => {
//         setCurrentJobId(jobId);
//         setFilteredSubmittedAnswers(null);
//         setJobQuestions(null);
//         setAllSubmittedAnswers(null);
//         setIsLoadingAnswers(true);

//         try {
//             const [answersResponse, questionResponse] = await Promise.all([
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`),
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${jobId}/`)
//             ]);
//             setAllSubmittedAnswers(answersResponse.data);
//             setJobQuestions(questionResponse.data || []);
//         } catch (error) {
//             console.error("Error fetching submitted answers or questions:", error);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//         } finally {
//             setIsLoadingAnswers(false);
//         }
//     };

//     useEffect(() => {
//         if (allSubmittedAnswers && currentJobId !== null) {
//             const filtered = allSubmittedAnswers.find(item => item.job_id === currentJobId);
//             setFilteredSubmittedAnswers(filtered || null);
//         } else {
//             setFilteredSubmittedAnswers(null);
//         }
//     }, [allSubmittedAnswers, currentJobId]);
//     return (
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
//             <Modal.Header closeButton>
//                 <Modal.Title className="gradient-text">
//                     {applicant?.first_name || applicant?.email || 'Applicant'} Details
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-4">
//                 {/* --- Job Applications Section --- */}
//                 <Card className="mb-4 shadow-sm">
//                     <Card.Header className="bg-light">
//                         <h5 className="mb-0">Job Applications</h5>
//                     </Card.Header>
//                     <Card.Body className="p-0">
//                         <Table striped bordered hover responsive size="sm" className="mb-0">
//                             <thead className="table-light">
//                                 <tr>
//                                     <th style={{ width: '40%' }}>Job Title</th>
//                                     <th style={{ width: '40%' }}>Status</th>
//                                     <th style={{ width: '20%' }}>Applied On</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobapplications && jobapplications.length > 0 ? (
//                                     jobapplications.map((jobApp) => {
//                                         // Use the globally defined jobStatusOptions
//                                         const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
//                                         return (
//                                             <tr key={jobApp.id}>
//                                                 <td>{jobApp.job_title || 'N/A'}</td>
//                                                 <td>
//                                                     <Form.Select
//                                                         size="sm"
//                                                         className={`${statusOption?.bgColor || 'bg-light'}`}
//                                                         value={jobApp.job_status}
//                                                         onChange={(e) => handleStatusChange(jobApp.id, e.target.value)}
//                                                         aria-label={`Job status for ${jobApp.job_title}`}
//                                                         style={{ minWidth: '150px', color: statusOption?.bgColor.includes('text-dark') ? '#000' : '#fff' }} // Updated color logic slightly
//                                                     >
//                                                         {/* Use the globally defined jobStatusOptions */}
//                                                         {jobStatusOptions.map((option) => (
//                                                             <option key={option.value} value={option.value} style={{ backgroundColor: '#fff', color: '#000' }}>
//                                                                 {option.label}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </td>
//                                                 <td>{jobApp.applied_date ? new Date(jobApp.applied_date).toLocaleDateString() : 'N/A'}</td>
//                                             </tr>
//                                         );
//                                     })
//                                 ) : (
//                                     <tr><td colSpan="3" className="text-center text-muted p-3">No job applications found.</td></tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                     </Card.Body>
//                 </Card>

//                 {/* --- Personality Assessments Section --- */}
//                 <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
//                 <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
//                     {Array.isArray(personalityData) && personalityData.length > 0 ? (
//                         personalityData.map((data, index) => (
//                             data && data.job_id ? (
//                                 <Card key={`${data.job_id}-${index}`} className="text-center shadow-sm" style={{ minWidth: '260px', maxWidth: '300px', flex: '1 1 260px' }}>
//                                     <Card.Header className="bg-light">
//                                         <Card.Title as="h6" className="mb-0 text-truncate">{personalityJobTitles[index] || `Assessment for Job ID: ${data.job_titles}`}</Card.Title>
//                                     </Card.Header>
//                                     <Card.Body className="d-flex flex-column p-2">
//                                         <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}>
//                                             <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
//                                         </div>
//                                         <div className="mt-auto">
//                                             <p className="mb-1">
//                                                 <strong>Score:</strong> <b className="gradient-text">{typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}</b>
//                                             </p>
//                                             <p className="mb-2">
//                                                 <strong>Result:</strong> {data.result === 'T' ? <span className="badge bg-success">Passed</span> : <span className="badge bg-danger">Failed</span>}
//                                             </p>
//                                             <Button
//                                                 variant="outline-info"
//                                                 size="sm"
//                                                 onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id)}
//                                                 disabled={isLoadingAnswers && currentJobId === data.job_id}
//                                             >
//                                                 {isLoadingAnswers && currentJobId === data.job_id ? (
//                                                     <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
//                                                 ) : (
//                                                     <i className="fas fa-receipt me-1"></i>
//                                                 )}
//                                                 View Answers
//                                             </Button>
//                                         </div>
//                                     </Card.Body>
//                                 </Card>
//                             ) : null
//                         ))
//                     ) : (
//                         <p className="text-center text-muted w-100">No personality assessment data available.</p>
//                     )}
//                 </div>

//                 {/* --- Submitted Answers Section (Conditional) --- */}
//                 {currentJobId && (
//                     <div className="mt-4">
//                         <Card className="shadow-sm">
//                             <Card.Header className="bg-light">
//                                 <h5 className="mb-0">Submitted Answers for Job: {personalityJobTitles[personalityData.findIndex(p => p.job_id === currentJobId)] || `ID ${currentJobId}`}</h5>
//                             </Card.Header>
//                             <Card.Body>
//                                 {isLoadingAnswers ? (
//                                     <div className="text-center p-4">
//                                         <Spinner animation="border" variant="primary" />
//                                         <p className="mt-2 mb-0">Loading answers...</p>
//                                     </div>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length > 0 ? (
//                                     <Table striped bordered hover responsive size="sm">
//                                         <thead className="table-light">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>#</th>
//                                                 <th style={{ width: '45%' }}>Question</th>
//                                                 <th style={{ width: '35%' }}>Your Answer(s)</th>
//                                                 <th style={{ width: '15%' }} className="text-center">Result</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {jobQuestions.map((question, index) => {
//                                                 const submittedAnswer = filteredSubmittedAnswers.selected_answers?.find(
//                                                     ans => ans.question_id === question.id
//                                                 );

//                                                 let yourAnswerDisplay = <i className="text-muted">Not Answered</i>;
//                                                 let resultDisplay = <span className="badge bg-secondary">N/A</span>;
//                                                 let resultText = "Not Answered";

//                                                 const isMultipleChoice = question.answers && question.answers.length > 0 && question.correct_answer_index !== null && question.correct_answer_index !== undefined;

//                                                 if (submittedAnswer) {
//                                                     if (isMultipleChoice && submittedAnswer.selected_answer_index !== null && submittedAnswer.selected_answer_index !== undefined) {
//                                                         const selectedIndex = submittedAnswer.selected_answer_index;
//                                                         const correctIndex = question.correct_answer_index;

//                                                         yourAnswerDisplay = (
//                                                             <ul className="list-unstyled mb-0 small">
//                                                                 {question.answers.map((answerText, ansIndex) => (
//                                                                     <li key={ansIndex}
//                                                                         className={`${selectedIndex === ansIndex ? 'fw-bold' : ''} ${correctIndex === ansIndex ? 'text-success' : (selectedIndex === ansIndex && selectedIndex !== correctIndex ? 'text-danger' : '')}`}
//                                                                         title={correctIndex === ansIndex ? 'Correct Answer' : (selectedIndex === ansIndex ? 'Selected Answer' : '')}
//                                                                     >
//                                                                         {selectedIndex === ansIndex && <i className="fas fa-check text-primary me-1"></i>}
//                                                                         {correctIndex === ansIndex && <i className="fas fa-star text-success me-1" style={{ fontSize: '0.7em' }}></i>}
//                                                                         {answerText}
//                                                                     </li>
//                                                                 ))}
//                                                             </ul>
//                                                         );

//                                                         if (selectedIndex === correctIndex) {
//                                                             resultDisplay = <span className="badge bg-success">Correct</span>; resultText = "Correct";
//                                                         } else {
//                                                             resultDisplay = <span className="badge bg-danger">Wrong</span>; resultText = "Wrong";
//                                                         }
//                                                     } else if (submittedAnswer.selected_answer_text !== null && submittedAnswer.selected_answer_text !== undefined) {
//                                                         yourAnswerDisplay = <span className="fst-italic">{submittedAnswer.selected_answer_text}</span>;
//                                                         resultDisplay = <span className="badge bg-info text-dark">Manual Check</span>; resultText = "Manual Check";
//                                                     }
//                                                 }

//                                                 let rowClass = '';
//                                                 if (resultText === "Correct") rowClass = 'table-success-light';
//                                                 else if (resultText === "Wrong") rowClass = 'table-danger-light';
//                                                 else if (resultText === "Not Answered") rowClass = 'table-warning-light';

//                                                 return (
//                                                     <tr key={question.id || index} className={rowClass}>
//                                                         <td className="text-muted">{index + 1}</td>
//                                                         <td className="small">{question.question_text}</td>
//                                                         <td>{yourAnswerDisplay}</td>
//                                                         <td className="text-center align-middle">{resultDisplay}</td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </Table>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length === 0 ? (
//                                     <p className="text-center text-muted p-3">No questions were found for this assessment.</p>
//                                 ) : !filteredSubmittedAnswers ? (
//                                     <p className="text-center text-muted p-3">Could not load answers for this assessment.</p>
//                                 ) : null}
//                             </Card.Body>
//                         </Card>
//                     </div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light">
//                 <Button variant="secondary" onClick={onHide}>Close</Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };
// // --- Utility Functions (Outside Components) ---
// const handleDownloadResume = async (applicantId, resumeFileName) => {
//     // ... (This function remains the same as your previous version)
//     if (!applicantId || !resumeFileName) return;
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, {
//             responseType: "arraybuffer",
//         });
//         const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/octet-stream" });
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         const safeFileName = resumeFileName.replace(/[^a-zA-Z0-9._-]/g, '_');
//         link.setAttribute("download", safeFileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error("Error downloading resume:", error);
//         alert("Failed to download resume. Please check console for details.");
//     }
// };

// // --- Main Component: Jobapplicationresult ---
// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([]);
//     const [activeTab, setActiveTab] = useState('Job_Opening'); // 'Job_Opening' | 'Business_Opportunity' | 'Technical_Consultant'
//     const [currentPage, setCurrentPage] = useState(1);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [recordsPerPage, setRecordsPerPage] = useState(10);
//     const [jobapplications, setJobApplications] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedApplicant, setSelectedApplicant] = useState(null);
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null);
//     const [filterJobTitle, setFilterJobTitle] = useState("");
//     const [filterJobStatus, setFilterJobStatus] = useState("");
//     const [filterLocation, setFilterLocation] = useState("");
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [isDownloadingBank, setIsDownloadingBank] = useState(false);

//     // --- Data Fetching and Processing ---
//     // MODIFIED: This function now sorts applicants by their most recent application date.
//     const fetchApplicants = () => {
//         setIsLoading(true);
//         setError(null);
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants_not_offered/")
//             .then(async (response) => {
//                 const potentialApplicants = response.data || [];
//                 const results = await Promise.allSettled(
//                     potentialApplicants.map(async (application) => {
//                         if (!application || !application.id) return null;
//                         try {
//                             const jobTitleResponse = await axios.get(
//                                 `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}/`
//                             );
//                             const jobData = jobTitleResponse.data || [];
//                             if (!jobData || jobData.length === 0) return null;

//                             // --- Start of Sorting Logic Change ---
//                             const jobTitles = jobData.map((job) => job.job_title).filter(Boolean);
//                             const jobStatuses = jobData.map((job) => job.job_status).filter(Boolean);
                            
//                             // Find the most recent application date for this applicant
//                             const appliedDates = jobData
//                                 .map(job => job.applied_date)
//                                 .filter(Boolean)
//                                 .map(dateStr => new Date(dateStr).getTime()); // Convert to ms for easy comparison

//                             const mostRecentTimestamp = appliedDates.length > 0 ? Math.max(...appliedDates) : 0;
//                             // --- End of Sorting Logic Change ---

//                             return {
//                                 ...application,
//                                 job_titles: jobTitles,
//                                 job_status: jobStatuses,
//                                 location: application.district || null,
//                                 mostRecentApplicationTimestamp: mostRecentTimestamp, // Add timestamp for sorting
//                             };
//                         } catch (error) {
//                             console.error(`Error processing job details for potential applicant ${application.id}, filtering out:`, error);
//                             return null;
//                         }
//                     })
//                 );
                
//                 let confirmedApplicants = results
//                     .filter(result => result.status === 'fulfilled' && result.value)
//                     .map(result => result.value);

//                 // --- NEW: Sort the entire list by the new timestamp, descending (newest first) ---
//                 confirmedApplicants.sort((a, b) => b.mostRecentApplicationTimestamp - a.mostRecentApplicationTimestamp);

//                 setApplicationList(confirmedApplicants);
//             })
//             .catch((error) => {
//                 console.error("Error fetching potential applicants list:", error);
//                 setError("Failed to load applicant data. Please try refreshing the page.");
//                 setApplicationList([]);
//             })
//             .finally(() => {
//                 setIsLoading(false);
//             });
//     };


//     useEffect(() => {
//         fetchApplicants();
//     }, []);

//     const updateJobApplicationStatusInList = (jobApplicationId, newStatus) => {
//         setJobApplications(prev =>
//             prev.map(app =>
//                 app.id === jobApplicationId ? { ...app, job_status: newStatus } : app
//             )
//         );
//         setApplicationList(prevList => prevList.map(applicant => {
//             const relevantJobApp = jobapplications.find(j => j.id === jobApplicationId && applicant.job_titles.includes(j.job_title));
//              if(relevantJobApp) {
//                  const jobIndex = applicant.job_titles.findIndex(title => title === relevantJobApp.job_title);
//                  if (jobIndex !== -1 && applicant.job_status && applicant.job_status.length > jobIndex) {
//                     const newStatuses = [...applicant.job_status];
//                     newStatuses[jobIndex] = newStatus;
//                     return { ...applicant, job_status: newStatuses };
//                  }
//              }
//              return applicant;
//         }));
//     };

//     // First, filter by selected opportunity tab
//     const tabFilteredApplications = useMemo(() => {
//         const selected = activeTab;
//         return applicationList.filter(app => {
//             const type = app?.job_opening || 'Job_Opening';
//             return type === selected;
//         });
//     }, [applicationList, activeTab]);

//     const filteredApplications = useMemo(() => {
//         // ... (This function remains the same as your previous version)
//         return tabFilteredApplications.filter((application) => {
//             if (!application) return false;

//             const searchQueryLower = searchQuery.toLowerCase();
//             const filterJobTitleLower = filterJobTitle.toLowerCase();
//             const filterLocationLower = filterLocation.toLowerCase();

//             const matchesSearchQuery = searchQuery
//                 ? ((application.first_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.middle_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.last_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.email || '').toLowerCase().includes(searchQueryLower))
//                 : true;

//             const matchesJobTitle = filterJobTitle
//                 ? application.job_titles?.some(title => title?.toLowerCase().includes(filterJobTitleLower))
//                 : true;

//             const matchesJobStatus = filterJobStatus
//                 ? application.job_status?.some(status => status === filterJobStatus)
//                 : true;

//             const matchesLocation = filterLocation
//                 ? (application.location || '').toLowerCase().includes(filterLocationLower)
//                 : true;

//             return matchesSearchQuery && matchesJobTitle && matchesJobStatus && matchesLocation;
//         });
//     }, [tabFilteredApplications, searchQuery, filterJobTitle, filterJobStatus, filterLocation]);

//     // --- Pagination Logic (Now dynamic based on recordsPerPage state) ---
//     const indexOfLastRecord = currentPage * recordsPerPage;
//     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//     const currentRecords = filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     const handlePageChange = (pageNumber) => {
//         if (pageNumber >= 1 && pageNumber <= totalPages) {
//             setCurrentPage(pageNumber);
//         }
//     };

//     const handleRecordsPerPageChange = (event) => {
//         setRecordsPerPage(Number(event.target.value));
//         setCurrentPage(1); // Reset to the first page to avoid invalid page numbers
//     };

//     const handleViewDetails = async (applicant) => {
//         // ... (This function remains the same)
//         if (!applicant || !applicant.id) return;
//         setSelectedApplicant(applicant);
//         setJobApplications([]);
//         setShowModal(true);

//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//             setJobApplications(response.data || []);
//         } catch (error) {
//             console.error(`Error fetching job apps for ${applicant.id}:`, error);
//             setJobApplications([]);
//             setError(`Could not load job applications for ${applicant.first_name || applicant.email}.`);
//         }
//     };

//     const handleViewApplicantDetails = async (applicantId) => {
//         // ... (This function remains the same)
//         if (!applicantId) return;
//         setSelectedApplicantDetails(null);
//         setShowDetailsModal(true);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//             setSelectedApplicantDetails(response.data);
//         } catch (error) {
//             console.error("Error fetching applicant details:", error);
//             setShowDetailsModal(false);
//             setError("Could not fetch full applicant details.");
//             setSelectedApplicantDetails(null);
//         }
//     };

//     const uniqueJobTitles = useMemo(() => {
//         const titles = tabFilteredApplications.flatMap(app => app.job_titles || []);
//         return [...new Set(titles)].sort();
//     }, [tabFilteredApplications]);

//     const jobStatusOptionsForFilter = useMemo(() => [
//         { value: "", label: "All Statuses" },
//         ...jobStatusOptions.map(opt => ({ value: opt.value, label: opt.label }))
//     ], []);

//     const uniqueLocations = useMemo(() => {
//         const locations = tabFilteredApplications.map(app => app.location).filter(Boolean);
//         return [...new Set(locations)].sort();
//     }, [tabFilteredApplications]);

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <main className="main p-3">
//                     <div className="container-fluid">
//                         {/* Alerts remain the same */}
//                         {successMessage && <Alert variant="success" onClose={() => setSuccessMessage("")} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1056, minWidth: '300px', top: '60px' }}><i className="fas fa-check-circle me-2"></i>{successMessage}</Alert>}
//                         {error && <Alert variant="danger" onClose={() => setError(null)} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1055, minWidth: '300px', top: successMessage ? '120px' : '60px' }}><i className="fas fa-exclamation-triangle me-2"></i> {error}</Alert>}

//                         <Card className="shadow-sm mb-4">
//                             <Card.Header className="bg-light d-flex flex-column flex-md-row justify-content-between align-items-md-center p-3">
//                                 <h1 className="h4 gradient-text mb-2 mb-md-0">Applicant Management</h1>
//                             </Card.Header>
//                             <Card.Body className="p-3">
//                                 {/* Opportunity Type Tabs */}
//                                 <ul className="nav nav-pills mb-3">
//                                     <li className="nav-item">
//                                         <button
//                                             type="button"
//                                             className={`nav-link ${activeTab === 'Job_Opening' ? 'active' : ''}`}
//                                             onClick={() => { setActiveTab('Job_Opening'); setCurrentPage(1); }}
//                                         >Jobs</button>
//                                     </li>
//                                     <li className="nav-item ms-2">
//                                         <button
//                                             type="button"
//                                             className={`nav-link ${activeTab === 'Business_Opportunity' ? 'active' : ''}`}
//                                             onClick={() => { setActiveTab('Business_Opportunity'); setCurrentPage(1); }}
//                                         >Business</button>
//                                     </li>
//                                     <li className="nav-item ms-2">
//                                         <button
//                                             type="button"
//                                             className={`nav-link ${activeTab === 'Technical_Consultant' ? 'active' : ''}`}
//                                             onClick={() => { setActiveTab('Technical_Consultant'); setCurrentPage(1); }}
//                                         >Consultants</button>
//                                     </li>
//                                 </ul>
//                                 {/* Search and Filters Row remains the same */}
//                                 <div className="row g-2 mb-3 align-items-center">
//                                     <div className="col-md-3">
//                                         <InputGroup size="sm">
//                                             <InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text>
//                                             <Form.Control type="search" placeholder="Search Name or Email..." value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }} aria-label="Search Applicants" />
//                                         </InputGroup>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterJobTitle} onChange={(e) => { setFilterJobTitle(e.target.value); setCurrentPage(1); }} aria-label="Filter by Job Title">
//                                             <option value="">All Job Titles</option>
//                                             {uniqueJobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterJobStatus} onChange={(e) => { setFilterJobStatus(e.target.value); setCurrentPage(1); }} aria-label="Filter by Job Status">
//                                             {jobStatusOptionsForFilter.map((option) => (<option key={option.value} value={option.value}>{option.label}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterLocation} onChange={(e) => { setFilterLocation(e.target.value); setCurrentPage(1); }} aria-label="Filter by Location (City)">
//                                             <option value="">All Locations</option>
//                                             {uniqueLocations.map((loc) => (<option key={loc} value={loc}>{loc}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-3 col-6 text-md-end">
//                                         <Button variant="outline-secondary" size="sm" onClick={() => { setSearchQuery(''); setFilterJobTitle(''); setFilterJobStatus(''); setFilterLocation(''); setCurrentPage(1); }}>
//                                             <i className="fas fa-undo me-1"></i> Reset Filters
//                                         </Button>
//                                     </div>
//                                 </div>

//                                 {/* Table Section remains the same */}
//                                 <div className="table-responsive">
//                                     <Table striped bordered hover size="sm" className="align-middle">
//                                         <thead className="table-dark">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>Sr. No.</th>
//                                                 <th>First Name</th>
//                                                 <th>Middle Name</th>
//                                                 <th>Last Name</th>
//                                                 <th>Email</th>
//                                                 <th>Phone</th>
//                                                 <th>Location</th>
//                                                 <th className="text-center">Resume</th>
//                                                 <th className="text-center" style={{ minWidth: '100px' }}>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {isLoading ? (
//                                                 <tr><td colSpan="9" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0">Loading Applicants...</p></td></tr>
//                                             ) : currentRecords.length > 0 ? (
//                                                 currentRecords.map((application, index) => (
//                                                     <tr key={application.id}>
//                                                         <td>{indexOfFirstRecord + index + 1}</td>
//                                                         <td>{application.first_name || '-'}</td>
//                                                         <td>{application.middle_name || ''}</td>
//                                                         <td>{application.last_name || '-'}</td>
//                                                         <td>{application.email || '-'}</td>
//                                                         <td>{application.phone || '-'}</td>
//                                                         <td>{application.location || '-'}</td>
//                                                         <td className="text-center">
//                                                             {application.resume ? (<Button variant="outline-primary" size="sm" className="p-1" onClick={() => handleDownloadResume(application.id, application.resume)} title={`Download ${application.resume}`}><i className="fas fa-download fa-fw"></i></Button>) : (<span className="text-muted small">N/A</span>)}
//                                                         </td>
//                                                         <td className="text-center">
//                                                             <Button variant="info" size="sm" className="me-2 p-2 mb-1 " onClick={() => handleViewDetails(application)} title="Check Results & Status"><i className="fas fa-clipboard-check fa-fw"></i></Button>
//                                                             <Button variant="secondary" size="sm" className="p-2" onClick={() => handleViewApplicantDetails(application.id)} title="View Full Applicant Details"><i className="fas fa-user fa-fw"></i></Button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr><td colSpan="9" className="text-center text-muted p-4">{applicationList.length === 0 && !isLoading ? "No applicants found." : "No applicants match the current filters."}</td></tr>
//                                             )}
//                                         </tbody>
//                                     </Table>
//                                 </div>

//                                 {/* --- MODIFIED: Pagination and View Options --- */}
//                                 {filteredApplications.length > 0 && !isLoading && (
//                                     <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-3">
//                                         {/* NEW: Dropdown to select records per page */}
//                                         <div className="d-flex align-items-center">
//                                             <span className="me-2 small text-muted">Show</span>
//                                             <Form.Select
//                                                 size="sm"
//                                                 style={{ width: 'auto' }}
//                                                 value={recordsPerPage}
//                                                 onChange={handleRecordsPerPageChange}
//                                                 aria-label="Select number of records per page"
//                                             >
//                                                 <option value="10">10</option>
//                                                 <option value="20">20</option>
//                                                 <option value="50">50</option>
//                                                 <option value="100">100</option>
//                                             </Form.Select>
//                                             <span className="ms-2 small text-muted">entries</span>
//                                         </div>

//                                         {/* Pagination buttons */}
//                                         {totalPages > 1 && (
//                                             <div className="d-flex justify-content-end flex-wrap">
//                                                 <Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="me-1 mb-1"> « Prev </Button>
//                                                 {[...Array(totalPages).keys()].map((page) => (
//                                                     <Button key={page + 1} variant={currentPage === page + 1 ? "primary" : "outline-primary"} size="sm" className="mx-1 mb-1" onClick={() => handlePageChange(page + 1)}> {page + 1} </Button>
//                                                 ))}
//                                                 <Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="ms-1 mb-1"> Next » </Button>
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>

//                     {/* Modals remain the same */}
//                     {showModal && selectedApplicant && <ApplicantModal applicant={selectedApplicant} jobapplications={jobapplications} setSuccessMessage={setSuccessMessage} updateJobApplication={updateJobApplicationStatusInList} key={`modal-${selectedApplicant.id}-${jobapplications.length}`} />}
//                     {showDetailsModal && <ApplicantDetailsModal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} applicant={selectedApplicantDetails} isLoading={!selectedApplicantDetails && showDetailsModal} />}
//                 </main>
//             </div>
//         </>
//     );
// }

// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css"; // Make sure this path is correct
// import Sidebar from "../Misc/Sidebar"; // Make sure this path is correct
// import DashNavbar from "../Misc/DashNavbar"; // Make sure this path is correct
// import { Table, Alert, Modal, Button, Card, Spinner, InputGroup, Form } from "react-bootstrap";
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "./ApplicantDetailsModal"; // Make sure this path is correct

// // --- Define Job Status Options Globally ---
// const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" }, // Added text-dark
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
// ];

// // --- ApplicantModal Component (Unchanged) ---
// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
// }) => {
//     // ... (This component remains the same as your previous version, so it's omitted for brevity)
//     const [show, setShow] = useState(false);
//     const [personalityData, setPersonalityData] = useState([]);
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
//     const chartRefs = useRef({});
//     const [allSubmittedAnswers, setAllSubmittedAnswers] = useState(null);
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
//     const [currentJobId, setCurrentJobId] = useState(null);
//     const [jobQuestions, setJobQuestions] = useState(null);
//     const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);

//     const handleStatusChange = (id, newStatus) => {
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus })
//             .then(() => {
//                 setSuccessMessage("Job status updated successfully");
//                 updateJobApplication(id, newStatus);
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error);
//             });
//     };

//     useEffect(() => {
//         setShow(false);
//         const timer = setTimeout(() => {
//             if (applicant && jobapplications) {
//                 setShow(true);
//             }
//         }, 100);

//         return () => {
//             clearTimeout(timer);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//             setCurrentJobId(null);
//             Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//             chartRefs.current = {};
//         };
//     }, [applicant, jobapplications]);

//     useEffect(() => {
//         if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant]);

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
//             const personalityResponse = await axios.get(personalityUrl);
//             const fetchedPersonalityData = personalityResponse.data || [];
//             setPersonalityData(fetchedPersonalityData);

//             if (fetchedPersonalityData.length > 0) {
//                 const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicantId}/`;
//                 const jobTitleResponse = await axios.get(jobTitleUrl);
//                 const jobTitlesMap = (jobTitleResponse.data || []).reduce((acc, job) => {
//                     if (job.job_id) acc[job.job_id] = job.job_title;
//                     return acc;
//                 }, {});
//                 const jobTitles = fetchedPersonalityData.map(data => jobTitlesMap[data.job_id] || `Job ID: ${data.job_id}`);
//                 setPersonalityJobTitles(jobTitles);
//             } else {
//                 setPersonalityJobTitles([]);
//             }

//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//         }
//     };

//     useEffect(() => {
//         Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//         chartRefs.current = {};

//         if (Array.isArray(personalityData)) {
//             personalityData.forEach((data, index) => {
//                 const chartId = `personalityChart-${applicant?.id}-${index}`;
//                 const chartElement = document.getElementById(chartId);
//                 if (chartElement && data && data.job_id) {
//                     try {
//                         const newChart = createDonutChart(data, chartId, data.status);
//                         if (newChart) {
//                             chartRefs.current[index] = newChart;
//                         }
//                     } catch (chartError) {
//                         console.error("Error creating chart:", chartError, "for data:", data);
//                     }
//                 }
//             });
//         }
//     }, [personalityData, applicant?.id]);

//     const onHide = () => {
//         setShow(false);
//     };

//     const createDonutChart = (data, chartId, status) => {
//         if (!data || typeof data.correct_count !== 'number' || typeof data.all_count !== 'number' || typeof data.wrong_count !== 'number' || data.all_count === 0) {
//             console.warn(`Invalid chart data for ${chartId}`, data);
//             const ctx = document.getElementById(chartId)?.getContext("2d");
//             if (ctx) {
//                 ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
//                 ctx.font = "12px Arial";
//                 ctx.textAlign = "center";
//                 ctx.fillText("Data unavailable", ctx.canvas.width / 2, ctx.canvas.height / 2);
//             }
//             return null;
//         }
//         const { correct_count, all_count, wrong_count } = data;
//         const ctx = document.getElementById(chartId)?.getContext("2d");

//         if (!ctx) {
//             console.error(`Canvas element with id ${chartId} not found`);
//             return null;
//         }

//         return new Chart(ctx, {
//             type: 'doughnut',
//             data: {
//                 labels: [`Correct (${correct_count})`, `Wrong (${wrong_count})`],
//                 datasets: [{
//                     data: [correct_count, wrong_count],
//                     backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'],
//                     borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'],
//                     borderWidth: 1,
//                 }]
//             },
//             options: {
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 cutout: '60%',
//                 plugins: {
//                     legend: { display: true, position: 'bottom', labels: { boxWidth: 10, padding: 15, font: { size: 10 } } },
//                     title: { display: false },
//                     tooltip: {
//                         callbacks: {
//                             label: function (context) {
//                                 let label = context.label || '';
//                                 if (label) { label += ': '; }
//                                 const value = context.parsed;
//                                 const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                                 const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%';
//                                 label += `${value} (${percentage})`;
//                                 return label;
//                             }
//                         }
//                     }
//                 }
//             }
//         });
//     };

//     const handleShowSubmittedAnswers = async (applicantId, jobId) => {
//         setCurrentJobId(jobId);
//         setFilteredSubmittedAnswers(null);
//         setJobQuestions(null);
//         setAllSubmittedAnswers(null);
//         setIsLoadingAnswers(true);

//         try {
//             const [answersResponse, questionResponse] = await Promise.all([
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`),
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${jobId}/`)
//             ]);
//             setAllSubmittedAnswers(answersResponse.data);
//             setJobQuestions(questionResponse.data || []);
//         } catch (error) {
//             console.error("Error fetching submitted answers or questions:", error);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//         } finally {
//             setIsLoadingAnswers(false);
//         }
//     };

//     useEffect(() => {
//         if (allSubmittedAnswers && currentJobId !== null) {
//             const filtered = allSubmittedAnswers.find(item => item.job_id === currentJobId);
//             setFilteredSubmittedAnswers(filtered || null);
//         } else {
//             setFilteredSubmittedAnswers(null);
//         }
//     }, [allSubmittedAnswers, currentJobId]);
//     return (
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
//             <Modal.Header closeButton>
//                 <Modal.Title className="gradient-text">
//                     {applicant?.first_name || applicant?.email || 'Applicant'} Details
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-4">
//                 {/* --- Job Applications Section --- */}
//                 <Card className="mb-4 shadow-sm">
//                     <Card.Header className="bg-light">
//                         <h5 className="mb-0">Job Applications</h5>
//                     </Card.Header>
//                     <Card.Body className="p-0">
//                         <Table striped bordered hover responsive size="sm" className="mb-0">
//                             <thead className="table-light">
//                                 <tr>
//                                     <th style={{ width: '40%' }}>Job Title</th>
//                                     <th style={{ width: '40%' }}>Status</th>
//                                     <th style={{ width: '20%' }}>Applied On</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobapplications && jobapplications.length > 0 ? (
//                                     jobapplications.map((jobApp) => {
//                                         // Use the globally defined jobStatusOptions
//                                         const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
//                                         return (
//                                             <tr key={jobApp.id}>
//                                                 <td>{jobApp.job_title || 'N/A'}</td>
//                                                 <td>
//                                                     <Form.Select
//                                                         size="sm"
//                                                         className={`${statusOption?.bgColor || 'bg-light'}`}
//                                                         value={jobApp.job_status}
//                                                         onChange={(e) => handleStatusChange(jobApp.id, e.target.value)}
//                                                         aria-label={`Job status for ${jobApp.job_title}`}
//                                                         style={{ minWidth: '150px', color: statusOption?.bgColor.includes('text-dark') ? '#000' : '#fff' }} // Updated color logic slightly
//                                                     >
//                                                         {/* Use the globally defined jobStatusOptions */}
//                                                         {jobStatusOptions.map((option) => (
//                                                             <option key={option.value} value={option.value} style={{ backgroundColor: '#fff', color: '#000' }}>
//                                                                 {option.label}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </td>
//                                                 <td>{jobApp.applied_date ? new Date(jobApp.applied_date).toLocaleDateString() : 'N/A'}</td>
//                                             </tr>
//                                         );
//                                     })
//                                 ) : (
//                                     <tr><td colSpan="3" className="text-center text-muted p-3">No job applications found.</td></tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                     </Card.Body>
//                 </Card>

//                 {/* --- Personality Assessments Section --- */}
//                 <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
//                 <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
//                     {Array.isArray(personalityData) && personalityData.length > 0 ? (
//                         personalityData.map((data, index) => (
//                             data && data.job_id ? (
//                                 <Card key={`${data.job_id}-${index}`} className="text-center shadow-sm" style={{ minWidth: '260px', maxWidth: '300px', flex: '1 1 260px' }}>
//                                     <Card.Header className="bg-light">
//                                         <Card.Title as="h6" className="mb-0 text-truncate">{personalityJobTitles[index] || `Assessment for Job ID: ${data.job_titles}`}</Card.Title>
//                                     </Card.Header>
//                                     <Card.Body className="d-flex flex-column p-2">
//                                         <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}>
//                                             <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
//                                         </div>
//                                         <div className="mt-auto">
//                                             <p className="mb-1">
//                                                 <strong>Score:</strong> <b className="gradient-text">{typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}</b>
//                                             </p>
//                                             <p className="mb-2">
//                                                 <strong>Result:</strong> {data.result === 'T' ? <span className="badge bg-success">Passed</span> : <span className="badge bg-danger">Failed</span>}
//                                             </p>
//                                             <Button
//                                                 variant="outline-info"
//                                                 size="sm"
//                                                 onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id)}
//                                                 disabled={isLoadingAnswers && currentJobId === data.job_id}
//                                             >
//                                                 {isLoadingAnswers && currentJobId === data.job_id ? (
//                                                     <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
//                                                 ) : (
//                                                     <i className="fas fa-receipt me-1"></i>
//                                                 )}
//                                                 View Answers
//                                             </Button>
//                                         </div>
//                                     </Card.Body>
//                                 </Card>
//                             ) : null
//                         ))
//                     ) : (
//                         <p className="text-center text-muted w-100">No personality assessment data available.</p>
//                     )}
//                 </div>

//                 {/* --- Submitted Answers Section (Conditional) --- */}
//                 {currentJobId && (
//                     <div className="mt-4">
//                         <Card className="shadow-sm">
//                             <Card.Header className="bg-light">
//                                 <h5 className="mb-0">Submitted Answers for Job: {personalityJobTitles[personalityData.findIndex(p => p.job_id === currentJobId)] || `ID ${currentJobId}`}</h5>
//                             </Card.Header>
//                             <Card.Body>
//                                 {isLoadingAnswers ? (
//                                     <div className="text-center p-4">
//                                         <Spinner animation="border" variant="primary" />
//                                         <p className="mt-2 mb-0">Loading answers...</p>
//                                     </div>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length > 0 ? (
//                                     <Table striped bordered hover responsive size="sm">
//                                         <thead className="table-light">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>#</th>
//                                                 <th style={{ width: '45%' }}>Question</th>
//                                                 <th style={{ width: '35%' }}>Your Answer(s)</th>
//                                                 <th style={{ width: '15%' }} className="text-center">Result</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {jobQuestions.map((question, index) => {
//                                                 const submittedAnswer = filteredSubmittedAnswers.selected_answers?.find(
//                                                     ans => ans.question_id === question.id
//                                                 );

//                                                 let yourAnswerDisplay = <i className="text-muted">Not Answered</i>;
//                                                 let resultDisplay = <span className="badge bg-secondary">N/A</span>;
//                                                 let resultText = "Not Answered";

//                                                 const isMultipleChoice = question.answers && question.answers.length > 0 && question.correct_answer_index !== null && question.correct_answer_index !== undefined;

//                                                 if (submittedAnswer) {
//                                                     if (isMultipleChoice && submittedAnswer.selected_answer_index !== null && submittedAnswer.selected_answer_index !== undefined) {
//                                                         const selectedIndex = submittedAnswer.selected_answer_index;
//                                                         const correctIndex = question.correct_answer_index;

//                                                         yourAnswerDisplay = (
//                                                             <ul className="list-unstyled mb-0 small">
//                                                                 {question.answers.map((answerText, ansIndex) => (
//                                                                     <li key={ansIndex}
//                                                                         className={`${selectedIndex === ansIndex ? 'fw-bold' : ''} ${correctIndex === ansIndex ? 'text-success' : (selectedIndex === ansIndex && selectedIndex !== correctIndex ? 'text-danger' : '')}`}
//                                                                         title={correctIndex === ansIndex ? 'Correct Answer' : (selectedIndex === ansIndex ? 'Selected Answer' : '')}
//                                                                     >
//                                                                         {selectedIndex === ansIndex && <i className="fas fa-check text-primary me-1"></i>}
//                                                                         {correctIndex === ansIndex && <i className="fas fa-star text-success me-1" style={{ fontSize: '0.7em' }}></i>}
//                                                                         {answerText}
//                                                                     </li>
//                                                                 ))}
//                                                             </ul>
//                                                         );

//                                                         if (selectedIndex === correctIndex) {
//                                                             resultDisplay = <span className="badge bg-success">Correct</span>; resultText = "Correct";
//                                                         } else {
//                                                             resultDisplay = <span className="badge bg-danger">Wrong</span>; resultText = "Wrong";
//                                                         }
//                                                     } else if (submittedAnswer.selected_answer_text !== null && submittedAnswer.selected_answer_text !== undefined) {
//                                                         yourAnswerDisplay = <span className="fst-italic">{submittedAnswer.selected_answer_text}</span>;
//                                                         resultDisplay = <span className="badge bg-info text-dark">Manual Check</span>; resultText = "Manual Check";
//                                                     }
//                                                 }

//                                                 let rowClass = '';
//                                                 if (resultText === "Correct") rowClass = 'table-success-light';
//                                                 else if (resultText === "Wrong") rowClass = 'table-danger-light';
//                                                 else if (resultText === "Not Answered") rowClass = 'table-warning-light';

//                                                 return (
//                                                     <tr key={question.id || index} className={rowClass}>
//                                                         <td className="text-muted">{index + 1}</td>
//                                                         <td className="small">{question.question_text}</td>
//                                                         <td>{yourAnswerDisplay}</td>
//                                                         <td className="text-center align-middle">{resultDisplay}</td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </Table>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length === 0 ? (
//                                     <p className="text-center text-muted p-3">No questions were found for this assessment.</p>
//                                 ) : !filteredSubmittedAnswers ? (
//                                     <p className="text-center text-muted p-3">Could not load answers for this assessment.</p>
//                                 ) : null}
//                             </Card.Body>
//                         </Card>
//                     </div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light">
//                 <Button variant="secondary" onClick={onHide}>Close</Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };
// // --- Utility Functions (Outside Components) ---
// const handleDownloadResume = async (applicantId, resumeFileName) => {
//     // ... (This function remains the same as your previous version)
//     if (!applicantId || !resumeFileName) return;
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, {
//             responseType: "arraybuffer",
//         });
//         const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/octet-stream" });
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         const safeFileName = resumeFileName.replace(/[^a-zA-Z0-9._-]/g, '_');
//         link.setAttribute("download", safeFileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error("Error downloading resume:", error);
//         alert("Failed to download resume. Please check console for details.");
//     }
// };

// // --- Main Component: Jobapplicationresult ---
// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
    
//     // MODIFIED: Converted recordsPerPage to a state
//     const [recordsPerPage, setRecordsPerPage] = useState(10);
    
//     const [jobapplications, setJobApplications] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedApplicant, setSelectedApplicant] = useState(null);
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null);
//     const [filterJobTitle, setFilterJobTitle] = useState("");
//     const [filterJobStatus, setFilterJobStatus] = useState("");
//     const [filterLocation, setFilterLocation] = useState("");
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [isDownloadingBank, setIsDownloadingBank] = useState(false);

//     // --- Data Fetching and Processing ---
//     const fetchApplicants = () => {
//         setIsLoading(true);
//         setError(null);
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants_not_offered/")
//             .then(async (response) => {
//                 const potentialApplicants = response.data || [];
//                 const results = await Promise.allSettled(
//                     potentialApplicants.map(async (application) => {
//                         if (!application || !application.id) return null;
//                         try {
//                             const jobTitleResponse = await axios.get(
//                                 `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}/`
//                             );
//                             const jobData = jobTitleResponse.data || [];
//                             if (!jobData || jobData.length === 0) return null;
//                             const jobTitles = jobData.map((job) => job.job_title).filter(Boolean);
//                             const jobStatuses = jobData.map((job) => job.job_status).filter(Boolean);
//                             return {
//                                 ...application,
//                                 job_titles: jobTitles,
//                                 job_status: jobStatuses,
//                                 location: application.district || null,
//                             };
//                         } catch (error) {
//                             console.error(`Error processing job details for potential applicant ${application.id}, filtering out:`, error);
//                             return null;
//                         }
//                     })
//                 );
//                 const confirmedApplicants = results
//                     .filter(result => result.status === 'fulfilled' && result.value)
//                     .map(result => result.value);
//                 setApplicationList(confirmedApplicants);
//             })
//             .catch((error) => {
//                 console.error("Error fetching potential applicants list:", error);
//                 setError("Failed to load applicant data. Please try refreshing the page.");
//                 setApplicationList([]);
//             })
//             .finally(() => {
//                 setIsLoading(false);
//             });
//     };

//     useEffect(() => {
//         fetchApplicants();
//     }, []);

//     const updateJobApplicationStatusInList = (jobApplicationId, newStatus) => {
//         setJobApplications(prev =>
//             prev.map(app =>
//                 app.id === jobApplicationId ? { ...app, job_status: newStatus } : app
//             )
//         );
//         setApplicationList(prevList => prevList.map(applicant => {
//             const relevantJobApp = jobapplications.find(j => j.id === jobApplicationId && applicant.job_titles.includes(j.job_title));
//              if(relevantJobApp) {
//                  const jobIndex = applicant.job_titles.findIndex(title => title === relevantJobApp.job_title);
//                  if (jobIndex !== -1 && applicant.job_status && applicant.job_status.length > jobIndex) {
//                     const newStatuses = [...applicant.job_status];
//                     newStatuses[jobIndex] = newStatus;
//                     return { ...applicant, job_status: newStatuses };
//                  }
//              }
//              return applicant;
//         }));
//     };

//     const filteredApplications = useMemo(() => {
//         // ... (This function remains the same as your previous version)
//         return applicationList.filter((application) => {
//             if (!application) return false;

//             const searchQueryLower = searchQuery.toLowerCase();
//             const filterJobTitleLower = filterJobTitle.toLowerCase();
//             const filterLocationLower = filterLocation.toLowerCase();

//             const matchesSearchQuery = searchQuery
//                 ? ((application.first_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.middle_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.last_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.email || '').toLowerCase().includes(searchQueryLower))
//                 : true;

//             const matchesJobTitle = filterJobTitle
//                 ? application.job_titles?.some(title => title?.toLowerCase().includes(filterJobTitleLower))
//                 : true;

//             const matchesJobStatus = filterJobStatus
//                 ? application.job_status?.some(status => status === filterJobStatus)
//                 : true;

//             const matchesLocation = filterLocation
//                 ? (application.location || '').toLowerCase().includes(filterLocationLower)
//                 : true;

//             return matchesSearchQuery && matchesJobTitle && matchesJobStatus && matchesLocation;
//         });
//     }, [applicationList, searchQuery, filterJobTitle, filterJobStatus, filterLocation]);

//     // --- Pagination Logic (Now dynamic based on recordsPerPage state) ---
//     const indexOfLastRecord = currentPage * recordsPerPage;
//     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//     const currentRecords = filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     const handlePageChange = (pageNumber) => {
//         if (pageNumber >= 1 && pageNumber <= totalPages) {
//             setCurrentPage(pageNumber);
//         }
//     };

//     // NEW: Handler for changing the number of records per page
//     const handleRecordsPerPageChange = (event) => {
//         setRecordsPerPage(Number(event.target.value));
//         setCurrentPage(1); // Reset to the first page to avoid invalid page numbers
//     };

//     const handleViewDetails = async (applicant) => {
//         // ... (This function remains the same)
//         if (!applicant || !applicant.id) return;
//         setSelectedApplicant(applicant);
//         setJobApplications([]);
//         setShowModal(true);

//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//             setJobApplications(response.data || []);
//         } catch (error) {
//             console.error(`Error fetching job apps for ${applicant.id}:`, error);
//             setJobApplications([]);
//             setError(`Could not load job applications for ${applicant.first_name || applicant.email}.`);
//         }
//     };

//     const handleViewApplicantDetails = async (applicantId) => {
//         // ... (This function remains the same)
//         if (!applicantId) return;
//         setSelectedApplicantDetails(null);
//         setShowDetailsModal(true);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//             setSelectedApplicantDetails(response.data);
//         } catch (error) {
//             console.error("Error fetching applicant details:", error);
//             setShowDetailsModal(false);
//             setError("Could not fetch full applicant details.");
//             setSelectedApplicantDetails(null);
//         }
//     };

//     // ... (other handlers and memoized filters remain the same)
//     const uniqueJobTitles = useMemo(() => {
//         const titles = applicationList.flatMap(app => app.job_titles || []);
//         return [...new Set(titles)].sort();
//     }, [applicationList]);

//     const jobStatusOptionsForFilter = useMemo(() => [
//         { value: "", label: "All Statuses" },
//         ...jobStatusOptions.map(opt => ({ value: opt.value, label: opt.label }))
//     ], []);

//     const uniqueLocations = useMemo(() => {
//         const locations = applicationList.map(app => app.location).filter(Boolean);
//         return [...new Set(locations)].sort();
//     }, [applicationList]);

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <main className="main p-3">
//                     <div className="container-fluid">
//                         {/* Alerts remain the same */}
//                         {successMessage && <Alert variant="success" onClose={() => setSuccessMessage("")} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1056, minWidth: '300px', top: '60px' }}><i className="fas fa-check-circle me-2"></i>{successMessage}</Alert>}
//                         {error && <Alert variant="danger" onClose={() => setError(null)} dismissible className="position-fixed top-0 end-0 m-3 shadow" style={{ zIndex: 1055, minWidth: '300px', top: successMessage ? '120px' : '60px' }}><i className="fas fa-exclamation-triangle me-2"></i> {error}</Alert>}

//                         <Card className="shadow-sm mb-4">
//                             <Card.Header className="bg-light d-flex flex-column flex-md-row justify-content-between align-items-md-center p-3">
//                                 <h1 className="h4 gradient-text mb-2 mb-md-0">Applicant Management</h1>
//                             </Card.Header>
//                             <Card.Body className="p-3">
//                                 {/* Search and Filters Row remains the same */}
//                                 <div className="row g-2 mb-3 align-items-center">
//                                     <div className="col-md-3">
//                                         <InputGroup size="sm">
//                                             <InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text>
//                                             <Form.Control type="search" placeholder="Search Name or Email..." value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }} aria-label="Search Applicants" />
//                                         </InputGroup>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterJobTitle} onChange={(e) => { setFilterJobTitle(e.target.value); setCurrentPage(1); }} aria-label="Filter by Job Title">
//                                             <option value="">All Job Titles</option>
//                                             {uniqueJobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterJobStatus} onChange={(e) => { setFilterJobStatus(e.target.value); setCurrentPage(1); }} aria-label="Filter by Job Status">
//                                             {jobStatusOptionsForFilter.map((option) => (<option key={option.value} value={option.value}>{option.label}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterLocation} onChange={(e) => { setFilterLocation(e.target.value); setCurrentPage(1); }} aria-label="Filter by Location (City)">
//                                             <option value="">All Locations</option>
//                                             {uniqueLocations.map((loc) => (<option key={loc} value={loc}>{loc}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-3 col-6 text-md-end">
//                                         <Button variant="outline-secondary" size="sm" onClick={() => { setSearchQuery(''); setFilterJobTitle(''); setFilterJobStatus(''); setFilterLocation(''); setCurrentPage(1); }}>
//                                             <i className="fas fa-undo me-1"></i> Reset Filters
//                                         </Button>
//                                     </div>
//                                 </div>

//                                 {/* Table Section remains the same */}
//                                 <div className="table-responsive">
//                                     <Table striped bordered hover size="sm" className="align-middle">
//                                         <thead className="table-dark">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>Sr. No.</th>
//                                                 <th>First Name</th>
//                                                 <th>Middle Name</th>
//                                                 <th>Last Name</th>
//                                                 <th>Email</th>
//                                                 <th>Phone</th>
//                                                 <th>Location</th>
//                                                 <th className="text-center">Resume</th>
//                                                 <th className="text-center" style={{ minWidth: '100px' }}>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {isLoading ? (
//                                                 <tr><td colSpan="9" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0">Loading Applicants...</p></td></tr>
//                                             ) : currentRecords.length > 0 ? (
//                                                 currentRecords.map((application, index) => (
//                                                     <tr key={application.id}>
//                                                         <td>{indexOfFirstRecord + index + 1}</td>
//                                                         <td>{application.first_name || '-'}</td>
//                                                         <td>{application.middle_name || ''}</td>
//                                                         <td>{application.last_name || '-'}</td>
//                                                         <td>{application.email || '-'}</td>
//                                                         <td>{application.phone || '-'}</td>
//                                                         <td>{application.location || '-'}</td>
//                                                         <td className="text-center">
//                                                             {application.resume ? (<Button variant="outline-primary" size="sm" className="p-1" onClick={() => handleDownloadResume(application.id, application.resume)} title={`Download ${application.resume}`}><i className="fas fa-download fa-fw"></i></Button>) : (<span className="text-muted small">N/A</span>)}
//                                                         </td>
//                                                         <td className="text-center">
//                                                             <Button variant="info" size="sm" className="me-2 p-2 mb-1 " onClick={() => handleViewDetails(application)} title="Check Results & Status"><i className="fas fa-clipboard-check fa-fw"></i></Button>
//                                                             <Button variant="secondary" size="sm" className="p-2" onClick={() => handleViewApplicantDetails(application.id)} title="View Full Applicant Details"><i className="fas fa-user fa-fw"></i></Button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr><td colSpan="9" className="text-center text-muted p-4">{applicationList.length === 0 && !isLoading ? "No applicants found." : "No applicants match the current filters."}</td></tr>
//                                             )}
//                                         </tbody>
//                                     </Table>
//                                 </div>

//                                 {/* --- MODIFIED: Pagination and View Options --- */}
//                                 {filteredApplications.length > 0 && !isLoading && (
//                                     <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-3">
//                                         {/* NEW: Dropdown to select records per page */}
//                                         <div className="d-flex align-items-center">
//                                             <span className="me-2 small text-muted">Show</span>
//                                             <Form.Select
//                                                 size="sm"
//                                                 style={{ width: 'auto' }}
//                                                 value={recordsPerPage}
//                                                 onChange={handleRecordsPerPageChange}
//                                                 aria-label="Select number of records per page"
//                                             >
//                                                 <option value="10">10</option>
//                                                 <option value="20">20</option>
//                                                 <option value="50">50</option>
//                                                 <option value="100">100</option>
//                                             </Form.Select>
//                                             <span className="ms-2 small text-muted">entries</span>
//                                         </div>

//                                         {/* Pagination buttons */}
//                                         {totalPages > 1 && (
//                                             <div className="d-flex justify-content-end flex-wrap">
//                                                 <Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="me-1 mb-1"> « Prev </Button>
//                                                 {[...Array(totalPages).keys()].map((page) => (
//                                                     <Button key={page + 1} variant={currentPage === page + 1 ? "primary" : "outline-primary"} size="sm" className="mx-1 mb-1" onClick={() => handlePageChange(page + 1)}> {page + 1} </Button>
//                                                 ))}
//                                                 <Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="ms-1 mb-1"> Next » </Button>
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>

//                     {/* Modals remain the same */}
//                     {showModal && selectedApplicant && <ApplicantModal applicant={selectedApplicant} jobapplications={jobapplications} setSuccessMessage={setSuccessMessage} updateJobApplication={updateJobApplicationStatusInList} key={`modal-${selectedApplicant.id}-${jobapplications.length}`} />}
//                     {showDetailsModal && <ApplicantDetailsModal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} applicant={selectedApplicantDetails} isLoading={!selectedApplicantDetails && showDetailsModal} />}
//                 </main>
//             </div>
//         </>
//     );
// }

// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css"; // Make sure this path is correct
// import Sidebar from "../Misc/Sidebar"; // Make sure this path is correct
// import DashNavbar from "../Misc/DashNavbar"; // Make sure this path is correct
// import { Table, Alert, Modal, Button, Card, Spinner, InputGroup, Form } from "react-bootstrap";
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "./ApplicantDetailsModal"; // Make sure this path is correct

// // --- Define Job Status Options Globally ---
// const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" }, // Added text-dark
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
// ];

// // --- ApplicantModal Component (Enhanced UI/UX) ---
// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
// }) => {
//     // jobStatusOptions is now defined outside, no need to redefine here

//     const [show, setShow] = useState(false);
//     const [personalityData, setPersonalityData] = useState([]);
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
//     const chartRefs = useRef({});
//     const [allSubmittedAnswers, setAllSubmittedAnswers] = useState(null);
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
//     const [currentJobId, setCurrentJobId] = useState(null);
//     const [jobQuestions, setJobQuestions] = useState(null);
//     const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);

//     const handleStatusChange = (id, newStatus) => {
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus })
//             .then(() => {
//                 setSuccessMessage("Job status updated successfully");
//                 updateJobApplication(id, newStatus);
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error);
//                 // Consider showing an error alert here
//             });
//     };

//     useEffect(() => {
//         setShow(false);
//         const timer = setTimeout(() => {
//             if (applicant && jobapplications) {
//                 setShow(true);
//             }
//         }, 100);

//         return () => {
//             clearTimeout(timer);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//             setCurrentJobId(null);
//             Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//             chartRefs.current = {};
//         };
//     }, [applicant, jobapplications]);

//     useEffect(() => {
//         if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant]);

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
//             const personalityResponse = await axios.get(personalityUrl);
//             const fetchedPersonalityData = personalityResponse.data || [];
//             setPersonalityData(fetchedPersonalityData);

//             if (fetchedPersonalityData.length > 0) {
//                 const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicantId}/`;
//                 const jobTitleResponse = await axios.get(jobTitleUrl);
//                 const jobTitlesMap = (jobTitleResponse.data || []).reduce((acc, job) => {
//                     if (job.job_id) acc[job.job_id] = job.job_title;
//                     return acc;
//                 }, {});
//                 const jobTitles = fetchedPersonalityData.map(data => jobTitlesMap[data.job_id] || `Job ID: ${data.job_id}`);
//                 setPersonalityJobTitles(jobTitles);
//             } else {
//                 setPersonalityJobTitles([]);
//             }

//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//         }
//     };

//     useEffect(() => {
//         Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//         chartRefs.current = {};

//         if (Array.isArray(personalityData)) {
//             personalityData.forEach((data, index) => {
//                 const chartId = `personalityChart-${applicant?.id}-${index}`;
//                 const chartElement = document.getElementById(chartId);
//                 if (chartElement && data && data.job_id) {
//                     try {
//                         const newChart = createDonutChart(data, chartId, data.status);
//                         if (newChart) {
//                             chartRefs.current[index] = newChart;
//                         }
//                     } catch (chartError) {
//                         console.error("Error creating chart:", chartError, "for data:", data);
//                     }
//                 }
//             });
//         }
//     }, [personalityData, applicant?.id]);

//     const onHide = () => {
//         setShow(false);
//     };

//     const createDonutChart = (data, chartId, status) => {
//         if (!data || typeof data.correct_count !== 'number' || typeof data.all_count !== 'number' || typeof data.wrong_count !== 'number' || data.all_count === 0) {
//             console.warn(`Invalid chart data for ${chartId}`, data);
//             const ctx = document.getElementById(chartId)?.getContext("2d");
//             if (ctx) {
//                 ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
//                 ctx.font = "12px Arial";
//                 ctx.textAlign = "center";
//                 ctx.fillText("Data unavailable", ctx.canvas.width / 2, ctx.canvas.height / 2);
//             }
//             return null;
//         }
//         const { correct_count, all_count, wrong_count } = data;
//         const ctx = document.getElementById(chartId)?.getContext("2d");

//         if (!ctx) {
//             console.error(`Canvas element with id ${chartId} not found`);
//             return null;
//         }

//         return new Chart(ctx, {
//             type: 'doughnut',
//             data: {
//                 labels: [`Correct (${correct_count})`, `Wrong (${wrong_count})`],
//                 datasets: [{
//                     data: [correct_count, wrong_count],
//                     backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'],
//                     borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'],
//                     borderWidth: 1,
//                 }]
//             },
//             options: {
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 cutout: '60%',
//                 plugins: {
//                     legend: { display: true, position: 'bottom', labels: { boxWidth: 10, padding: 15, font: { size: 10 } } },
//                     title: { display: false },
//                     tooltip: {
//                         callbacks: {
//                             label: function (context) {
//                                 let label = context.label || '';
//                                 if (label) { label += ': '; }
//                                 const value = context.parsed;
//                                 const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                                 const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%';
//                                 label += `${value} (${percentage})`;
//                                 return label;
//                             }
//                         }
//                     }
//                 }
//             }
//         });
//     };

//     const handleShowSubmittedAnswers = async (applicantId, jobId) => {
//         setCurrentJobId(jobId);
//         setFilteredSubmittedAnswers(null);
//         setJobQuestions(null);
//         setAllSubmittedAnswers(null);
//         setIsLoadingAnswers(true);

//         try {
//             const [answersResponse, questionResponse] = await Promise.all([
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`),
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${jobId}/`)
//             ]);
//             setAllSubmittedAnswers(answersResponse.data);
//             setJobQuestions(questionResponse.data || []);
//         } catch (error) {
//             console.error("Error fetching submitted answers or questions:", error);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//         } finally {
//             setIsLoadingAnswers(false);
//         }
//     };

//     useEffect(() => {
//         if (allSubmittedAnswers && currentJobId !== null) {
//             const filtered = allSubmittedAnswers.find(item => item.job_id === currentJobId);
//             setFilteredSubmittedAnswers(filtered || null);
//         } else {
//             setFilteredSubmittedAnswers(null);
//         }
//     }, [allSubmittedAnswers, currentJobId]);

//     return (
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
//             <Modal.Header closeButton>
//                 <Modal.Title className="gradient-text">
//                     {applicant?.first_name || applicant?.email || 'Applicant'} Details
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-4">
//                 {/* --- Job Applications Section --- */}
//                 <Card className="mb-4 shadow-sm">
//                     <Card.Header className="bg-light">
//                         <h5 className="mb-0">Job Applications</h5>
//                     </Card.Header>
//                     <Card.Body className="p-0">
//                         <Table striped bordered hover responsive size="sm" className="mb-0">
//                             <thead className="table-light">
//                                 <tr>
//                                     <th style={{ width: '40%' }}>Job Title</th>
//                                     <th style={{ width: '40%' }}>Status</th>
//                                     <th style={{ width: '20%' }}>Applied On</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobapplications && jobapplications.length > 0 ? (
//                                     jobapplications.map((jobApp) => {
//                                         // Use the globally defined jobStatusOptions
//                                         const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
//                                         return (
//                                             <tr key={jobApp.id}>
//                                                 <td>{jobApp.job_title || 'N/A'}</td>
//                                                 <td>
//                                                     <Form.Select
//                                                         size="sm"
//                                                         className={`${statusOption?.bgColor || 'bg-light'}`}
//                                                         value={jobApp.job_status}
//                                                         onChange={(e) => handleStatusChange(jobApp.id, e.target.value)}
//                                                         aria-label={`Job status for ${jobApp.job_title}`}
//                                                         style={{ minWidth: '150px', color: statusOption?.bgColor.includes('text-dark') ? '#000' : '#fff' }} // Updated color logic slightly
//                                                     >
//                                                         {/* Use the globally defined jobStatusOptions */}
//                                                         {jobStatusOptions.map((option) => (
//                                                             <option key={option.value} value={option.value} style={{ backgroundColor: '#fff', color: '#000' }}>
//                                                                 {option.label}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </td>
//                                                 <td>{jobApp.applied_date ? new Date(jobApp.applied_date).toLocaleDateString() : 'N/A'}</td>
//                                             </tr>
//                                         );
//                                     })
//                                 ) : (
//                                     <tr><td colSpan="3" className="text-center text-muted p-3">No job applications found.</td></tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                     </Card.Body>
//                 </Card>

//                 {/* --- Personality Assessments Section --- */}
//                 <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
//                 <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
//                     {Array.isArray(personalityData) && personalityData.length > 0 ? (
//                         personalityData.map((data, index) => (
//                             data && data.job_id ? (
//                                 <Card key={`${data.job_id}-${index}`} className="text-center shadow-sm" style={{ minWidth: '260px', maxWidth: '300px', flex: '1 1 260px' }}>
//                                     <Card.Header className="bg-light">
//                                         <Card.Title as="h6" className="mb-0 text-truncate">{personalityJobTitles[index] || `Assessment for Job ID: ${data.job_id}`}</Card.Title>
//                                     </Card.Header>
//                                     <Card.Body className="d-flex flex-column p-2">
//                                         <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}>
//                                             <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
//                                         </div>
//                                         <div className="mt-auto">
//                                             <p className="mb-1">
//                                                 <strong>Score:</strong> <b className="gradient-text">{typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}</b>
//                                             </p>
//                                             <p className="mb-2">
//                                                 <strong>Result:</strong> {data.result === 'T' ? <span className="badge bg-success">Passed</span> : <span className="badge bg-danger">Failed</span>}
//                                             </p>
//                                             <Button
//                                                 variant="outline-info"
//                                                 size="sm"
//                                                 onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id)}
//                                                 disabled={isLoadingAnswers && currentJobId === data.job_id}
//                                             >
//                                                 {isLoadingAnswers && currentJobId === data.job_id ? (
//                                                     <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
//                                                 ) : (
//                                                     <i className="fas fa-receipt me-1"></i>
//                                                 )}
//                                                 View Answers
//                                             </Button>
//                                         </div>
//                                     </Card.Body>
//                                 </Card>
//                             ) : null
//                         ))
//                     ) : (
//                         <p className="text-center text-muted w-100">No personality assessment data available.</p>
//                     )}
//                 </div>

//                 {/* --- Submitted Answers Section (Conditional) --- */}
//                 {currentJobId && (
//                     <div className="mt-4">
//                         <Card className="shadow-sm">
//                             <Card.Header className="bg-light">
//                                 <h5 className="mb-0">Submitted Answers for Job: {personalityJobTitles[personalityData.findIndex(p => p.job_id === currentJobId)] || `ID ${currentJobId}`}</h5>
//                             </Card.Header>
//                             <Card.Body>
//                                 {isLoadingAnswers ? (
//                                     <div className="text-center p-4">
//                                         <Spinner animation="border" variant="primary" />
//                                         <p className="mt-2 mb-0">Loading answers...</p>
//                                     </div>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length > 0 ? (
//                                     <Table striped bordered hover responsive size="sm">
//                                         <thead className="table-light">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>#</th>
//                                                 <th style={{ width: '45%' }}>Question</th>
//                                                 <th style={{ width: '35%' }}>Your Answer(s)</th>
//                                                 <th style={{ width: '15%' }} className="text-center">Result</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {jobQuestions.map((question, index) => {
//                                                 const submittedAnswer = filteredSubmittedAnswers.selected_answers?.find(
//                                                     ans => ans.question_id === question.id
//                                                 );

//                                                 let yourAnswerDisplay = <i className="text-muted">Not Answered</i>;
//                                                 let resultDisplay = <span className="badge bg-secondary">N/A</span>;
//                                                 let resultText = "Not Answered";

//                                                 const isMultipleChoice = question.answers && question.answers.length > 0 && question.correct_answer_index !== null && question.correct_answer_index !== undefined;

//                                                 if (submittedAnswer) {
//                                                     if (isMultipleChoice && submittedAnswer.selected_answer_index !== null && submittedAnswer.selected_answer_index !== undefined) {
//                                                         const selectedIndex = submittedAnswer.selected_answer_index;
//                                                         const correctIndex = question.correct_answer_index;

//                                                         yourAnswerDisplay = (
//                                                             <ul className="list-unstyled mb-0 small">
//                                                                 {question.answers.map((answerText, ansIndex) => (
//                                                                     <li key={ansIndex}
//                                                                         className={`${selectedIndex === ansIndex ? 'fw-bold' : ''} ${correctIndex === ansIndex ? 'text-success' : (selectedIndex === ansIndex && selectedIndex !== correctIndex ? 'text-danger' : '')}`}
//                                                                         title={correctIndex === ansIndex ? 'Correct Answer' : (selectedIndex === ansIndex ? 'Selected Answer' : '')}
//                                                                     >
//                                                                         {selectedIndex === ansIndex && <i className="fas fa-check text-primary me-1"></i>}
//                                                                         {correctIndex === ansIndex && <i className="fas fa-star text-success me-1" style={{ fontSize: '0.7em' }}></i>}
//                                                                         {answerText}
//                                                                     </li>
//                                                                 ))}
//                                                             </ul>
//                                                         );

//                                                         if (selectedIndex === correctIndex) {
//                                                             resultDisplay = <span className="badge bg-success">Correct</span>; resultText = "Correct";
//                                                         } else {
//                                                             resultDisplay = <span className="badge bg-danger">Wrong</span>; resultText = "Wrong";
//                                                         }
//                                                     } else if (submittedAnswer.selected_answer_text !== null && submittedAnswer.selected_answer_text !== undefined) {
//                                                         yourAnswerDisplay = <span className="fst-italic">{submittedAnswer.selected_answer_text}</span>;
//                                                         resultDisplay = <span className="badge bg-info text-dark">Manual Check</span>; resultText = "Manual Check";
//                                                     }
//                                                 }

//                                                 let rowClass = '';
//                                                 if (resultText === "Correct") rowClass = 'table-success-light';
//                                                 else if (resultText === "Wrong") rowClass = 'table-danger-light';
//                                                 else if (resultText === "Not Answered") rowClass = 'table-warning-light';

//                                                 return (
//                                                     <tr key={question.id || index} className={rowClass}>
//                                                         <td className="text-muted">{index + 1}</td>
//                                                         <td className="small">{question.question_text}</td>
//                                                         <td>{yourAnswerDisplay}</td>
//                                                         <td className="text-center align-middle">{resultDisplay}</td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </Table>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length === 0 ? (
//                                     <p className="text-center text-muted p-3">No questions were found for this assessment.</p>
//                                 ) : !filteredSubmittedAnswers ? (
//                                     <p className="text-center text-muted p-3">Could not load answers for this assessment.</p>
//                                 ) : null}
//                             </Card.Body>
//                         </Card>
//                     </div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light">
//                 <Button variant="secondary" onClick={onHide}>Close</Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };

// // --- Utility Functions (Outside Components) ---
// const handleDownloadResume = async (applicantId, resumeFileName) => {
//     if (!applicantId || !resumeFileName) return;
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, {
//             responseType: "arraybuffer",
//         });
//         const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/octet-stream" });
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         const safeFileName = resumeFileName.replace(/[^a-zA-Z0-9._-]/g, '_');
//         link.setAttribute("download", safeFileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error("Error downloading resume:", error);
//         alert("Failed to download resume. Please check console for details.");
//     }
// };

// // --- Main Component: Jobapplicationresult (Enhanced UI/UX) ---
// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const recordsPerPage = 10;
//     const [jobapplications, setJobApplications] = useState([]); // For the modal
//     const [showModal, setShowModal] = useState(false);
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedApplicant, setSelectedApplicant] = useState(null); // For ApplicantModal
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null); // For ApplicantDetailsModal
//     const [filterJobTitle, setFilterJobTitle] = useState("");
//     const [filterJobStatus, setFilterJobStatus] = useState(""); // This will hold the value like "applied", "selected" etc.
//     const [filterLocation, setFilterLocation] = useState(""); // City filter
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [isDownloadingBank, setIsDownloadingBank] = useState(false);

//     const fetchApplicants = () => {
//         setIsLoading(true);
//         setError(null);
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants_not_offered/")
//             .then(async (response) => {
//                 const potentialApplicants = response.data || [];
//                 const results = await Promise.allSettled(
//                     potentialApplicants.map(async (application) => {
//                         if (!application || !application.id) return null;

//                         try {
//                             const jobTitleResponse = await axios.get(
//                                 `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}/`
//                             );
//                             const jobData = jobTitleResponse.data || [];

//                             if (!jobData || jobData.length === 0) {
//                                 return null; // Filter out users with no job applications
//                             }

//                             const jobTitles = jobData.map((job) => job.job_title).filter(Boolean);
//                             const jobStatuses = jobData.map((job) => job.job_status).filter(Boolean);

//                             return {
//                                 ...application,
//                                 job_titles: jobTitles,
//                                 job_status: jobStatuses, // Store raw status values
//                                 location: application.district || null,
//                             };
//                         } catch (error) {
//                             console.error(`Error processing job details for potential applicant ${application.id}, filtering out:`, error);
//                             return null;
//                         }
//                     })
//                 );

//                 const confirmedApplicants = results
//                     .filter(result => result.status === 'fulfilled' && result.value)
//                     .map(result => result.value);

//                 setApplicationList(confirmedApplicants);
//             })
//             .catch((error) => {
//                 console.error("Error fetching potential applicants list:", error);
//                 setError("Failed to load applicant data. Please try refreshing the page.");
//                 setApplicationList([]);
//             })
//             .finally(() => {
//                 setIsLoading(false);
//             });
//     };

//     useEffect(() => {
//         fetchApplicants();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const updateJobApplicationStatusInList = (jobApplicationId, newStatus) => {
//         setJobApplications(prev =>
//             prev.map(app =>
//                 app.id === jobApplicationId ? { ...app, job_status: newStatus } : app
//             )
//         );

//         // Update the main applicationList (more robust approach might be needed depending on data structure)
//         setApplicationList(prevList => prevList.map(applicant => {
//             const relevantJobApp = jobapplications.find(j => j.id === jobApplicationId && applicant.job_titles.includes(j.job_title)); // Find if this applicant had the job
//              if(relevantJobApp) {
//                 // Find the index of the specific job application's status to update
//                  const jobIndex = applicant.job_titles.findIndex(title => title === relevantJobApp.job_title); // Assumes titles are unique per applicant for simplicity here
//                  if (jobIndex !== -1 && applicant.job_status && applicant.job_status.length > jobIndex) {
//                     const newStatuses = [...applicant.job_status];
//                     newStatuses[jobIndex] = newStatus;
//                     return { ...applicant, job_status: newStatuses };
//                  }
//              }
//              return applicant;
//         }));
//          // Alternative: Consider refetching if the above logic is too complex/unreliable
//          // fetchApplicants();
//     };

//     // Memoized filtering logic
//     const filteredApplications = useMemo(() => {
//         return applicationList.filter((application) => {
//             if (!application) return false;

//             const searchQueryLower = searchQuery.toLowerCase();
//             const filterJobTitleLower = filterJobTitle.toLowerCase();
//             // filterJobStatus already holds the value like "applied", "selected"
//             const filterLocationLower = filterLocation.toLowerCase();

//             const matchesSearchQuery = searchQuery
//                 ? ((application.first_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.middle_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.last_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.email || '').toLowerCase().includes(searchQueryLower))
//                 : true;

//             const matchesJobTitle = filterJobTitle
//                 ? application.job_titles?.some(title => title?.toLowerCase().includes(filterJobTitleLower))
//                 : true;

//             // Match against the raw status values stored in application.job_status
//             const matchesJobStatus = filterJobStatus
//                 ? application.job_status?.some(status => status === filterJobStatus)
//                 : true;

//             const matchesLocation = filterLocation
//                 ? (application.location || '').toLowerCase().includes(filterLocationLower)
//                 : true;

//             return matchesSearchQuery && matchesJobTitle && matchesJobStatus && matchesLocation;
//         });
//     }, [applicationList, searchQuery, filterJobTitle, filterJobStatus, filterLocation]);

//     const indexOfLastRecord = currentPage * recordsPerPage;
//     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//     const currentRecords = filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     const handlePageChange = (pageNumber) => {
//         if (pageNumber >= 1 && pageNumber <= totalPages) {
//             setCurrentPage(pageNumber);
//         }
//     };

//     const handleViewDetails = async (applicant) => {
//         if (!applicant || !applicant.id) return;
//         setSelectedApplicant(applicant);
//         setJobApplications([]);
//         setShowModal(true);

//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//             setJobApplications(response.data || []);
//         } catch (error) {
//             console.error(`Error fetching job apps for ${applicant.id}:`, error);
//             setJobApplications([]);
//             setError(`Could not load job applications for ${applicant.first_name || applicant.email}.`);
//         }
//     };

//     const handleViewApplicantDetails = async (applicantId) => {
//         if (!applicantId) return;
//         setSelectedApplicantDetails(null);
//         setShowDetailsModal(true);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//             setSelectedApplicantDetails(response.data);
//         } catch (error) {
//             console.error("Error fetching applicant details:", error);
//             setShowDetailsModal(false);
//             setError("Could not fetch full applicant details.");
//             setSelectedApplicantDetails(null);
//         }
//     };

//     const handleDownloadResumeBank = async () => {
//         setError(null);
//         setIsDownloadingBank(true);
//         try {
//             const response = await axios.get('https://raasbackend.vetrinahealthcare.com/download-resume-bank/', {
//                 responseType: 'blob',
//             });
//             const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'applicant_data.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//         } catch (error) {
//             console.error("Error downloading resume bank:", error);
//             let errorMsg = "Failed to download the Applicant Data file.";
//             if (error.response?.status === 404) {
//                 errorMsg = "Error: Applicant Data file not found on server.";
//             } else if (error.request) {
//                 errorMsg = "Network error: Could not connect to server.";
//             }
//             setError(errorMsg);
//         } finally {
//             setIsDownloadingBank(false);
//         }
//     };

//     // --- Dynamic options for filters (Memoized) ---
//     const uniqueJobTitles = useMemo(() => {
//         const titles = applicationList.flatMap(app => app.job_titles || []);
//         return [...new Set(titles)].sort();
//     }, [applicationList]);

//     // Use the globally defined jobStatusOptions for the filter dropdown
//     const jobStatusOptionsForFilter = useMemo(() => [
//         { value: "", label: "All Statuses" }, // Add the "All" option
//         // Use the global definition
//         ...jobStatusOptions.map(opt => ({ value: opt.value, label: opt.label }))
//     ], []); // No dependency needed as jobStatusOptions is constant

//     const uniqueLocations = useMemo(() => {
//         const locations = applicationList.map(app => app.location).filter(Boolean);
//         return [...new Set(locations)].sort();
//     }, [applicationList]);

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <main className="main p-3">
//                     <div className="container-fluid">
//                         {/* --- Fixed Alerts --- */}
//                         {successMessage && (
//                             <Alert
//                                 variant="success"
//                                 onClose={() => setSuccessMessage("")}
//                                 dismissible
//                                 className="position-fixed top-0 end-0 m-3 shadow"
//                                 style={{ zIndex: 1056, minWidth: '300px', top: '60px' }}
//                             >
//                                 <i className="fas fa-check-circle me-2"></i>{successMessage}
//                             </Alert>
//                         )}
//                         {error && (
//                             <Alert
//                                 variant="danger"
//                                 onClose={() => setError(null)}
//                                 dismissible
//                                 className="position-fixed top-0 end-0 m-3 shadow"
//                                 style={{ zIndex: 1055, minWidth: '300px', top: successMessage ? '120px' : '60px' }}
//                             >
//                                 <i className="fas fa-exclamation-triangle me-2"></i> {error}
//                             </Alert>
//                         )}

//                         <Card className="shadow-sm mb-4">
//                             <Card.Header className="bg-light d-flex flex-column flex-md-row justify-content-between align-items-md-center p-3">
//                                 <h1 className="h4 gradient-text mb-2 mb-md-0">Applicant Management</h1>
//                                 {/* <Button
//                                     variant="success"
//                                     size="sm"
//                                     onClick={handleDownloadResumeBank}
//                                     disabled={isDownloadingBank || isLoading}
//                                 >
//                                     {isDownloadingBank ? (
//                                         <>
//                                             <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
//                                             <span className="visually-hidden">Loading...</span> Downloading...
//                                         </>
//                                     ) : (
//                                         <><i className="fas fa-file-excel me-2"></i> Download Applicant Data (XLSX)</>
//                                     )}
//                                 </Button> */}
//                             </Card.Header>
//                             <Card.Body className="p-3">
//                                 {/* --- Search and Filters Row --- */}
//                                 <div className="row g-2 mb-3 align-items-center">
//                                     <div className="col-md-3">
//                                         <InputGroup size="sm">
//                                             <InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text>
//                                             <Form.Control
//                                                 type="search"
//                                                 placeholder="Search Name or Email..."
//                                                 value={searchQuery}
//                                                 onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
//                                                 aria-label="Search Applicants"
//                                             />
//                                         </InputGroup>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterJobTitle} onChange={(e) => { setFilterJobTitle(e.target.value); setCurrentPage(1); }} aria-label="Filter by Job Title">
//                                             <option value="">All Job Titles</option>
//                                             {uniqueJobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                          {/* Use the generated options for the filter */}
//                                         <Form.Select size="sm" value={filterJobStatus} onChange={(e) => { setFilterJobStatus(e.target.value); setCurrentPage(1); }} aria-label="Filter by Job Status">
//                                             {jobStatusOptionsForFilter.map((option) => (
//                                                 <option key={option.value} value={option.value}>{option.label}</option>
//                                             ))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterLocation} onChange={(e) => { setFilterLocation(e.target.value); setCurrentPage(1); }} aria-label="Filter by Location (City)">
//                                             <option value="">All Locations</option>
//                                             {uniqueLocations.map((loc) => (<option key={loc} value={loc}>{loc}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-3 col-6 text-md-end">
//                                         <Button variant="outline-secondary" size="sm" onClick={() => { setSearchQuery(''); setFilterJobTitle(''); setFilterJobStatus(''); setFilterLocation(''); setCurrentPage(1); }}>
//                                             <i className="fas fa-undo me-1"></i> Reset Filters
//                                         </Button>
//                                     </div>
//                                 </div>

//                                                                {/* --- Table Section --- */}
//                                 <div className="table-responsive">
//                                     <Table striped bordered hover size="sm" className="align-middle">
//                                         <thead className="table-dark">
//                                             <tr>
//                                                 {/* MODIFIED: Added Sr. No. column */}
//                                                 <th style={{ width: '5%' }}>Sr. No.</th>
//                                                 <th>First Name</th>
//                                                 <th>Middle Name</th>
//                                                 <th>Last Name</th>
//                                                 <th>Email</th>
//                                                 <th>Phone</th>
//                                                 <th>Location</th>
//                                                 <th className="text-center">Resume</th>
//                                                 <th className="text-center" style={{ minWidth: '100px' }}>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {isLoading ? (
//                                                 // MODIFIED: Increased colSpan to 9
//                                                 <tr><td colSpan="9" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0">Loading Applicants...</p></td></tr>
//                                             ) : currentRecords.length > 0 ? (
//                                                 // MODIFIED: Added index to map and a new <td> for the serial number
//                                                 currentRecords.map((application, index) => (
//                                                     <tr key={application.id}>
//                                                         <td>{indexOfFirstRecord + index + 1}</td>
//                                                         <td>{application.first_name || '-'}</td>
//                                                         <td>{application.middle_name || ''}</td>
//                                                         <td>{application.last_name || '-'}</td>
//                                                         <td>{application.email || '-'}</td>
//                                                         <td>{application.phone || '-'}</td>
//                                                         <td>{application.location || '-'}</td>
//                                                         <td className="text-center">
//                                                             {application.resume ? (
//                                                                 <Button variant="outline-primary" size="sm" className="p-1" onClick={() => handleDownloadResume(application.id, application.resume)} title={`Download ${application.resume}`}>
//                                                                     <i className="fas fa-download fa-fw"></i>
//                                                                 </Button>
//                                                             ) : (<span className="text-muted small">N/A</span>)}
//                                                         </td>
//                                                         <td className="text-center">
//                                                             <Button variant="info" size="sm" className="me-2 p-2 mb-1 " onClick={() => handleViewDetails(application)} title="Check Results & Status">
//                                                                 <i className="fas fa-clipboard-check fa-fw"></i>
//                                                             </Button>
//                                                             <Button variant="secondary" size="sm" className="p-2" onClick={() => handleViewApplicantDetails(application.id)} title="View Full Applicant Details">
//                                                                 <i className="fas fa-user fa-fw"></i>
//                                                             </Button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 // MODIFIED: Increased colSpan to 9
//                                                 <tr><td colSpan="9" className="text-center text-muted p-4">{applicationList.length === 0 && !isLoading ? "No applicants found." : "No applicants match the current filters."}</td></tr>
//                                             )}
//                                         </tbody>
//                                     </Table>
//                                 </div>

//                                 {/* --- Pagination --- */}
//                                 {totalPages > 1 && !isLoading && (
//                                     <div className="d-flex justify-content-center mt-3 flex-wrap">
//                                         <Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="me-1 mb-1"> « Prev </Button>
//                                         {[...Array(totalPages).keys()].map((page) => (
//                                             <Button key={page + 1} variant={currentPage === page + 1 ? "primary" : "outline-primary"} size="sm" className="mx-1 mb-1" onClick={() => handlePageChange(page + 1)}> {page + 1} </Button>
//                                         ))}
//                                         <Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="ms-1 mb-1"> Next » </Button>
//                                     </div>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>

//                     {/* --- Modals --- */}
//                     {showModal && selectedApplicant && (
//                         <ApplicantModal
//                             applicant={selectedApplicant}
//                             jobapplications={jobapplications}
//                             setSuccessMessage={setSuccessMessage}
//                             updateJobApplication={updateJobApplicationStatusInList}
//                             key={`modal-${selectedApplicant.id}-${jobapplications.length}`}
//                         />
//                     )}

//                     {showDetailsModal && (
//                         <ApplicantDetailsModal
//                             show={showDetailsModal}
//                             onHide={() => setShowDetailsModal(false)}
//                             applicant={selectedApplicantDetails}
//                             isLoading={!selectedApplicantDetails && showDetailsModal}
//                         />
//                     )}

//                 </main>
//             </div>
//         </>
//     );
// }

// import React, { useState, useEffect, useRef, useMemo } from "react"; // Added useMemo
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css"; // Make sure this path is correct
// import Sidebar from "../Misc/Sidebar"; // Make sure this path is correct
// import DashNavbar from "../Misc/DashNavbar"; // Make sure this path is correct
// import { Table, Alert, Modal, Button, Card, Spinner, InputGroup, Form } from "react-bootstrap"; // Added InputGroup, Form
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "./ApplicantDetailsModal"; // Make sure this path is correct
// // Removed Spinner import from here as it's already imported from react-bootstrap

// // --- ApplicantModal Component (Enhanced UI/UX) ---
// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
// }) => {
//     const jobStatusOptions = [
//         { value: "applied", label: "Applied", bgColor: "bg-info" },
//         { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//         { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark"}, // Added text-dark for better contrast on warning
//         { value: "selected", label: "Selected", bgColor: "bg-success" },
//         { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
//     ];
//     const [show, setShow] = useState(false);
//     const [personalityData, setPersonalityData] = useState([]);
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
//     const chartRefs = useRef({}); // Use object for refs keyed by index/id
//     const [allSubmittedAnswers, setAllSubmittedAnswers] = useState(null);
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
//     const [currentJobId, setCurrentJobId] = useState(null);
//     const [jobQuestions, setJobQuestions] = useState(null);
//     const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);

//     const handleStatusChange = (id, newStatus) => {
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus })
//             .then(() => {
//                 setSuccessMessage("Job status updated successfully");
//                 updateJobApplication(id, newStatus); // Update state in parent component
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error);
//                 // Consider showing an error alert here
//             });
//     };

//     // Effect to control modal visibility and initial state reset
//     useEffect(() => {
//         setShow(false); // Reset show state first
//         const timer = setTimeout(() => {
//             if (applicant && jobapplications) { // Only show if data is potentially ready
//                  setShow(true);
//             }
//         }, 100); // Short delay

//         return () => {
//             clearTimeout(timer);
//             // Cleanup when modal is about to hide or props change forcing re-eval
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//             setCurrentJobId(null);
//             // Destroy charts safely
//             Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//             chartRefs.current = {};
//         };
//     }, [applicant, jobapplications]); // Re-evaluate when applicant or jobapplications change

//     // Effect to fetch data when the modal becomes visible
//     useEffect(() => {
//         if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant]); // Depend on show and applicant

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
//             const personalityResponse = await axios.get(personalityUrl);
//             const fetchedPersonalityData = personalityResponse.data || [];
//             setPersonalityData(fetchedPersonalityData);

//             // Fetch corresponding job titles only if personality data exists
//             if (fetchedPersonalityData.length > 0) {
//                  const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicantId}/`;
//                  const jobTitleResponse = await axios.get(jobTitleUrl);
//                  // Simple mapping assuming order matches - adjust if backend provides job_title in personality results
//                  const jobTitles = jobTitleResponse.data.map((job) => job.job_title);
//                  setPersonalityJobTitles(jobTitles);
//             } else {
//                  setPersonalityJobTitles([]);
//             }

//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//         }
//     };

//     // Effect to create/update charts when personalityData changes
//     useEffect(() => {
//         // Destroy existing charts first for the current set of data
//         Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//         chartRefs.current = {}; // Clear the ref object

//         if (Array.isArray(personalityData)) {
//             personalityData.forEach((data, index) => {
//                 const chartId = `personalityChart-${applicant?.id}-${index}`; // More unique ID
//                 const chartElement = document.getElementById(chartId);
//                 if (chartElement && data && data.job_id) { // Ensure canvas exists and data is valid
//                     try {
//                         const newChart = createDonutChart(data, chartId, data.status);
//                         if (newChart) {
//                             chartRefs.current[index] = newChart; // Store by index
//                         }
//                     } catch (chartError) {
//                         console.error("Error creating chart:", chartError, "for data:", data);
//                     }
//                 }
//             });
//         }
//         // Cleanup is handled in the visibility effect
//     }, [personalityData, applicant?.id]); // Depend on data and applicant ID for unique chart IDs


//     const onHide = () => {
//         setShow(false); // Trigger cleanup effect
//     };

//     const createDonutChart = (data, chartId, status) => {
//          if (!data || typeof data.correct_count !== 'number' || typeof data.all_count !== 'number' || typeof data.wrong_count !== 'number' || data.all_count === 0) {
//              console.warn(`Invalid chart data for ${chartId}`, data);
//              // Optionally render a placeholder or message on the canvas
//              const ctx = document.getElementById(chartId)?.getContext("2d");
//              if (ctx) {
//                  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
//                  ctx.font = "12px Arial";
//                  ctx.textAlign = "center";
//                  ctx.fillText("Data unavailable", ctx.canvas.width / 2, ctx.canvas.height / 2);
//              }
//              return null;
//         }
//         const { correct_count, all_count, wrong_count } = data;
//         const ctx = document.getElementById(chartId)?.getContext("2d");

//         if (!ctx) {
//             console.error(`Canvas element with id ${chartId} not found`);
//             return null;
//         }

//         const correctPercentage = ((correct_count / all_count) * 100).toFixed(1);
//         const wrongPercentage = ((wrong_count / all_count) * 100).toFixed(1);

//         return new Chart(ctx, {
//             type: 'doughnut',
//             data: {
//                 labels: [`Correct (${correct_count})`, `Wrong (${wrong_count})`],
//                 datasets: [{
//                     data: [correct_count, wrong_count],
//                     backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'], // Bootstrap success/danger slightly transparent
//                     borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'],
//                     borderWidth: 1,
//                 }]
//             },
//             options: {
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 cutout: '60%', // Adjust doughnut thickness
//                 plugins: {
//                     legend: {
//                         display: true,
//                         position: 'bottom',
//                         labels: { boxWidth: 10, padding: 15, font: { size: 10 } }
//                     },
//                     title: { display: false }, // Title removed, info shown elsewhere
//                     tooltip: {
//                         callbacks: {
//                             label: function(context) {
//                                 let label = context.label || '';
//                                 if (label) { label += ': '; }
//                                 // Calculate percentage for tooltip dynamically
//                                 const value = context.parsed;
//                                 const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                                 const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%';
//                                 label += `${value} (${percentage})`;
//                                 return label;
//                             }
//                         }
//                     }
//                 }
//             }
//         });
//     };

//     const handleShowSubmittedAnswers = async (applicantId, jobId) => {
//         setCurrentJobId(jobId);
//         setFilteredSubmittedAnswers(null);
//         setJobQuestions(null);
//         setAllSubmittedAnswers(null);
//         setIsLoadingAnswers(true); // Start loading indicator

//         try {
//             // Fetch both concurrently
//             const [answersResponse, questionResponse] = await Promise.all([
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`),
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${jobId}/`)
//             ]);

//             setAllSubmittedAnswers(answersResponse.data);
//             setJobQuestions(questionResponse.data || []); // Ensure array

//             // Filtering happens in the useEffect hook
//         } catch (error) {
//             console.error("Error fetching submitted answers or questions:", error);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//             // Optionally show an error message to the user
//         } finally {
//              setIsLoadingAnswers(false); // Stop loading indicator
//         }
//     };

//     // Effect to filter answers when data or jobId changes
//     useEffect(() => {
//         if (allSubmittedAnswers && currentJobId !== null) {
//             const filtered = allSubmittedAnswers.find(item => item.job_id === currentJobId);
//             setFilteredSubmittedAnswers(filtered || null);
//         } else {
//             setFilteredSubmittedAnswers(null);
//         }
//     }, [allSubmittedAnswers, currentJobId]);

//     return (
//         // Added scrollable, increased size to xl
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
//             <Modal.Header closeButton>
//                 <Modal.Title className="gradient-text">
//                     {applicant?.first_name || applicant?.email || 'Applicant'} Details {/* Show name or email */}
//                  </Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-4"> {/* Added padding */}
//                 {/* --- Job Applications Section --- */}
//                  <Card className="mb-4 shadow-sm">
//                      <Card.Header className="bg-light">
//                         <h5 className="mb-0">Job Applications</h5>
//                      </Card.Header>
//                      <Card.Body className="p-0"> {/* Remove padding for full-width table */}
//                         <Table striped bordered hover responsive size="sm" className="mb-0"> {/* Added classes, removed margin */}
//                             <thead className="table-light"> {/* Lighter head */}
//                                 <tr>
//                                     <th style={{width: '40%'}}>Job Title</th>
//                                     <th style={{width: '40%'}}>Status</th>
//                                     <th style={{width: '20%'}}>Applied On</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobapplications && jobapplications.length > 0 ? (
//                                     jobapplications.map((jobApp) => {
//                                          const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
//                                         return (
//                                             <tr key={jobApp.id}>
//                                                 <td>{jobApp.job_title || 'N/A'}</td>
//                                                 <td>
//                                                     {/* Use Form.Select for consistent Bootstrap styling */}
//                                                     <Form.Select
//                                                         size="sm"
//                                                         className={`${statusOption?.bgColor || 'bg-light'}`} // Apply background color class
//                                                         value={jobApp.job_status}
//                                                         onChange={(e) => handleStatusChange(jobApp.id, e.target.value)}
//                                                         aria-label={`Job status for ${jobApp.job_title}`}
//                                                         style={{ minWidth: '150px', color: statusOption?.bgColor.includes('warning') ? '#000' : '#fff' }} // Dynamic text color
//                                                     >
//                                                         {jobStatusOptions.map((option) => (
//                                                             <option key={option.value} value={option.value} style={{backgroundColor: '#fff', color: '#000'}}> {/* Ensure options are readable */}
//                                                                 {option.label}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </td>
//                                                 <td>{jobApp.applied_date ? new Date(jobApp.applied_date).toLocaleDateString() : 'N/A'}</td>
//                                             </tr>
//                                         );
//                                     })
//                                 ) : (
//                                 <tr><td colSpan="3" className="text-center text-muted p-3">No job applications found.</td></tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                      </Card.Body>
//                  </Card>


//                  {/* --- Personality Assessments Section --- */}
//                  <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
//                  <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
//                     {Array.isArray(personalityData) && personalityData.length > 0 ? (
//                         personalityData.map((data, index) => (
//                             data && data.job_id ? ( // Render only if data and job_id are present
//                                 <Card key={data.job_id} className="text-center shadow-sm" style={{ minWidth: '260px', maxWidth: '300px', flex: '1 1 260px' }}> {/* Flex properties */}
//                                     <Card.Header className="bg-light">
//                                          <Card.Title as="h6" className="mb-0 text-truncate">{personalityJobTitles[index] || `Assessment ID: ${data.job_id}`}</Card.Title>
//                                     </Card.Header>
//                                     <Card.Body className="d-flex flex-column p-2"> {/* Flex column, less padding */}
//                                         <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}> {/* Adjusted height/margin */}
//                                             {/* Ensure unique ID using applicant id and index */}
//                                             <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
//                                         </div>
//                                         <div className="mt-auto"> {/* Push content below to bottom */}
//                                             <p className="mb-1">
//                                                 <strong>Score:</strong> <b className="gradient-text">{typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}</b>
//                                              </p>
//                                              <p className="mb-2">
//                                                 <strong>Result:</strong> {data.result === 'T' ? <span className="badge bg-success">Passed</span> : <span className="badge bg-danger">Failed</span>}
//                                              </p>
//                                             <Button
//                                                 variant="outline-info" // Changed variant
//                                                 size="sm"
//                                                 onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id)}
//                                                 disabled={isLoadingAnswers && currentJobId === data.job_id} // Disable if loading this one
//                                             >
//                                                 {isLoadingAnswers && currentJobId === data.job_id ? (
//                                                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
//                                                 ) : (
//                                                      <i className="fas fa-receipt me-1"></i> // Added icon
//                                                 )}
//                                                 View Answers
//                                             </Button>
//                                         </div>
//                                     </Card.Body>
//                                 </Card>
//                             ) : null
//                         ))
//                     ) : (
//                         <p className="text-center text-muted w-100">No personality assessment data available.</p>
//                     )}
//                 </div>

//                 {/* --- Submitted Answers Section (Conditional) --- */}
//                 {currentJobId && ( // Show this section if a job ID has been selected
//                     <div className="mt-4">
//                         <Card className="shadow-sm">
//                              <Card.Header className="bg-light">
//                                  <h5 className="mb-0">Submitted Answers for Job: {personalityJobTitles.find((title, index) => personalityData[index]?.job_id === currentJobId) || `ID ${currentJobId}`}</h5>
//                              </Card.Header>
//                             <Card.Body>
//                                 {isLoadingAnswers ? (
//                                     <div className="text-center p-4">
//                                         <Spinner animation="border" variant="primary" />
//                                         <p className="mt-2 mb-0">Loading answers...</p>
//                                     </div>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length > 0 ? (
//                                     <Table striped bordered hover responsive size="sm">
//                                         <thead className="table-light">
//                                             <tr>
//                                                 <th style={{width: '5%'}}>#</th>
//                                                 <th style={{width: '45%'}}>Question</th>
//                                                 <th style={{width: '35%'}}>Your Answer(s)</th>
//                                                 <th style={{width: '15%'}} className="text-center">Result</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {jobQuestions.map((question, index) => {
//                                                 const submittedAnswer = filteredSubmittedAnswers.selected_answers?.find(
//                                                     ans => ans.question_id === question.id
//                                                 );

//                                                 let yourAnswerDisplay = <i className="text-muted">Not Answered</i>;
//                                                 let resultDisplay = <span className="badge bg-secondary">N/A</span>;
//                                                 let resultText = "Not Answered"; // For logic/styling

//                                                 const isMultipleChoice = question.answers && question.answers.length > 0 && question.correct_answer_index !== null && question.correct_answer_index !== undefined;

//                                                 if (submittedAnswer) {
//                                                     if (isMultipleChoice && submittedAnswer.selected_answer_index !== null && submittedAnswer.selected_answer_index !== undefined) {
//                                                         const selectedIndex = submittedAnswer.selected_answer_index;
//                                                         const correctIndex = question.correct_answer_index;

//                                                         yourAnswerDisplay = (
//                                                             <ul className="list-unstyled mb-0 small"> {/* Use smaller text */}
//                                                                 {question.answers.map((answerText, ansIndex) => (
//                                                                     <li key={ansIndex}
//                                                                         className={`${selectedIndex === ansIndex ? 'fw-bold' : ''} ${correctIndex === ansIndex ? 'text-success' : (selectedIndex === ansIndex && selectedIndex !== correctIndex ? 'text-danger' : '')}`} // More specific coloring
//                                                                         title={correctIndex === ansIndex ? 'Correct Answer' : (selectedIndex === ansIndex ? 'Selected Answer' : '')} // Tooltip
//                                                                     >
//                                                                         {/* Indicate selected and correct */}
//                                                                         {selectedIndex === ansIndex && <i className="fas fa-check text-primary me-1"></i>}
//                                                                         {correctIndex === ansIndex && <i className="fas fa-star text-success me-1" style={{fontSize: '0.7em'}}></i>}
//                                                                         {answerText}
//                                                                     </li>
//                                                                 ))}
//                                                             </ul>
//                                                         );

//                                                         if (selectedIndex === correctIndex) {
//                                                             resultDisplay = <span className="badge bg-success">Correct</span>;
//                                                             resultText = "Correct";
//                                                         } else {
//                                                             resultDisplay = <span className="badge bg-danger">Wrong</span>;
//                                                             resultText = "Wrong";
//                                                         }
//                                                     } else if (submittedAnswer.selected_answer_text !== null && submittedAnswer.selected_answer_text !== undefined) {
//                                                         yourAnswerDisplay = <span className="fst-italic">{submittedAnswer.selected_answer_text}</span>; // Italicize text answers
//                                                         resultDisplay = <span className="badge bg-info text-dark">Manual Check</span>; // Use info badge
//                                                         resultText = "Manual Check";
//                                                     }
//                                                 }

//                                                 let rowClass = '';
//                                                 if (resultText === "Correct") rowClass = 'table-success-light'; // Use custom lighter classes if defined, or Bootstrap's
//                                                 else if (resultText === "Wrong") rowClass = 'table-danger-light';
//                                                 else if (resultText === "Not Answered") rowClass = 'table-warning-light';

//                                                 return (
//                                                     <tr key={question.id || index} className={rowClass}>
//                                                         <td className="text-muted">{index + 1}</td>
//                                                         <td className="small">{question.question_text}</td> {/* Smaller question text */}
//                                                         <td>{yourAnswerDisplay}</td>
//                                                         <td className="text-center align-middle">{resultDisplay}</td> {/* Vertically align badge */}
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </Table>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length === 0 ? (
//                                      <p className="text-center text-muted p-3">No questions were found for this assessment.</p>
//                                 ) : !filteredSubmittedAnswers ? (
//                                     <p className="text-center text-muted p-3">Could not load answers for this assessment.</p>
//                                 ) : null }
//                             </Card.Body>
//                         </Card>
//                     </div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light"> {/* Added background */}
//                 <Button variant="secondary" onClick={onHide}>Close</Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };

// // --- Utility Functions (Outside Components) ---
// const handleDownloadResume = async (applicantId, resumeFileName) => {
//      if (!applicantId || !resumeFileName) return; // Basic check
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, {
//             responseType: "arraybuffer",
//         });
//         const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/octet-stream" }); // Use actual content type if available
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", resumeFileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error("Error downloading resume:", error);
//         alert("Failed to download resume. Please check console for details."); // User feedback
//     }
// };

// // --- Main Component: Jobapplicationresult (Enhanced UI/UX) ---
// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const recordsPerPage = 10;
//     const [jobapplications, setJobApplications] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedApplicant, setSelectedApplicant] = useState(null);
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null);
//     const [filterJobTitle, setFilterJobTitle] = useState("");
//     const [filterJobStatus, setFilterJobStatus] = useState("");
//     const [filterLocation, setFilterLocation] = useState(""); // City filter
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [isDownloadingBank, setIsDownloadingBank] = useState(false); // State for download button

//     // Function to fetch initial applicant list
//     const fetchApplicants = () => {
//         setIsLoading(true);
//         setError(null);
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants/")
//             .then(async (response) => {
//                 const applicants = response.data || [];
//                 const results = await Promise.allSettled(
//                     applicants.map(async (application) => {
//                         if (!application || !application.id) return null;
//                         try {
//                             // Fetch job titles/statuses for this applicant
//                             const jobTitleResponse = await axios.get(
//                                 `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}/`
//                             );
//                             const jobData = jobTitleResponse.data || [];
//                             const jobTitles = jobData.map((job) => job.job_title).filter(Boolean);
//                             const jobStatuses = jobData.map((job) => job.job_status).filter(Boolean);

//                             return {
//                                 ...application, // Spread all fields from backend
//                                 job_titles: jobTitles,
//                                 job_status: jobStatuses,
//                                 // LOCATION is now derived from 'city' field directly
//                                 location: application.city || null, // <<<<< Use city field
//                             };
//                         } catch (error) {
//                             console.error(`Error processing job details for applicant ${application.id}:`, error);
//                             return { // Return basic data even if job details fail
//                                 ...application,
//                                 job_titles: [],
//                                 job_status: [],
//                                 location: application.city || null, // <<<<< Use city field
//                             };
//                         }
//                     })
//                 );

//                 const updatedApplications = results
//                     .filter(result => result.status === 'fulfilled' && result.value)
//                     .map(result => result.value);

//                 setApplicationList(updatedApplications);
//             })
//             .catch((error) => {
//                 console.error("Error fetching applicants list:", error);
//                 setError("Failed to load applicant data. Please try refreshing the page.");
//             })
//             .finally(() => {
//                 setIsLoading(false);
//             });
//     };

//     useEffect(() => {
//         fetchApplicants();
//     }, []); // Fetch on mount

//     // Function to update job status in the list (passed to modal)
//      const updateJobApplicationStatusInList = (jobApplicationId, newStatus) => {
//          // This function needs to update the status *within the applicationList* if filters depend on it,
//          // or simply update the 'jobapplications' state passed to the modal if that's sufficient for the modal's display.
//          // For simplicity, we primarily update the state passed to the modal here.
//         setJobApplications(prev =>
//             prev.map(app =>
//                 app.id === jobApplicationId ? { ...app, job_status: newStatus } : app
//             )
//         );
//         // OPTIONAL: To make filters update immediately, you might need to update applicationList too.
//         // This is more complex as one applicant can have multiple jobs. Refetching might be easier.
//         // fetchApplicants(); // Or implement a more targeted update
//     };

//     // Memoized filtering logic
//     const filteredApplications = useMemo(() => {
//         return applicationList.filter((application) => {
//              if (!application) return false;

//             const searchQueryLower = searchQuery.toLowerCase();
//             const filterJobTitleLower = filterJobTitle.toLowerCase();
//             const filterJobStatusLower = filterJobStatus.toLowerCase();
//             const filterLocationLower = filterLocation.toLowerCase(); // City filter

//             // Search Query Match (Name, Email)
//             const matchesSearchQuery = searchQuery
//                 ? ((application.first_name || '').toLowerCase().includes(searchQueryLower) ||
//                    (application.middle_name || '').toLowerCase().includes(searchQueryLower) ||
//                    (application.last_name || '').toLowerCase().includes(searchQueryLower) ||
//                    (application.email || '').toLowerCase().includes(searchQueryLower))
//                 : true;

//             // Job Title Match
//              const matchesJobTitle = filterJobTitle
//                 ? application.job_titles?.some(title => title?.toLowerCase().includes(filterJobTitleLower))
//                 : true;

//             // Job Status Match
//             const matchesJobStatus = filterJobStatus
//                 ? application.job_status?.some(status => status?.toLowerCase().includes(filterJobStatusLower))
//                 : true;

//             // Location (City) Match <<<<< Uses 'location' which now holds city
//              const matchesLocation = filterLocation
//                 ? (application.location || '').toLowerCase().includes(filterLocationLower) // Use location (city)
//                 : true;

//             return matchesSearchQuery && matchesJobTitle && matchesJobStatus && matchesLocation;
//         });
//     }, [applicationList, searchQuery, filterJobTitle, filterJobStatus, filterLocation]); // Dependencies


//     // Pagination
//     const indexOfLastRecord = currentPage * recordsPerPage;
//     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//     const currentRecords = filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     const handlePageChange = (pageNumber) => {
//          setCurrentPage(pageNumber);
//     };

//     // Modal Handlers
//     const handleViewDetails = async (applicant) => {
//         if (!applicant || !applicant.id) return;
//         setSelectedApplicant(applicant);
//         setJobApplications([]); // Clear previous jobs
//         setShowModal(true); // Show modal first (can show loading inside)

//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//             setJobApplications(response.data || []);
//         } catch (error) {
//             console.error(`Error fetching job apps for ${applicant.id}:`, error);
//             setJobApplications([]); // Set empty on error
//         }
//     };

//     const handleViewApplicantDetails = async (applicantId) => {
//         if (!applicantId) return;
//         setSelectedApplicantDetails(null);
//         setShowDetailsModal(true);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//             setSelectedApplicantDetails(response.data);
//         } catch (error) {
//             console.error("Error fetching applicant details:", error);
//             setShowDetailsModal(false); // Close on error
//             setError("Could not fetch full applicant details.");
//         }
//     };

//     // Resume Bank Download Handler
//     const handleDownloadResumeBank = async () => {
//         setError(null);
//         setIsDownloadingBank(true);
//         try {
//             const response = await axios.get('https://raasbackend.vetrinahealthcare.com/download-resume-bank/', {
//                 responseType: 'blob',
//             });
//             const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'applicant_data.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//         } catch (error) {
//             console.error("Error downloading resume bank:", error);
//             let errorMsg = "Failed to download the Resume Bank file.";
//             // Provide more specific error feedback if possible
//              if (error.response?.status === 404) {
//                  errorMsg = "Error: Resume Bank file not found on server.";
//              } else if (error.request) {
//                  errorMsg = "Network error: Could not connect to server.";
//              }
//             setError(errorMsg);
//         } finally {
//             setIsDownloadingBank(false);
//         }
//     };

//      // --- Dynamic options for filters (Memoized) ---
//     const uniqueJobTitles = useMemo(() => {
//         const titles = applicationList.flatMap(app => app.job_titles || []);
//         return [...new Set(titles)].sort();
//     }, [applicationList]);

//     const uniqueJobStatuses = useMemo(() => {
//          const statuses = applicationList.flatMap(app => app.job_status || []);
//          return [...new Set(statuses)].sort();
//     }, [applicationList]);

//     const uniqueLocations = useMemo(() => {
//         // Use the 'location' field which now holds the city
//         const locations = applicationList.map(app => app.location).filter(Boolean);
//         return [...new Set(locations)].sort();
//     }, [applicationList]);

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <main className="main p-3"> {/* Use main tag, add padding */}
//                     <div className="container-fluid">
//                          {/* --- Fixed Alerts --- */}
//                          {successMessage && (
//                             <Alert
//                                 variant="success"
//                                 onClose={() => setSuccessMessage("")}
//                                 dismissible
//                                 className="position-fixed top-0 end-0 m-3" // Position top-right
//                                 style={{ zIndex: 9999, minWidth: '300px', top: '60px' }} // Adjust top offset as needed
//                             >
//                                 <i className="fas fa-check-circle me-2"></i>{successMessage}
//                             </Alert>
//                         )}
//                         {error && (
//                             <Alert
//                                 variant="danger"
//                                 onClose={() => setError(null)}
//                                 dismissible
//                                 className="position-fixed top-0 end-0 m-3" // Position top-right
//                                 style={{ zIndex: 9998, minWidth: '300px', top: successMessage ? '120px' : '60px' }} // Adjust top offset
//                             >
//                                <i className="fas fa-exclamation-triangle me-2"></i> {error}
//                             </Alert>
//                         )}

//                          <Card className="shadow-sm">
//                             <Card.Header className="bg-light d-flex flex-column flex-md-row justify-content-between align-items-md-center p-3">
//                                 <h1 className="h4 gradient-text mb-2 mb-md-0">Application Management</h1>
//                                 <Button
//                                     variant="success"
//                                     size="sm"
//                                     onClick={handleDownloadResumeBank}
//                                     disabled={isDownloadingBank}
//                                 >
//                                     {isDownloadingBank ? (
//                                         <>
//                                             <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
//                                             <span className="visually-hidden">Loading...</span> Downloading...
//                                         </>
//                                     ) : (
//                                         <><i className="fas fa-file-excel me-2"></i> Download Resume Bank (XLSX)</>
//                                     )}
//                                 </Button>
//                             </Card.Header>
//                             <Card.Body className="p-3">
//                                 {/* --- Search and Filters Row --- */}
//                                 <div className="row g-2 mb-3 align-items-center">
//                                     {/* Search */}
//                                     <div className="col-md-4">
//                                         <InputGroup size="sm">
//                                             <InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text>
//                                             <Form.Control
//                                                 type="search"
//                                                 placeholder="Search by Name or Email..."
//                                                 value={searchQuery}
//                                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                                 aria-label="Search Applicants"
//                                             />
//                                         </InputGroup>
//                                     </div>
//                                     {/* Job Title Filter */}
//                                     <div className="col-md-2 col-6"> {/* Adjust column sizes */}
//                                          <Form.Select size="sm" value={filterJobTitle} onChange={(e) => setFilterJobTitle(e.target.value)} aria-label="Filter by Job Title">
//                                             <option value="">All Job Titles</option>
//                                             {uniqueJobTitles.map((title) => ( <option key={title} value={title}>{title}</option> ))}
//                                         </Form.Select>
//                                     </div>
//                                     {/* Job Status Filter */}
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterJobStatus} onChange={(e) => setFilterJobStatus(e.target.value)} aria-label="Filter by Job Status">
//                                             <option value="">All Statuses</option>
//                                             {uniqueJobStatuses.map((status) => ( <option key={status} value={status}>{status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</option> ))}
//                                         </Form.Select>
//                                     </div>
//                                     {/* Location (City) Filter */}
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterLocation} onChange={(e) => setFilterLocation(e.target.value)} aria-label="Filter by Location (City)">
//                                             <option value="">All Locations</option>
//                                             {uniqueLocations.map((loc) => ( <option key={loc} value={loc}>{loc}</option> ))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6 text-md-end"> {/* Reset button */}
//                                        <Button variant="outline-secondary" size="sm" onClick={() => { setSearchQuery(''); setFilterJobTitle(''); setFilterJobStatus(''); setFilterLocation(''); setCurrentPage(1); }}>
//                                          <i className="fas fa-times me-1"></i> Reset Filters
//                                        </Button>
//                                     </div>
//                                 </div>

//                                 {/* --- Table Section --- */}
//                                 <div className="table-responsive"> {/* Make table scroll horizontally on small screens */}
//                                      <Table striped bordered hover size="sm" className="align-middle"> {/* align-middle for vertical centering */}
//                                         <thead className="table-dark">
//                                             <tr>
//                                                 {/* Add sorting capabilities later if needed */}
//                                                 <th>First Name</th>
//                                                 <th>Middle Name</th>
//                                                 <th>Last Name</th>
//                                                 <th>Email</th>
//                                                 <th>Phone</th>
//                                                 <th>Location (City)</th>{/* <<<<< Updated Header */}
//                                                 <th className="text-center">Resume</th>
//                                                 <th className="text-center">Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {isLoading ? (
//                                                 <tr>
//                                                     <td colSpan="8" className="text-center p-5">
//                                                         <Spinner animation="border" variant="primary" />
//                                                         <p className="mt-2 mb-0">Loading Applicants...</p>
//                                                     </td>
//                                                 </tr>
//                                             ) : currentRecords.length > 0 ? (
//                                                 currentRecords.map((application) => (
//                                                     <tr key={application.id}>
//                                                         <td>{application.first_name || '-'}</td>
//                                                         <td>{application.middle_name || ''}</td>
//                                                         <td>{application.last_name || '-'}</td>
//                                                         <td>{application.email || '-'}</td>
//                                                         <td>{application.phone || '-'}</td>
//                                                         <td>{application.location || '-'}</td> {/* <<<<< Display city */}
//                                                         <td className="text-center">
//                                                             {application.resume ? (
//                                                                 <Button
//                                                                     variant="outline-primary" // Subtle button
//                                                                     size="sm"
//                                                                     className="p-1" // Minimal padding
//                                                                     onClick={() => handleDownloadResume(application.id, application.resume)}
//                                                                     title={`Download ${application.resume}`}
//                                                                 >
//                                                                     <i className="fas fa-download fa-fw"></i> {/* Fixed width icon */}
//                                                                 </Button>
//                                                             ) : (
//                                                                 <span className="text-muted small">N/A</span>
//                                                             )}
//                                                         </td>
//                                                         <td className="text-center">
//                                                             <Button
//                                                                 variant="info" // Use theme color
//                                                                 size="sm"
//                                                                 className="me-1 p-1"
//                                                                 onClick={() => handleViewDetails(application)}
//                                                                 title="Check Results & Status"
//                                                             >
//                                                                 <i className="fas fa-clipboard-check fa-fw"></i>
//                                                             </Button>
//                                                             <Button
//                                                                 variant="secondary" // Use theme color
//                                                                 size="sm"
//                                                                 className="p-1"
//                                                                 onClick={() => handleViewApplicantDetails(application.id)}
//                                                                 title="View Full Applicant Details"
//                                                             >
//                                                                 <i className="fas fa-user fa-fw"></i>
//                                                             </Button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td colSpan="8" className="text-center text-muted p-4">No matching applications found.</td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </Table>
//                                 </div>

//                                 {/* --- Pagination --- */}
//                                 {totalPages > 1 && !isLoading && (
//                                     <div className="d-flex justify-content-center mt-3">
//                                         <Button
//                                             variant="outline-secondary" size="sm"
//                                             onClick={() => handlePageChange(currentPage - 1)}
//                                             disabled={currentPage === 1} className="me-1"
//                                         > « Prev </Button>

//                                         {/* Logic for limited page numbers (optional) */}
//                                         {[...Array(totalPages).keys()].map((page) => (
//                                             <Button key={page + 1}
//                                                 variant={currentPage === page + 1 ? "primary" : "outline-primary"} size="sm"
//                                                 className="mx-1" onClick={() => handlePageChange(page + 1)}
//                                             > {page + 1} </Button>
//                                         ))}

//                                         <Button
//                                             variant="outline-secondary" size="sm"
//                                             onClick={() => handlePageChange(currentPage + 1)}
//                                             disabled={currentPage === totalPages} className="ms-1"
//                                         > Next » </Button>
//                                     </div>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>

//                      {/* --- Modals --- */}
//                      {/* Applicant Results/Status Modal */}
//                     {showModal && selectedApplicant && (
//                         <ApplicantModal
//                             applicant={selectedApplicant}
//                             jobapplications={jobapplications}
//                             setSuccessMessage={setSuccessMessage}
//                             updateJobApplication={updateJobApplicationStatusInList}
//                             key={`modal-${selectedApplicant.id}`} // Ensure re-mount on applicant change
//                         />
//                     )}

//                     {/* Applicant Full Details Modal */}
//                      {showDetailsModal && (
//                          <ApplicantDetailsModal
//                             show={showDetailsModal} // Pass show state
//                             onHide={() => setShowDetailsModal(false)} // Pass hide handler
//                             applicant={selectedApplicantDetails} // Pass fetched details (can be null initially)
//                             isLoading={!selectedApplicantDetails} // Pass loading state
//                          />
//                      )}

//                 </main>
//             </div>
//         </>
//     );
// }

// import React, { useState, useEffect, useRef } from "react"
// import axios from "axios"
// import "bootstrap/dist/css/bootstrap.min.css"
// import "../css/dash.css"
// import Sidebar from "../Misc/Sidebar"
// import DashNavbar from "../Misc/DashNavbar"
// import { Table, Alert, Modal, Button, Card } from "react-bootstrap"
// import Chart from "chart.js/auto"
// import ApplicantDetailsModal from "./ApplicantDetailsModal"
// import Spinner from "react-bootstrap/Spinner"

// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
//     setChartData: setModalChartData,
// }) => {
//     const jobStatusOptions = [
//         { value: "applied", label: "Applied", bgColor: "bg-info" },
//         { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//         {
//             value: "interview_scheduled",
//             label: "Interview Scheduled",
//             bgColor: "bg-warning",
//         },
//         { value: "selected", label: "Selected", bgColor: "bg-success" },
//         { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
//     ]
//     const [applicationList, setApplicationList] = useState([])
//     const [show, setShow] = useState(false)
//     const [refreshInterval, setRefreshInterval] = useState(null)

//     const [score, setScore] = useState([])
//     const handleStatusChange = (id, newStatus) => {
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus })
//             .then((response) => {
//                 console.log("status changed to:", newStatus)
//                 setSuccessMessage("Job status updated successfully")
//                 updateJobApplication(id, newStatus)

//                 axios.get("https://raasbackend.vetrinahealthcare.com/applicants/").then(async (response) => {
//                     const updatedApplications = []
//                     await Promise.all(
//                         response.data.map(async (application) => {
//                             try {
//                                 const jobTitleResponse = await axios.get(
//                                     `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}/`,
//                                 )
//                                 const jobScore = jobTitleResponse.data.map((job) => job.similarly_score)
//                                 setScore(jobScore)
//                                 console.log(score)
//                                 const updatedApplication = {
//                                     ...application,
//                                 }
//                                 updatedApplications.push(updatedApplication)
//                             } catch (error) {
//                                 console.error("Error processing application:", error)
//                             }
//                         }),
//                     )
//                     setApplicationList(updatedApplications)
//                 })
//                 setTimeout(() => {
//                     setSuccessMessage("")
//                 }, 5000)
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error)
//             })
//     }
//     //const [chartData, setChartData] = useState(null)  //Old Chart Data
//     const [personalityData, setPersonalityData] = useState([]); // Array to hold multiple results
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);

//     const chartRefs = useRef([]); // Ref to store chart instances

//     const [allSubmittedAnswers, setAllSubmittedAnswers] = useState(null); // Store all response,
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null); // Store filterd answer
//     const [currentJobId, setCurrentJobId] = useState(null); //New state for current jobId

//     const [jobQuestions, setJobQuestions] = useState(null); // Store job questions from API

//     useEffect(() => {
//         if (!show) {
//             setPersonalityData([]); // Clear previous data when modal hides
//             setPersonalityJobTitles([]);
//             setAllSubmittedAnswers(null); // also clear when closing modal
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);  //Clear Job Question when close
//             setCurrentJobId(null);  // Clear currentJobId when close
//         }
//     }, [show])

//     useEffect(() => {
//         if (show) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant]);

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const url = applicantId
//                 ? `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`
//                 : "https://raasbackend.vetrinahealthcare.com/get_personality_results/";
//             const response = await axios.get(url);
//             setPersonalityData(response.data);  // Assuming the backend returns an array
//             const jobTitleResponse = await axios.get(
//                 `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicantId}/`,
//             );
//             const jobTitles = jobTitleResponse.data.map((job) => job.job_title);
//             setPersonalityJobTitles(jobTitles); // save job titles
//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//         }
//     };

//     useEffect(() => {
//         // Destroy existing chart instances
//         chartRefs.current.forEach(chart => {
//             chart.destroy();
//         });
//         chartRefs.current = []; // Clear the array

//         // Create charts for each personality data
//         personalityData.forEach((data, index) => {
//             const chartId = `personalityChart-${index}`;
//             const chartRef = document.getElementById(chartId);
//             if (chartRef) {
//                 const newChart = createDonutChart(data, chartId, data.status); // Pass the status to the chart
//                 chartRefs.current.push(newChart); // Store the chart instance
//             }
//         });
//     }, [personalityData]);

//     useEffect(() => {
//         setShow(false)
//         setTimeout(() => {
//             setShow(true)
//         }, 100)
//     }, [applicant, jobapplications, applicant.similarity_scores])
//     const onHide = () => {
//         setShow(false)
//     }

//     const createDonutChart = (data, chartId, status) => {
//         const { correct_count, all_count, wrong_count } = data;
//         const ctx = document.getElementById(chartId).getContext("2d");

//         if (!ctx) {
//             console.error(`Canvas element with id ${chartId} not found`);
//             return null;
//         }

//         const correctPercentage = (correct_count / all_count) * 100;
//         const wrongPercentage = (wrong_count / all_count) * 100;

//         const chart = new Chart(ctx, {
//             type: 'doughnut',
//             data: {
//                 labels: ['Correct', 'Wrong'],
//                 datasets: [{
//                     label: 'Quiz Results',
//                     data: [correct_count, wrong_count],
//                     backgroundColor: [
//                         'rgba(75, 192, 192, 0.8)',
//                         'rgba(255, 99, 132, 0.8)'
//                     ],
//                     borderColor: [
//                         'rgba(75, 192, 192, 1)',
//                         'rgba(255, 99, 132, 1)'
//                     ],
//                     borderWidth: 1,
//                 }]
//             },
//             options: {
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 plugins: {
//                     legend: {
//                         position: 'top',
//                     },
//                     title: {
//                         display: true,
//                         text: `Quiz Result Breakdown (Percentage: ${status}%)`, // show the status here and changed Status to Percentage
//                     }
//                 }
//             }
//         });
//         return chart;
//     };

//     // Handler for the "Show Submitted Answers" button click
//     const handleShowSubmittedAnswers = async (applicantId, jobId) => {
//         setCurrentJobId(jobId);  // Set currently selected jobId
//         try {
//             const answersResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`); // Get All data
//             setAllSubmittedAnswers(answersResponse.data);  // Store all the API response.

//             // Fetch job questions from the new API
//             try {
//                 const questionResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${jobId}/`);
//                 setJobQuestions(questionResponse.data);
//             } catch (questionError) {
//                 console.error("Error fetching job questions:", questionError);
//                 setJobQuestions(null);
//             }
//         } catch (error) {
//             console.error("Error fetching submitted answers:", error);
//             setAllSubmittedAnswers(null);  // Clear any previous data in case of an error
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null); // Also Clear Question when Error occur
//         }
//     };

//     useEffect(() => {
//         //Filter logic
//         if (allSubmittedAnswers) {
//             const filtered = allSubmittedAnswers.find(item => item.job_id === currentJobId); // only show job_id equal
//             setFilteredSubmittedAnswers(filtered);
//         } else {
//             setFilteredSubmittedAnswers(null);
//         }
//     }, [allSubmittedAnswers, currentJobId]);

//     return (
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered>
//             <Modal.Header closeButton>
//                 <Modal.Title className=" gradient-text">Applicant Details</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Table bordered>
//                     <thead className="thead-dark">
//                         <tr>
//                             <th scope="col">Job Title</th>
//                             <th scope="col">Job Status</th>
//                             {/* <th scope="col">Similarity Score</th> */}
//                             <th scope="col">Applied Date</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {jobapplications.map((jobApplication, index) => {
//                             console.log("jobApplication:", jobApplication)
//                             return (
//                                 <tr key={index}>
//                                     <td className="text-center p-2">{jobApplication.job_title}</td>
//                                     <td className="text-center p-2">
//                                         <select
//                                             className={`form-select ${jobStatusOptions.find((option) => option.value === jobApplication.job_status)?.bgColor
//                                                 }`}
//                                             value={jobApplication.job_status}
//                                             onChange={(e) => handleStatusChange(jobApplication.id, e.target.value)}
//                                         >
//                                             {jobStatusOptions.map((option) => (
//                                                 <option key={option.value} value={option.value}>
//                                                     {option.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </td>
//                                     {/* <td className="text-center p-2">{applicant.similarity_scores[index]}</td> */}
//                                     <td className="text-center p-2">{new Date(jobApplication.applied_date).toLocaleDateString()}</td>
//                                 </tr>
//                             )
//                         })}
//                     </tbody>
//                 </Table>
//                 <div className="row justify-content-center">
//                     <h4 className="gradient-text text-center">Personality Assessments</h4>
//                     <div className="d-flex flex-wrap justify-content-center"> {/* Use flexbox to wrap items */}
//                         {Array.isArray(personalityData) && personalityData.length > 0 ? (
//                             personalityData.map((data, index) => (
//                                 <div className="col-md-4 mb-4 d-flex justify-content-center"> {/* Adjust col-md- to col-md-4 */}
//                                     <Card className="advanced-card" style={{ maxWidth: '300px' }}>  {/* Apply custom class and set max width */}
//                                         <Card.Body className="text-center">
//                                             <Card.Title>{personalityJobTitles[index]}</Card.Title>
//                                             <div style={{ width: '100%', height: '200px' }}>
//                                                 <canvas id={`personalityChart-${index}`}></canvas>
//                                             </div>
//                                             <Card.Text>
//                                                 Result: {data.result === 'T' ? 'Passed' : 'Failed'}
//                                             </Card.Text>
//                                             <Card.Text>
//                                                 Percentage: <b className="gradient-text">{data.status}%</b>
//                                             </Card.Text>
//                                             {/* Added "Show Submitted Answers" button here */}
//                                             <Button variant="info" onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id)}>
//                                                 Show Submitted Answers
//                                             </Button>
//                                         </Card.Body>
//                                     </Card>
//                                 </div>
//                             ))
//                         ) : (
//                             <p className="text-center">No personality data available.</p>
//                         )}
//                     </div>
//                 </div>
//                 {/* Conditionally render the submitted answers */}
//                 {filteredSubmittedAnswers && currentJobId && jobQuestions && (
//                     <div className="row justify-content-center mt-4">
//                         <h5 className="gradient-text text-center">Submitted Answers and Questions for Job ID {currentJobId}:</h5>
//                         <Table striped bordered hover>
//                             <thead>
//                                 <tr>
//                                     <th>Question</th>
//                                     <th>Your Answer</th>
//                                     <th>Result</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobQuestions.map((question, index) => {
//                                     const submittedAnswer = filteredSubmittedAnswers.selected_answers?.find(answer => answer.question_id === question.id);
//                                     let yourAnswer = "N/A";
//                                     let yourAnswerOptions = [];
//                                     let result = "N/A";

//                                     if (submittedAnswer) {
//                                         if (submittedAnswer.selected_answer_index !== undefined && submittedAnswer.selected_answer_index !== null) {
//                                             // For multiple-choice questions
//                                             yourAnswer = question.answers[submittedAnswer.selected_answer_index] || "Answer index out of bounds";
//                                             yourAnswerOptions = question.answers.map((answer, answerIndex) => ({
//                                                 text: answer,
//                                                 isCorrect: answerIndex === question.correct_answer_index,
//                                                 isSelected: answerIndex === submittedAnswer.selected_answer_index
//                                             }));

//                                             if (submittedAnswer.selected_answer_index === question.correct_answer_index) {
//                                                 result = "Correct";
//                                             } else {
//                                                 result = "Wrong";
//                                             }

//                                         } else if (submittedAnswer.selected_answer_text) {
//                                             // For text-based questions
//                                             yourAnswer = submittedAnswer.selected_answer_text;
//                                             yourAnswerOptions = [{ text: yourAnswer, isCorrect: false, isSelected: true }];
//                                             result = "Text-based: Check Manually"; // since the correct answer index is null and there is no correct answer
//                                         }
//                                     } else {
//                                         yourAnswerOptions = question.answers.map((answer, answerIndex) => ({
//                                             text: answer,
//                                             isCorrect: answerIndex === question.correct_answer_index,
//                                             isSelected: false
//                                         }));
//                                         result = "Not Answered";  // If no answer found
//                                     }

//                                     //Determine if the question is a multiple-choice question.
//                                     const isMultipleChoice = question.answers && question.answers.length > 0 && question.correct_answer_index !== null;

//                                     return (
//                                         <tr key={index}>
//                                             <td>
//                                                 {question.question_text}
//                                             </td>
//                                             <td>
//                                                 {isMultipleChoice ? (
//                                                     <ul className="list-unstyled">
//                                                         {yourAnswerOptions.map((option, optionIndex) => (
//                                                             <li key={optionIndex}
//                                                                 className={`${option.isCorrect ? 'text-success' : ''} ${option.isSelected ? 'fw-bold' : ''}`}>
//                                                                 {option.text}
//                                                             </li>
//                                                         ))}
//                                                     </ul>
//                                                 ) : (
//                                                     yourAnswer
//                                                 )}
//                                             </td>
//                                             <td>{result}</td>
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         </Table>
//                     </div>
//                 )}
//             </Modal.Body>
//         </Modal>
//     )
// }
// const handleDownloadResume = async (applicantId, resumeFileName) => {
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, {
//             responseType: "arraybuffer",
//         })
//         const blob = new Blob([response.data], { type: "application/pdf" })
//         const url = window.URL.createObjectURL(blob)
//         const link = document.createElement("a")
//         link.href = url
//         link.setAttribute("download", resumeFileName) // Set the desired file name
//         document.body.appendChild(link)
//         link.click()
//         document.body.removeChild(link)
//         window.URL.revokeObjectURL(url)
//     } catch (error) {
//         console.error("Error downloading resume:", error)
//     }
// }
// const getHighestTraitIndices = (traits) => {
//     const highestTrait = Math.max(...traits)
//     return traits.reduce((indices, trait, index) => {
//         if (trait === highestTrait) {
//             indices.push(index)
//         }
//         return indices
//     }, [])
// }

// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([])
//     const [currentPage, setCurrentPage] = useState(1)
//     const [successMessage, setSuccessMessage] = useState("")
//     const [searchQuery, setSearchQuery] = useState("")
//     const recordsPerPage = 4
//     const [jobapplications, setjobapplications] = useState([])
//     const [score, setScore] = useState([])
//     const [showModal, setShowModal] = useState(false)
//     const [showDetailsModal, setShowDetailsModal] = useState(false)
//     const [selectedApplicant, setSelectedApplicant] = useState(null)
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null)
//     const [jobTitles, setJobTitles] = useState([])
//     const [filterJobTitle, setFilterJobTitle] = useState("")
//     const [filterJobStatus, setFilterJobStatus] = useState("")
//     const [sortSimilarityScore, setSortSimilarityScore] = useState("")
//     const [isLoading, setIsLoading] = useState(false)

//     const [error, setError] = useState(null)

//     const updateJobApplication = (applicantId, newStatus) => {
//         const updatedApplications = jobapplications.map((application) => {
//             if (application.id === applicantId) {
//                 return { ...application, job_status: newStatus }
//             }
//             return application
//         })
//         setjobapplications(updatedApplications)
//     }
//     useEffect(() => {
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants/")
//             .then(async (response) => {
//                 const updatedApplications = []
//                 await Promise.all(
//                     response.data.map(async (application) => {
//                         try {
//                             const resumeResponse = await axios.get(
//                                 `https://raasbackend.vetrinahealthcare.com/api/resume/${application.id}/`,
//                                 { responseType: "blob" },
//                             )
//                             const pdfFile = new File([resumeResponse.data], application.resume, {
//                                 type: "application/pdf",
//                             })
//                             const jobTitleResponse = await axios.get(
//                                 `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}/`,
//                             )
//                             const jobTitles = jobTitleResponse.data.map((job) => job.job_title)
//                             const similarityScores = jobTitleResponse.data.map((job) => job.similarly_score)
//                             const jobstatus = jobTitleResponse.data.map((job) => job.job_status)
//                             const updatedApplication = {
//                                 ...application,
//                                 job_titles: jobTitles,
//                                 similarity_scores: similarityScores,
//                                 job_status: jobstatus,
//                             }
//                             updatedApplications.push(updatedApplication)
//                         } catch (error) {
//                             console.error("Error processing application:", error)
//                         }
//                     }),
//                 )
//                 setApplicationList(updatedApplications)
//                 setIsLoading(false)
//             })
//             .catch((error) => {
//                 console.error("Error fetching applications:", error)
//                 setError(error)
//                 setIsLoading(false)
//             })
//     }, [])
//     const handleFilter = () => {
//         let filteredList = applicationList.filter((application) => {
//             const matchesSearchQuery =
//                 application.first_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 application.middle_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 application.last_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 application.email?.toLowerCase().includes(searchQuery.toLowerCase())
//             const matchesJobTitle = filterJobTitle
//                 ? application.job_titles?.some((jobTitle) => jobTitle.toLowerCase().includes(filterJobTitle.toLowerCase()))
//                 : true
//             const matchesJobStatus = filterJobStatus
//                 ? application.job_status?.some((jobstatus) => jobstatus.toLowerCase().includes(filterJobStatus.toLowerCase()))
//                 : true
//             return matchesSearchQuery && matchesJobTitle && matchesJobStatus
//         })

//         if (sortSimilarityScore) {
//             filteredList = filteredList.sort((a, b) => {
//                 const maxScoreA = Math.max(...(a.similarity_scores || []))
//                 const maxScoreB = Math.max(...(b.similarity_scores || []))
//                 return sortSimilarityScore === "asc" ? maxScoreA - maxScoreB : maxScoreB - maxScoreA
//             })
//         }
//         return filteredList
//     }
//     const filteredApplications = handleFilter()
//     const indexOfLastRecord = currentPage * recordsPerPage
//     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
//     const currentRecords = filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord)
//     const handlePageChange = (pageNumber) => setCurrentPage(pageNumber)
//     const [chartData, setChartData] = useState(null)
//     const extractPDFText = async () => {
//         setIsLoading(true)
//         try {
//             const response = await axios.get("https://raasbackend.vetrinahealthcare.com/applicants/")
//             const applications = response.data
//             for (const application of applications) {
//                 try {
//                     const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${application.id}/`, {
//                         responseType: "blob"
//                     })
//                     const pdfFile = new File([response.data], application.resume, {
//                         type: "application/pdf",
//                     })
//                     const jobTitleResponse = await axios.get(
//                         `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}/`,
//                     )
//                     const jobTitles = jobTitleResponse.data.map((job) => job.job_title)
//                     const applicant_id = jobTitleResponse.data.map((job) => job.applicant)[0]
//                     const formData = new FormData()
//                     formData.append("pdf_file", pdfFile)
//                     formData.append("job_titles", JSON.stringify(jobTitles))
//                     formData.append("applicant_id", applicant_id)
//                     await axios.post(`https://raasbackend.vetrinahealthcare.com/extract-pdf-text/` + applicant_id, formData, {
//                         headers: { "Content-Type": "multipart/form-data" },
//                     })
//                 } catch (error) {
//                     console.error("Error extracting PDF text:", error)
//                 }
//             }
//         } catch (error) {
//             console.error("Error fetching applicants:", error)
//         } finally {
//             setIsLoading(false)
//         }
//     }

//     useEffect(() => {
//         extractPDFText()
//     }, [])

//     const handleViewDetails = async (applicant, jobapplications) => {
//         setSelectedApplicant(applicant)
//         setShowModal(true)
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`)
//             setjobapplications(response.data)

//         } catch (error) {
//             console.error("Error fetching job applications:", error)
//         }
//     }

//     const handleViewApplicantDetails = async (applicantId) => {
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`)
//             setSelectedApplicantDetails(response.data)
//             setShowDetailsModal(true)
//         } catch (error) {
//             console.error("Error fetching applicant details:", error)
//         }
//     }
//     // --- ADDED: Handler for the "Resume Bank" button ---
//     const handleDownloadResumeBank = async () => {
//         console.log("Attempting to download resume bank...");
//         setError(null); // Clear previous errors
//         // Consider setting a specific loading state for the button if needed
//         try {
//             // Make sure the backend URL matches your Django server address and port
//             const response = await axios.get('https://raasbackend.vetrinahealthcare.com/download-resume-bank/', {
//                 responseType: 'blob', // Crucial for handling file downloads
//             });

//             // Create a Blob from the response data with the correct MIME type for Excel
//             const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

//             // Create a temporary URL for the blob
//             const url = window.URL.createObjectURL(blob);

//             // Create a temporary anchor element to trigger the download
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'applicant_data.xlsx'); // Set the desired filename

//             // Append the link to the body, click it, and then remove it
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);

//             // Revoke the temporary URL to free up resources
//             window.URL.revokeObjectURL(url);

//             console.log("Resume bank download triggered.");
//             // Optionally show a success message if needed
//             // setSuccessMessage("Resume Bank download started.");
//             // setTimeout(() => setSuccessMessage(""), 5000);

//         } catch (error) {
//             console.error("Error downloading resume bank:", error);
//             let errorMsg = "Failed to download the Resume Bank file.";
//             if (error.response) {
//                 console.error("Server Error:", error.response.status, error.response.data);
//                 if (error.response.status === 404) {
//                     errorMsg = "Error: The Resume Bank file (applicant_data.xlsx) was not found on the server.";
//                 } else {
//                     try {
//                         const errorBlob = error.response.data;
//                         if (errorBlob instanceof Blob) {
//                             const errorText = await errorBlob.text();
//                             if (!errorText.trim().startsWith('<')) { // Avoid showing HTML error pages
//                                 errorMsg += ` Server message: ${errorText.substring(0, 100)}`;
//                             } else {
//                                 errorMsg += ` (Server Status: ${error.response.status})`;
//                             }
//                         } else {
//                             errorMsg += ` (Server Status: ${error.response.status})`;
//                         }
//                     } catch (blobError) {
//                         errorMsg += ` (Server Status: ${error.response.status})`;
//                     }
//                 }
//             } else if (error.request) {
//                 errorMsg = "Network error: Could not connect to the server.";
//             } else {
//                 errorMsg = `Error: ${error.message}`;
//             }
//             setError(errorMsg); // Show the error message to the user
//         } finally {
//             // Stop any specific button loading indicator if used
//         }
//     };

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <div className="main">
//                     <div className="container mt-2">
//                         <div className="d-flex justify-content-center align-items-center applicationlist">
//                             <div className="auth-inner w-100" style={{ padding: "0px" }}>
//                                 <div className="row justify-content-center">
//                                     <div className="col-lg-12">
//                                         <div className="bg-white rounded p-3">
//                                             {/* --- Row for Title and Download Button --- */}
//                                             <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
//                                                 <h2 className="display-6 gradient-text mb-2 mb-md-0">Application List</h2>
//                                                 {/* --- ADD THIS BUTTON --- */}
//                                                 <Button
//                                                     variant="success"
//                                                     onClick={handleDownloadResumeBank}
//                                                     disabled={isLoading} // Optional: disable while main list loads
//                                                 >
//                                                     <i className="fas fa-download me-2"></i> Download Resume Bank
//                                                 </Button>
//                                                 {/* --- END OF ADDED BUTTON --- */}
//                                             </div>

//                                             {/* --- Alert for Download Errors --- */}
//                                             {error && (
//                                                 <Alert variant="danger" onClose={() => setError(null)} dismissible className="mt-3">
//                                                     {error}
//                                                 </Alert>
//                                             )}

//                                             {/* Your existing successMessage Alert comes after this */}
//                                             {successMessage && (
//                                                 <div
//                                                     style={{
//                                                         position: "fixed",
//                                                         top: "10%", // Adjust as needed
//                                                         right: "2%",
//                                                         zIndex: "9999",
//                                                     }}
//                                                 >
//                                                     <Alert variant="success" onClose={() => setSuccessMessage("")} dismissible>
//                                                         {/* Original content */}
//                                                         <div style={{ display: "flex", alignItems: "center" }}>
//                                                             <span style={{ flex: 1 }}>{successMessage}</span>
//                                                         </div>
//                                                     </Alert>
//                                                 </div>
//                                             )}                                            {successMessage && (
//                                                 <div
//                                                     style={{
//                                                         position: "fixed",
//                                                         top: "10%",
//                                                         right: "2%",
//                                                         zIndex: "9999",
//                                                     }}
//                                                 >
//                                                     <Alert variant="success" onClose={() => setSuccessMessage("")} dismissible>
//                                                         <div style={{ display: "flex", alignItems: "center" }}>
//                                                             <span style={{ flex: 1 }}>{successMessage}</span>
//                                                         </div>
//                                                     </Alert>
//                                                 </div>
//                                             )}
//                                             <div className="row justify-content-center">
//                                                 <div className="col-md-5 mb-4">
//                                                     <div className="input-group">
//                                                         <div className="form-outline" data-mdb-input-init style={{ width: "100%" }}>
//                                                             <input
//                                                                 id="search-input"
//                                                                 type="search"
//                                                                 className="form-control text-xs"
//                                                                 placeholder="Search by Name, Email or Job title"
//                                                                 value={searchQuery}
//                                                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                                             />
//                                                         </div>
//                                                         <button
//                                                             id="search-button"
//                                                             type="button"
//                                                             className="btn btn-primary text-xs"
//                                                             style={{
//                                                                 position: "absolute",
//                                                                 right: "0px",
//                                                                 top: "0px",
//                                                             }}
//                                                         >
//                                                             <i className="fas fa-search"></i>
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="row mb-4">
//                                                 <div className="col-md-4" style={{ marginBottom: "5px", width: "100wv" }}>
//                                                     <select
//                                                         className="form-select"
//                                                         value={filterJobTitle}
//                                                         onChange={(e) => setFilterJobTitle(e.target.value)}
//                                                     >
//                                                         <option value="">All Job Titles</option>
//                                                         {[...new Set(applicationList.flatMap((application) => application.job_titles))].map(
//                                                             (title, index) => (
//                                                                 <option key={index} value={title}>
//                                                                     {title}
//                                                                 </option>
//                                                             ),
//                                                         )}
//                                                     </select>
//                                                 </div>
//                                                 {/* <div className="col-md-4" style={{ marginBottom: "5px" }}>
//                                                     <select
//                                                         className="form-select"
//                                                         value={sortSimilarityScore}
//                                                         onChange={(e) => setSortSimilarityScore(e.target.value)}
//                                                     >
//                                                         <option value="">Sort by Similarity Score</option>
//                                                         <option value="asc">Low to High</option>
//                                                         <option value="desc">High to Low</option>
//                                                     </select>
//                                                 </div> */}
//                                                 <div className="col-md-4" style={{ marginBottom: "5px" }}>
//                                                     <select
//                                                         className="form-select"
//                                                         value={filterJobStatus}
//                                                         onChange={(e) => setFilterJobStatus(e.target.value)}
//                                                     >
//                                                         <option value="">All Job Status</option>
//                                                         {[...new Set(applicationList.flatMap((application) => application.job_status))].map(
//                                                             (status, index) => (
//                                                                 <option key={index} value={status}>
//                                                                     {status}
//                                                                 </option>
//                                                             ),
//                                                         )}
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                             {/* Loader */}
//                                             <div style={{ position: "relative", minHeight: "300px" }}>
//                                                 {isLoading ? (
//                                                     <div
//                                                         style={{
//                                                             display: "flex",
//                                                             justifyContent: "center",
//                                                             alignItems: "center",
//                                                             position: "absolute",
//                                                             top: 0,
//                                                             left: 0,
//                                                             right: 0,
//                                                             bottom: 0,
//                                                             backgroundColor: "rgba(255, 255, 255, 0.8)",
//                                                             zIndex: 10,
//                                                         }}
//                                                     >
//                                                         <Spinner animation="border" role="status" variant="primary" />
//                                                     </div>
//                                                 ) : (
//                                                     <Table responsive="xxl" size="xxl">
//                                                         <thead className="thead-dark">
//                                                             <tr>
//                                                                 <th scope="col">First Name</th>
//                                                                 <th scope="col">Middle Name</th>
//                                                                 <th scope="col">Last Name</th>
//                                                                 <th scope="col">Email</th>
//                                                                 <th scope="col">Phone</th>
//                                                                 <th scope="col">Resume</th>
//                                                                 <th scope="col">Actions</th>
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody>
//                                                             {currentRecords.map((application) => (
//                                                                 <tr key={application.id}>
//                                                                     <td className="text-center p-2 ">{application.first_name}</td>
//                                                                     <td className="text-center p-2 ">{application.middle_name}</td>
//                                                                     <td className="text-center p-2 ">{application.last_name}</td>
//                                                                     <td className="text-center p-2 ">{application.email}</td>
//                                                                     <td className="text-center p-2 ">{application.phone}</td>
//                                                                     <td className="text-center p-2 ">
//                                                                         {application.resume && (
//                                                                             <button
//                                                                                 className="button-dwn"
//                                                                                 type="button"
//                                                                                 onClick={() => handleDownloadResume(application.id, application.resume)}
//                                                                             >
//                                                                                 <span className="button-dwn__text">Download</span>
//                                                                             </button>
//                                                                         )}
//                                                                     </td>
//                                                                     <td className="text-center p-2">
//                                                                         <Button
//                                                                             variant="dark"
//                                                                             size="sm"
//                                                                             className="px-3 py-1 mt-1"
//                                                                             onClick={() => handleViewDetails(application, jobapplications)}
//                                                                         >
//                                                                             <i className="fas fa-eye me-2"></i> Check Result
//                                                                         </Button>
//                                                                         <Button
//                                                                             variant="dark"
//                                                                             size="sm"
//                                                                             className="ms-4 px-3 py-1 mt-1"
//                                                                             onClick={() => handleViewApplicantDetails(application.id)}
//                                                                         >
//                                                                             <i className="fas fa-user me-2"></i> Details
//                                                                         </Button>
//                                                                     </td>
//                                                                 </tr>
//                                                             ))}
//                                                         </tbody>
//                                                     </Table>
//                                                 )}
//                                                 {/* Pagination */}
//                                                 <div className="d-flex justify-content-center">
//                                                     {Array.from({
//                                                         length: Math.ceil(filteredApplications.length / recordsPerPage),
//                                                     }).map((_, index) => (
//                                                         <Button
//                                                             key={index}
//                                                             variant="outline-primary"
//                                                             className="mx-1"
//                                                             onClick={() => handlePageChange(index + 1)}
//                                                         >
//                                                             {index + 1}
//                                                         </Button>
//                                                     ))}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* Modals */}
//                         {showModal && (
//                             <ApplicantModal
//                                 show={showModal}
//                                 onHide={() => setShowModal(false)}
//                                 applicant={selectedApplicant}
//                                 jobapplications={jobapplications}
//                                 setSuccessMessage={setSuccessMessage}
//                                 updateJobApplication={updateJobApplication}
//                             //setChartData={setChartData}
//                             />
//                         )}
//                         {showDetailsModal && (
//                             <ApplicantDetailsModal
//                                 show={showDetailsModal}
//                                 onHide={() => setShowDetailsModal(false)}
//                                 applicant={selectedApplicantDetails}
//                             />
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

// const getOptionStyle = (option, isCorrect, isSelected) => {
//     let style = {};
//     if (isCorrect) {
//         style.color = 'green';  // Correct answer is green
//     }
//     if (isSelected) {
//         style.fontWeight = 'bold'; // Selected answer is bold
//     }
//     return style;
// };


// import React, { useState, useEffect, Form } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css";
// import Sidebar from "../Misc/Sidebar";
// import DashNavbar from "../Misc/DashNavbar";
// import { Table, Alert, Modal, Button } from "react-bootstrap";
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "./ApplicantDetailsModal";

// const ApplicantModal = ({
//   applicant,
//   jobapplications,
//   setSuccessMessage,
//   updateJobApplication,
//   setChartData: setModalChartData,
// }) => {
//   const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     {
//       value: "interview_scheduled",
//       label: "Interview Scheduled",
//       bgColor: "bg-warning",
//     },
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
//   ];
//   const [applicationList, setApplicationList] = useState([]);
//   const [show, setShow] = useState(false);
//   const [refreshInterval, setRefreshInterval] = useState(null);

//   const [score, setScore] = useState([]);
//   const handleStatusChange = (id, newStatus) => {
//     axios
//       .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus, })
//       .then((response) => {
//         console.log("status changed to:", newStatus);
//         setSuccessMessage("Job status updated successfully");
//         updateJobApplication(id, newStatus);

//         axios
//           .get("https://raasbackend.vetrinahealthcare.com/applicants/")
//           .then(async (response) => {
//             const updatedApplications = [];

//             // Map through each application
//             await Promise.all(
//               response.data.map(async (application) => {
//                 try {
//                   // Fetch job titles for the applicant
//                   const jobTitleResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}`
//                   );
//                   // const jobTitles = jobTitleResponse.data.map(job => job.job_title);
//                   const jobScore = jobTitleResponse.data.map(
//                     (job) => job.similarly_score
//                   );

//                   setScore(jobScore);
//                   console.log(score);

//                   const updatedApplication = {
//                     ...application,
//                     // similarity_scores: extractTextResponse.data.similarity_scores,
//                     // job_titles: jobTitles
//                   };

//                   // Push the updated application to the array
//                   updatedApplications.push(updatedApplication);
//                 } catch (error) {
//                   console.error("Error processing application:", error);
//                 }
//               })
//             );

//             // After processing all applications, update the state
//             setApplicationList(updatedApplications);
//           });

//         setTimeout(() => {
//           setSuccessMessage("");
//         }, 5000);
//       })
//       .catch((error) => {
//         console.error("Error updating job status:", error);
//       });
//   };

//   const [chartData, setChartData] = useState(null);

//   useEffect(() => {
//     // Reset chartData when the modal is hidden
//     if (!show) {
//       setChartData(null);
//     }
//   }, [show]);

//   useEffect(() => {
//     if (show && chartData === null) {
//       // Fetch personality assessment data and render the chart
//       fetchPersonalityData(applicant.id);
//     }
//   }, [show, chartData, applicant, setChartData]);

//   const fetchPersonalityData = async (applicantId) => {
//     try {
//       const url = applicantId ? `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/` : "https://raasbackend.vetrinahealthcare.com/get_personality_results/";

//       const response = await axios.get(url);
//       setChartData(response.data);

//       // Call the function to render the chart
//       createBarChart(response.data);
//     } catch (error) {
//       console.error("Error fetching personality assessment data:", error);
//     }
//   };

//   // useEffect(() => {
//   //   // Open the modal automatically after 5 seconds
//   //   const timeout = setTimeout(() => {
//   //     setShow(true);
//   //   });

//   //   // Set an interval to refresh the modal every 10 seconds
//   //   const interval = setInterval(() => {
//   //     setShow(false);
//   //     setTimeout(() => {
//   //       setShow(true);
//   //     });
//   //   });

//   //   // setRefreshInterval(interval);

//   //   // Clean up the timeout and interval on component unmount
//   //   return () => {
//   //     clearTimeout(timeout);
//   //     clearInterval(interval);
//   //   };
//   // }, []);

//   useEffect(() => {
//     // Refresh the modal content when applicant, jobapplications, or similarity_scores props change
//     setShow(false);
//     setTimeout(() => {
//       setShow(true);
//     }, 100);
//   }, [applicant, jobapplications, applicant.similarity_scores]);

//   const onHide = () => {
//     // clearInterval(refreshInterval);
//     setShow(false);
//   };

//   return (
//     <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered>
//       <Modal.Header closeButton>
//         <Modal.Title className=" gradient-text">Applicant Details</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Table bordered>
//           <thead className="thead-dark">
//             <tr>
//               <th scope="col">Job Title</th>
//               <th scope="col">Job Status</th>
//               <th scope="col">Similarity Score</th>
//               <th scope="col">Applied Date</th>
//             </tr>
//           </thead>
//           <tbody>
//             {jobapplications.map((jobApplication, index) => {
//               console.log("jobApplication:", jobApplication);
//               return (
//                 <tr key={index}>
//                   <td className="text-center p-2">
//                     {jobApplication.job_title}
//                   </td>
//                   <td className="text-center p-2">
//                     <select
//                       className={`form-select ${jobStatusOptions.find(
//                         (option) => option.value === jobApplication.job_status
//                       )?.bgColor
//                         }`}
//                       value={jobApplication.job_status}
//                       onChange={(e) =>
//                         handleStatusChange(jobApplication.id, e.target.value)
//                       }
//                     >
//                       {jobStatusOptions.map((option) => (
//                         <option key={option.value} value={option.value}>
//                           {option.label}
//                         </option>
//                       ))}
//                     </select>
//                   </td>
//                   <td className="text-center p-2">
//                     {applicant.similarity_scores[index]}
//                   </td>
//                   <td className="text-center p-2">
//                     {new Date(jobApplication.applied_date).toLocaleDateString()}
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </Table>
//         {/* Add the canvas element for the personality chart */}
//         <div className="row justify-content-center text-center">
//           <h4 className=" gradient-text">Personality Assessment</h4>
//           <canvas id="personalityChart" width="400" height="160"></canvas>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// const handleDownloadResume = async (applicantId, resumeFileName) => {
//   try {
//     // Fetch the resume file content from the backend
//     const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`,
//       {
//         responseType: "arraybuffer",
//       }
//     );

//     // Create a Blob from the response data
//     const blob = new Blob([response.data], { type: "application/pdf" });

//     // Create a link element to trigger the download
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", resumeFileName); // Set the desired file name
//     document.body.appendChild(link);

//     // Trigger the download
//     link.click();

//     // Cleanup
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error("Error downloading resume:", error);
//   }
// };

// const getHighestTraitIndices = (traits) => {
//   const highestTrait = Math.max(...traits);
//   return traits.reduce((indices, trait, index) => {
//     if (trait === highestTrait) {
//       indices.push(index);
//     }
//     return indices;
//   }, []);
// };

// const createBarChart = (data) => {
//   // Extract personality trait scores from the data
//   const {
//     extraversion,
//     agreeableness,
//     openness,
//     conscientiousness,
//     neuroticism,
//   } = data;
//   const traits = [
//     extraversion,
//     agreeableness,
//     openness,
//     conscientiousness,
//     neuroticism,
//   ];

//   // Get the canvas element to render the chart
//   const ctx = document.getElementById("personalityChart").getContext("2d");

//   // Get the indices of the highest trait(s)
//   const highestTraitIndices = getHighestTraitIndices(traits);

//   // Create an array to hold background colors for each trait
//   const backgroundColors = [
//     "rgba(75, 192, 192, 0.2)",
//     "rgba(75, 192, 192, 0.2)",
//     "rgba(75, 192, 192, 0.2)",
//     "rgba(75, 192, 192, 0.2)",
//     "rgba(75, 192, 192, 0.2)",
//   ];

//   // Change the color of the columns with the highest trait(s)
//   highestTraitIndices.forEach((index) => {
//     backgroundColors[index] = "rgba(0, 0, 255, 0.2)";
//   });

//   // Create or update the bar chart
//   new Chart(ctx, {
//     type: "bar",
//     data: {
//       labels: [
//         "Extraversion",
//         "Agreeableness",
//         "Openness",
//         "Conscientiousness",
//         "Neuroticism",
//       ],
//       datasets: [
//         {
//           label: "Personality Traits",
//           data: [
//             extraversion,
//             agreeableness,
//             openness,
//             conscientiousness,
//             neuroticism,
//           ],
//           backgroundColor: backgroundColors,
//           borderColor: "rgba(75, 192, 192, 1)",
//           borderWidth: 1,
//           barPercentage: 10.0, // Adjust this value as needed
//           categoryPercentage: 0.1, // Adjust this value as needed
//         },
//         {
//           label: "Highest Trait",
//           data: [0, 0, 0, 0, 0], // Add zeros for all traits except the highest one
//           backgroundColor: "rgba(0, 0, 255, 0.2)",
//           borderColor: "rgba(0, 0, 255, 1)",
//           borderWidth: 1,
//         },
//       ],
//     },
//     options: {
//       scales: {
//         y: {
//           beginAtZero: true,
//           max: 25,
//         },
//       },
//       // barPercentage: 1.0, // Adjust this value as needed
//       // categoryPercentage: 1.5, // Adjust this value as needed
//     },
//   });
// };

// export default function Jobapplicationresult() {
//   const [applicationList, setApplicationList] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const recordsPerPage = 10;
//   const [jobapplications, setjobapplications] = useState([]);
//   const [score, setScore] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [showDetailsModal, setShowDetailsModal] = useState(false);
//   const [selectedApplicant, setSelectedApplicant] = useState(null);
//   const [selectedApplicantDetails, setSelectedApplicantDetails] =
//     useState(null);
//   const [jobTitles, setJobTitles] = useState([]);
//   // State for filters
//   const [filterJobTitle, setFilterJobTitle] = useState("");
//   const [filterJobStatus, setFilterJobStatus] = useState("");
//   const [sortSimilarityScore, setSortSimilarityScore] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const updateJobApplication = (applicantId, newStatus) => {
//     const updatedApplications = jobapplications.map((application) => {
//       if (application.id === applicantId) {
//         return { ...application, job_status: newStatus };
//       }
//       return application;
//     });
//     setjobapplications(updatedApplications);
//   };

//   // useEffect(() => {
//   //   const fetchJobTitles = async ({ applicantId }) => {
//   //     try {
//   //       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicantId}/`);
//   //       setJobTitles(response.data);
//   //     } catch (err) {
//   //       setError(err.message);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchJobTitles();
//   // });

//   useEffect(() => {
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/applicants/")
//       .then(async (response) => {
//         const updatedApplications = [];

//         await Promise.all(
//           response.data.map(async (application) => {
//             try {
//               const resumeResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${application.id}/`,
//                 { responseType: "blob" }
//               );
//               const pdfFile = new File(
//                 [resumeResponse.data],
//                 application.resume,
//                 {
//                   type: "application/pdf",
//                 }
//               );

//               const jobTitleResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}`
//               );
//               const jobTitles = jobTitleResponse.data.map(
//                 (job) => job.job_title
//               );
//               const similarityScores = jobTitleResponse.data.map(
//                 (job) => job.similarly_score
//               );
//               const jobstatus = jobTitleResponse.data.map(
//                 (job) => job.job_status
//               );

//               const updatedApplication = {
//                 ...application,
//                 job_titles: jobTitles,
//                 similarity_scores: similarityScores,
//                 job_status: jobstatus,
//               };

//               updatedApplications.push(updatedApplication);
//             } catch (error) {
//               console.error("Error processing application:", error);
//             }
//           })
//         );

//         setApplicationList(updatedApplications);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching applications:", error);
//         setError(error);
//         setLoading(false);
//       });
//   }, []);

//   // // Filter application list based on search query
//   // const filteredApplications = applicationList.filter(
//   //   (application) =>
//   //     application.first_name
//   //       .toLowerCase()
//   //       .includes(searchQuery.toLowerCase()) ||
//   //     application.last_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//   //     application.email.toLowerCase().includes(searchQuery.toLowerCase())
//   // );

//   const handleFilter = () => {
//     let filteredList = applicationList.filter((application) => {
//       const matchesSearchQuery =
//         application.first_name
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase()) ||
//         application.last_name
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase()) ||
//         application.email.toLowerCase().includes(searchQuery.toLowerCase());

//       const matchesJobTitle = filterJobTitle
//         ? application.job_titles.some((jobTitle) =>
//           jobTitle.toLowerCase().includes(filterJobTitle.toLowerCase())
//         )
//         : true;

//       // const matchesJobStatus = filterJobStatus
//       //   ? application.job_status && application.job_status.toLowerCase().includes(filterJobStatus.toLowerCase())
//       //   : true;

//       const matchesJobStatus = filterJobStatus
//         ? application.job_status.some((jobstatus) =>
//           jobstatus.toLowerCase().includes(filterJobStatus.toLowerCase())
//         )
//         : true;

//       return matchesSearchQuery && matchesJobTitle && matchesJobStatus;
//     });

//     if (sortSimilarityScore) {
//       filteredList = filteredList.sort((a, b) => {
//         const maxScoreA = Math.max(...a.similarity_scores);
//         const maxScoreB = Math.max(...b.similarity_scores);
//         return sortSimilarityScore === "asc"
//           ? maxScoreA - maxScoreB
//           : maxScoreB - maxScoreA;
//       });
//     }

//     return filteredList;
//   };

//   const filteredApplications = handleFilter();
//   // Get current records
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = filteredApplications.slice(
//     indexOfFirstRecord,
//     indexOfLastRecord
//   );

//   // Change page
//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
//   const [chartData, setChartData] = useState(null);

//   const extractPDFText = async () => {
//     const response = await axios.get("https://raasbackend.vetrinahealthcare.com/applicants/");
//     const applications = response.data;

//     for (const application of applications) {
//       try {
//         // Fetch resume PDF
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${application.id}/`,
//           { responseType: "blob" }
//         );
//         const pdfFile = new File([response.data], application.resume, {
//           type: "application/pdf",
//         });

//         // Fetch job titles for the applicant
//         const jobTitleResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}`
//         );
//         const jobTitles = jobTitleResponse.data.map((job) => job.job_title);
//         const applicant_id = jobTitleResponse.data.map(
//           (job) => job.applicant
//         )[0];

//         const formData = new FormData();
//         formData.append("pdf_file", pdfFile);
//         formData.append("job_titles", JSON.stringify(jobTitles));
//         formData.append("applicant_id", applicant_id);

//         const extractTextResponse = await axios.post
//           (`https://raasbackend.vetrinahealthcare.com/extract-pdf-text/` + applicant_id,
//             formData,
//             {
//               headers: {
//                 "Content-Type": "multipart/form-data", // Set the correct content type
//               },
//             }
//           );
//         console.log("PDF text extraction response:", extractTextResponse.data);
//       } catch (error) {
//         console.error("Error extracting PDF text:", error);
//       }
//     }
//   };

//   useEffect(() => {
//     // Call extractPDFText function when the component mounts
//     extractPDFText();
//   }, []);

//   const handleViewDetails = async (applicant, jobapplications) => {
//     setSelectedApplicant(applicant);
//     setShowModal(true);
//     // await fetchDataAndStore(applicant.id);

//     try {
//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`
//       );
//       setjobapplications(response.data);

//       // Fetch personality data for the selected applicant
//       const personalityResponse = await axios.get
//         (`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicant.id}/`);
//       setChartData(personalityResponse.data);
//       // Assuming you have the applicant's PDF file and job titles available
//       const pdfFile = applicant.resume; // Replace with the actual PDF file object
//       const jobTitles = jobapplications.map((job) => job.job_title);
//       // You can process the extracted text as needed
//       // console.log(extractedText);
//       // postExtractPdfText()
//     } catch (error) {
//       console.error("Error fetching job applications:", error);
//     }
//   };

//   const handleViewApplicantDetails = async (applicantId) => {
//     try {
//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//       const applicantDetails = response.data;
//       setSelectedApplicantDetails(applicantDetails);
//       setShowDetailsModal(true);
//     } catch (error) {
//       console.error("Error fetching applicant details:", error);
//     }
//   };

//   return (
//     <>
//       {/* <div
//         style={{ display: "flex", flexDirection: "column", height: "100vh" }}
//       > */}
//       <DashNavbar />
//       <div className="wrapper">
//         <Sidebar />
//         <div className="main">
//           <div className="container mt-2 ">
//             <div className="d-flex justify-content-center align-items-center applicationlist">
//               <div className="auth-inner w-100 " style={{ padding: "0px" }}>
//                 <div className="row justify-content-center">
//                   <div className="col-lg-12">
//                     <div className="bg-white rounded p-3">
//                       <h2 className="display-6 gradient-text mb-4">
//                         Application List
//                       </h2>
//                       {successMessage && (
//                         <div
//                           style={{
//                             position: "fixed",
//                             top: "10%",
//                             right: "2%",
//                             zIndex: "9999",
//                           }}
//                         >
//                           <Alert
//                             variant="success"
//                             onClose={() => setSuccessMessage("")}
//                             dismissible
//                           >
//                             <div
//                               style={{ display: "flex", alignItems: "center" }}
//                             >
//                               <span style={{ flex: 1 }}>{successMessage}</span>
//                             </div>
//                           </Alert>
//                         </div>
//                       )}
//                       {/* Search bar */}
//                       {/* <div className="row justify-content-center">
//                         <div className="col-md-5 mb-4">
//                           <div className="input-group">
//                             <div
//                               className="form-outline"
//                               data-mdb-input-init
//                               style={{ width: "100%" }}
//                             >
//                               <input
//                                 id="search-input"
//                                 type="search"
//                                 className="form-control text-xs"
//                                 placeholder="Search by Name, Email or Job title"
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                               />
//                             </div>
//                             <button
//                               id="search-button"
//                               type="button"
//                               className="btn btn-primary text-xs"
//                               style={{
//                                 position: "absolute",
//                                 right: "0px",
//                                 top: "0px",
//                               }}
//                             >
//                               <i className="fas fa-search"></i>
//                             </button>
//                           </div>
//                         </div>
//                       </div> */}
//                       <div className="row justify-content-center">
//                         <div className="col-md-5 mb-4">
//                           <div className="input-group">
//                             <div
//                               className="form-outline"
//                               data-mdb-input-init
//                               style={{ width: "100%" }}
//                             >
//                               <input
//                                 id="search-input"
//                                 type="search"
//                                 className="form-control text-xs"
//                                 placeholder="Search by Name, Email or Job title"
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                               />
//                             </div>
//                             <button
//                               id="search-button"
//                               type="button"
//                               className="btn btn-primary text-xs"
//                               style={{
//                                 position: "absolute",
//                                 right: "0px",
//                                 top: "0px",
//                               }}
//                             >
//                               <i className="fas fa-search"></i>
//                             </button>
//                           </div>
//                         </div>
//                       </div>

//                       <div className="row mb-4">
//                         <div
//                           className="col-md-4"
//                           style={{ marginBottom: "5px", width: "100wv" }}
//                         >
//                           <select
//                             className="form-select"
//                             value={filterJobTitle}
//                             onChange={(e) => setFilterJobTitle(e.target.value)}
//                           >
//                             <option value="">All Job Titles</option>
//                             {[
//                               ...new Set(
//                                 applicationList.flatMap(
//                                   (application) => application.job_titles
//                                 )
//                               ),
//                             ].map((title, index) => (
//                               <option key={index} value={title}>
//                                 {title}
//                               </option>
//                             ))}
//                           </select>
//                         </div>
//                         <div
//                           className="col-md-4"
//                           style={{ marginBottom: "5px" }}
//                         >
//                           <select
//                             className="form-select"
//                             value={sortSimilarityScore}
//                             onChange={(e) =>
//                               setSortSimilarityScore(e.target.value)
//                             }
//                           >
//                             <option value="">Sort by Similarity Score</option>
//                             <option value="asc">Low to High</option>
//                             <option value="desc">High to Low</option>
//                           </select>
//                         </div>
//                         <div
//                           className="col-md-4"
//                           style={{ marginBottom: "5px" }}
//                         >
//                           <select
//                             className="form-select"
//                             value={filterJobStatus}
//                             onChange={(e) => setFilterJobStatus(e.target.value)}
//                           >
//                             <option value="">All Job Status</option>
//                             {[
//                               ...new Set(
//                                 applicationList.flatMap(
//                                   (application) => application.job_status
//                                 )
//                               ),
//                             ].map((status, index) => (
//                               <option key={index} value={status}>
//                                 {status}
//                               </option>
//                             ))}
//                           </select>
//                         </div>
//                       </div>

//                       <Table responsive="xxl" size="xxl">
//                         <thead className="thead-dark">
//                           <tr>
//                             <th scope="col">First Name</th>
//                             <th scope="col">Last Name</th>
//                             <th scope="col">Email</th>
//                             <th scope="col">Phone</th>
//                             <th scope="col">Resume</th>
//                             <th scope="col">Actions</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {currentRecords.map((application, index) => (
//                             <tr key={application.id}>
//                               <td className="text-center p-2 ">
//                                 {application.first_name}
//                               </td>
//                               <td className="text-center p-2 ">
//                                 {application.last_name}
//                               </td>
//                               <td className="text-center p-2 ">
//                                 {application.email}
//                               </td>
//                               <td className="text-center p-2 ">
//                                 {application.phone}
//                               </td>
//                               <td className="text-center p-2 ">
//                                 {/* Display Resume and Download Option */}
//                                 {application.resume && (
//                                   <>
//                                     <button
//                                       className="button-dwn"
//                                       type="button"
//                                       role="button"
//                                       tabIndex={0}
//                                       onClick={() =>
//                                         handleDownloadResume(
//                                           application.id,
//                                           application.resume
//                                         )
//                                       }
//                                       onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                           handleDownloadResume(
//                                             application.id,
//                                             application.resume
//                                           );
//                                         }
//                                       }}
//                                     >
//                                       <span className="button-dwn__text">
//                                         Download
//                                       </span>
//                                       <span className="button-dwn__icon">
//                                         <svg
//                                           xmlns="http://www.w3.org/2000/svg"
//                                           viewBox="0 0 35 35"
//                                           id="bdd05811-e15d-428c-bb53-8661459f9307"
//                                           data-name="Layer 2"
//                                           className="svg"
//                                         >
//                                           <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
//                                           <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
//                                           <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
//                                         </svg>
//                                       </span>
//                                     </button>
//                                   </>
//                                 )}
//                               </td>
//                               <td className="text-center p-2">
//                                 <Button
//                                   variant="dark"
//                                   size="sm"
//                                   className="px-3 py-1 "
//                                   style={{ marginBottom: "5px" }}
//                                   onClick={() =>
//                                     handleViewDetails(
//                                       application,
//                                       jobapplications
//                                     )
//                                   }
//                                 >
//                                   <i className="fas fa-eye me-2"></i>
//                                   View
//                                 </Button>

//                                 <Button
//                                   variant="dark"
//                                   size="sm"
//                                   className="ms-4 px-3 py-1"
//                                   style={{ marginBottom: "5px" }}
//                                   onClick={() =>
//                                     handleViewApplicantDetails(application.id)
//                                   }
//                                 >
//                                   <i className="fas fa-circle-info me-2"></i>
//                                   Info
//                                 </Button>
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </Table>
//                       {/* Pagination Controls */}
//                       <nav aria-label="Page navigation">
//                         <ul className="pagination justify-content-right">
//                           {Array.from(
//                             {
//                               length: Math.ceil(
//                                 applicationList.length / recordsPerPage
//                               ),
//                             },
//                             (_, index) => (
//                               <li
//                                 key={index + 1}
//                                 className={`page-item ${index + 1 === currentPage ? "active" : ""
//                                   }`}
//                               >
//                                 <button
//                                   className="page-link text-xs"
//                                   onClick={() => handlePageChange(index + 1)}
//                                 >
//                                   {index + 1}
//                                 </button>
//                               </li>
//                             )
//                           )}
//                         </ul>
//                       </nav>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {selectedApplicant && (
//         <ApplicantModal
//           show={showModal}
//           onHide={() => setShowModal(false)}
//           applicant={selectedApplicant}
//           jobapplications={jobapplications}
//           setjobapplications={setjobapplications}
//           setSuccessMessage={setSuccessMessage}
//           updateJobApplication={updateJobApplication}
//         />
//       )}

//       {/* Applicant Details Modal */}
//       {selectedApplicantDetails && (
//         <ApplicantDetailsModal
//           applicant={selectedApplicantDetails}
//           show={showDetailsModal}
//           onHide={() => setShowDetailsModal(false)}
//         />
//       )}
//     </>
//   );
// }

//old code
// import React, { useState, useEffect, Form } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css";
// import Sidebar from "../Misc/Sidebar";
// import DashNavbar from "../Misc/DashNavbar";
// import { Table, Alert, Modal, Button } from "react-bootstrap";
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "./ApplicantDetailsModal";
// import Spinner from "react-bootstrap/Spinner";

// const ApplicantModal = ({
//   applicant,
//   jobapplications,
//   setSuccessMessage,
//   updateJobApplication,
//   setChartData: setModalChartData,
// }) => {
//   const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     {
//       value: "interview_scheduled",
//       label: "Interview Scheduled",
//       bgColor: "bg-warning",
//     },
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
//   ];
//   const [applicationList, setApplicationList] = useState([]);
//   const [show, setShow] = useState(false);
//   const [refreshInterval, setRefreshInterval] = useState(null);

//   const [score, setScore] = useState([]);
//   const handleStatusChange = (id, newStatus) => {
//     axios
//       .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus, })
//       .then((response) => {
//         console.log("status changed to:", newStatus);
//         setSuccessMessage("Job status updated successfully");
//         updateJobApplication(id, newStatus);

//         axios
//           .get("https://raasbackend.vetrinahealthcare.com/applicants/")
//           .then(async (response) => {
//             const updatedApplications = [];
//             await Promise.all(
//               response.data.map(async (application) => {
//                 try {
//                   const jobTitleResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}`
//                   );
//                   const jobScore = jobTitleResponse.data.map(
//                     (job) => job.similarly_score
//                   );
//                   setScore(jobScore);
//                   console.log(score);
//                   const updatedApplication = {
//                     ...application,
//                   };
//                   updatedApplications.push(updatedApplication);
//                 } catch (error) {
//                   console.error("Error processing application:", error);
//                 }
//               })
//             );
//             setApplicationList(updatedApplications);
//           });
//         setTimeout(() => {
//           setSuccessMessage("");
//         }, 5000);
//       })
//       .catch((error) => {
//         console.error("Error updating job status:", error);
//       });
//   };
//   const [chartData, setChartData] = useState(null);
//   useEffect(() => {
//     if (!show) {
//       setChartData(null);
//     }
//   }, [show]);
//   useEffect(() => {
//     if (show && chartData === null) {
//       fetchPersonalityData(applicant.id);
//     }
//   }, [show, chartData, applicant, setChartData]);
//   const fetchPersonalityData = async (applicantId) => {
//     try {
//       const url = applicantId ? `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/` : "https://raasbackend.vetrinahealthcare.com/get_personality_results/";
//       const response = await axios.get(url);
//       setChartData(response.data);
//       createBarChart(response.data);
//     } catch (error) {
//       console.error("Error fetching personality assessment data:", error);
//     }
//   };
//   useEffect(() => {
//     setShow(false);
//     setTimeout(() => {
//       setShow(true);
//     }, 100);
//   }, [applicant, jobapplications, applicant.similarity_scores]);
//   const onHide = () => {
//     setShow(false);
//   };
//   return (
//     <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered>
//       <Modal.Header closeButton>
//         <Modal.Title className=" gradient-text">Applicant Details</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Table bordered>
//           <thead className="thead-dark">
//             <tr>
//               <th scope="col">Job Title</th>
//               <th scope="col">Job Status</th>
//               <th scope="col">Similarity Score</th>
//               <th scope="col">Applied Date</th>
//             </tr>
//           </thead>
//           <tbody>
//             {jobapplications.map((jobApplication, index) => {
//               console.log("jobApplication:", jobApplication);
//               return (
//                 <tr key={index}>
//                   <td className="text-center p-2">
//                     {jobApplication.job_title}
//                   </td>
//                   <td className="text-center p-2">
//                     <select
//                       className={`form-select ${jobStatusOptions.find(
//                         (option) => option.value === jobApplication.job_status
//                       )?.bgColor
//                         }`}
//                       value={jobApplication.job_status}
//                       onChange={(e) =>
//                         handleStatusChange(jobApplication.id, e.target.value)
//                       }
//                     >
//                       {jobStatusOptions.map((option) => (
//                         <option key={option.value} value={option.value}>
//                           {option.label}
//                         </option>
//                       ))}
//                     </select>
//                   </td>
//                   <td className="text-center p-2">
//                     {applicant.similarity_scores[index]}
//                   </td>
//                   <td className="text-center p-2">
//                     {new Date(jobApplication.applied_date).toLocaleDateString()}
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </Table>
//         <div className="row justify-content-center text-center">
//           <h4 className=" gradient-text">Personality Assessment</h4>
//           <canvas id="personalityChart" width="400" height="160"></canvas>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };
// const handleDownloadResume = async (applicantId, resumeFileName) => {
//   try {
//     const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`,
//       {
//         responseType: "arraybuffer",
//       }
//     );
//     const blob = new Blob([response.data], { type: "application/pdf" });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", resumeFileName); // Set the desired file name
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error("Error downloading resume:", error);
//   }
// };
// const getHighestTraitIndices = (traits) => {
//   const highestTrait = Math.max(...traits);
//   return traits.reduce((indices, trait, index) => {
//     if (trait === highestTrait) {
//       indices.push(index);
//     }
//     return indices;
//   }, []);
// };
// const createBarChart = (data) => {
//   const {
//     extraversion,
//     agreeableness,
//     openness,
//     conscientiousness,
//     neuroticism,
//   } = data;
//   const traits = [
//     extraversion,
//     agreeableness,
//     openness,
//     conscientiousness,
//     neuroticism,
//   ];
//   const ctx = document.getElementById("personalityChart").getContext("2d");
//   const highestTraitIndices = getHighestTraitIndices(traits);
//   const backgroundColors = [
//     "rgba(75, 192, 192, 0.2)",
//     "rgba(75, 192, 192, 0.2)",
//     "rgba(75, 192, 192, 0.2)",
//     "rgba(75, 192, 192, 0.2)",
//     "rgba(75, 192, 192, 0.2)",
//   ];
//   highestTraitIndices.forEach((index) => {
//     backgroundColors[index] = "rgba(0, 0, 255, 0.2)";
//   });
//   new Chart(ctx, {
//     type: "bar",
//     data: {
//       labels: [
//         "Extraversion",
//         "Agreeableness",
//         "Openness",
//         "Conscientiousness",
//         "Neuroticism",
//       ],
//       datasets: [
//         {
//           label: "Personality Traits",
//           data: [
//             extraversion,
//             agreeableness,
//             openness,
//             conscientiousness,
//             neuroticism,
//           ],
//           backgroundColor: backgroundColors,
//           borderColor: "rgba(75, 192, 192, 1)",
//           borderWidth: 1,
//           barPercentage: 10.0, // Adjust this value as needed
//           categoryPercentage: 0.1, // Adjust this value as needed
//         },
//         {
//           label: "Highest Trait",
//           data: [0, 0, 0, 0, 0], // Add zeros for all traits except the highest one
//           backgroundColor: "rgba(0, 0, 255, 0.2)",
//           borderColor: "rgba(0, 0, 255, 1)",
//           borderWidth: 1,
//         },
//       ],
//     },
//     options: {
//       scales: {
//         y: {
//           beginAtZero: true,
//           max: 25,
//         },
//       },
//     },
//   });
// };
// export default function Jobapplicationresult() {
//   const [applicationList, setApplicationList] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const recordsPerPage = 10;
//   const [jobapplications, setjobapplications] = useState([]);
//   const [score, setScore] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [showDetailsModal, setShowDetailsModal] = useState(false);
//   const [selectedApplicant, setSelectedApplicant] = useState(null);
//   const [selectedApplicantDetails, setSelectedApplicantDetails] =
//     useState(null);
//   const [jobTitles, setJobTitles] = useState([]);
//   const [filterJobTitle, setFilterJobTitle] = useState("");
//   const [filterJobStatus, setFilterJobStatus] = useState("");
//   const [sortSimilarityScore, setSortSimilarityScore] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const [error, setError] = useState(null);

//   const updateJobApplication = (applicantId, newStatus) => {
//     const updatedApplications = jobapplications.map((application) => {
//       if (application.id === applicantId) {
//         return { ...application, job_status: newStatus };
//       }
//       return application;
//     });
//     setjobapplications(updatedApplications);
//   };
//   useEffect(() => {
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/applicants/")
//       .then(async (response) => {
//         const updatedApplications = [];
//         await Promise.all(
//           response.data.map(async (application) => {
//             try {
//               const resumeResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${application.id}/`,
//                 { responseType: "blob" }
//               );
//               const pdfFile = new File(
//                 [resumeResponse.data],
//                 application.resume,
//                 {
//                   type: "application/pdf",
//                 }
//               );
//               const jobTitleResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}`
//               );
//               const jobTitles = jobTitleResponse.data.map(
//                 (job) => job.job_title
//               );
//               const similarityScores = jobTitleResponse.data.map(
//                 (job) => job.similarly_score
//               );
//               const jobstatus = jobTitleResponse.data.map(
//                 (job) => job.job_status
//               );
//               const updatedApplication = {
//                 ...application,
//                 job_titles: jobTitles,
//                 similarity_scores: similarityScores,
//                 job_status: jobstatus,
//               };
//               updatedApplications.push(updatedApplication);
//             } catch (error) {
//               console.error("Error processing application:", error);
//             }
//           })
//         );
//         setApplicationList(updatedApplications);
//         setIsLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching applications:", error);
//         setError(error);
//         setIsLoading(false);
//       });
//   }, []);
//   const handleFilter = () => {
//     let filteredList = applicationList.filter((application) => {
//       const matchesSearchQuery =
//         application.first_name
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase()) ||
//         application.last_name
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase()) ||
//         application.email.toLowerCase().includes(searchQuery.toLowerCase());
//       const matchesJobTitle = filterJobTitle
//         ? application.job_titles.some((jobTitle) =>
//           jobTitle.toLowerCase().includes(filterJobTitle.toLowerCase())
//         )
//         : true;
//       const matchesJobStatus = filterJobStatus
//         ? application.job_status.some((jobstatus) =>
//           jobstatus.toLowerCase().includes(filterJobStatus.toLowerCase())
//         )
//         : true;
//       return matchesSearchQuery && matchesJobTitle && matchesJobStatus;
//     });
//     if (sortSimilarityScore) {
//       filteredList = filteredList.sort((a, b) => {
//         const maxScoreA = Math.max(...a.similarity_scores);
//         const maxScoreB = Math.max(...b.similarity_scores);
//         return sortSimilarityScore === "asc"
//           ? maxScoreA - maxScoreB
//           : maxScoreB - maxScoreA;
//       });
//     }
//     return filteredList;
//   };
//   const filteredApplications = handleFilter();
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = filteredApplications.slice(
//     indexOfFirstRecord,
//     indexOfLastRecord
//   );
//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
//   const [chartData, setChartData] = useState(null);
//   const extractPDFText = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/applicants/");
//       const applications = response.data;
//       for (const application of applications) {
//         try {
//           const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${application.id}/`, {
//             responseType: "blob",
//           });
//           const pdfFile = new File([response.data], application.resume, {
//             type: "application/pdf",
//           });
//           const jobTitleResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}`);
//           const jobTitles = jobTitleResponse.data.map((job) => job.job_title);
//           const applicant_id = jobTitleResponse.data.map((job) => job.applicant)[0];
//           const formData = new FormData();
//           formData.append("pdf_file", pdfFile);
//           formData.append("job_titles", JSON.stringify(jobTitles));
//           formData.append("applicant_id", applicant_id);
//           await axios.post(
//             `https://raasbackend.vetrinahealthcare.com/extract-pdf-text/` + applicant_id,
//             formData,
//             { headers: { "Content-Type": "multipart/form-data" } }
//           );
//         } catch (error) {
//           console.error("Error extracting PDF text:", error);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching applicants:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     extractPDFText();
//   }, []);

//   const handleViewDetails = async (applicant, jobapplications) => {
//     setSelectedApplicant(applicant);
//     setShowModal(true);
//     try {
//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//       setjobapplications(response.data);
//       const personalityResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicant.id}/`);
//       setChartData(personalityResponse.data);
//     } catch (error) {
//       console.error("Error fetching job applications:", error);
//     }
//   };

//   const handleViewApplicantDetails = async (applicantId) => {
//     try {
//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//       setSelectedApplicantDetails(response.data);
//       setShowDetailsModal(true);
//     } catch (error) {
//       console.error("Error fetching applicant details:", error);
//     }
//   };

//   return (
//     <>
//       <DashNavbar />
//       <div className="wrapper">
//         <Sidebar />
//         <div className="main">
//           <div className="container mt-2">
//             <div className="d-flex justify-content-center align-items-center applicationlist">
//               <div className="auth-inner w-100" style={{ padding: "0px" }}>
//                 <div className="row justify-content-center">
//                   <div className="col-lg-12">
//                     <div className="bg-white rounded p-3">
//                       <h2 className="display-6 gradient-text mb-4">Application List</h2>
//                       {successMessage && (
//                         <div
//                           style={{
//                             position: "fixed",
//                             top: "10%",
//                             right: "2%",
//                             zIndex: "9999",
//                           }}
//                         >
//                           <Alert variant="success" onClose={() => setSuccessMessage("")} dismissible>
//                             <div style={{ display: "flex", alignItems: "center" }}>
//                               <span style={{ flex: 1 }}>{successMessage}</span>
//                             </div>
//                           </Alert>
//                         </div>
//                       )}
//                       <div className="row justify-content-center">
//                         <div className="col-md-5 mb-4">
//                           <div className="input-group">
//                             <div className="form-outline" data-mdb-input-init style={{ width: "100%" }}>
//                               <input
//                                 id="search-input"
//                                 type="search"
//                                 className="form-control text-xs"
//                                 placeholder="Search by Name, Email or Job title"
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                               />
//                             </div>
//                             <button
//                               id="search-button"
//                               type="button"
//                               className="btn btn-primary text-xs"
//                               style={{
//                                 position: "absolute",
//                                 right: "0px",
//                                 top: "0px",
//                               }}
//                             >
//                               <i className="fas fa-search"></i>
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="row mb-4">
//                         <div className="col-md-4" style={{ marginBottom: "5px", width: "100wv" }}>
//                           <select
//                             className="form-select"
//                             value={filterJobTitle}
//                             onChange={(e) => setFilterJobTitle(e.target.value)}
//                           >
//                             <option value="">All Job Titles</option>
//                             {[...new Set(applicationList.flatMap((application) => application.job_titles))].map(
//                               (title, index) => (
//                                 <option key={index} value={title}>
//                                   {title}
//                                 </option>
//                               )
//                             )}
//                           </select>
//                         </div>
//                         <div className="col-md-4" style={{ marginBottom: "5px" }}>
//                           <select
//                             className="form-select"
//                             value={sortSimilarityScore}
//                             onChange={(e) => setSortSimilarityScore(e.target.value)}
//                           >
//                             <option value="">Sort by Similarity Score</option>
//                             <option value="asc">Low to High</option>
//                             <option value="desc">High to Low</option>
//                           </select>
//                         </div>
//                         <div className="col-md-4" style={{ marginBottom: "5px" }}>
//                           <select
//                             className="form-select"
//                             value={filterJobStatus}
//                             onChange={(e) => setFilterJobStatus(e.target.value)}
//                           >
//                             <option value="">All Job Status</option>
//                             {[...new Set(applicationList.flatMap((application) => application.job_status))].map(
//                               (status, index) => (
//                                 <option key={index} value={status}>
//                                   {status}
//                                 </option>
//                               )
//                             )}
//                           </select>
//                         </div>
//                       </div>
//                       {/* Loader */}
//                       <div style={{ position: "relative", minHeight: "300px" }}>
//                         {isLoading ? (
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                               position: "absolute",
//                               top: 0,
//                               left: 0,
//                               right: 0,
//                               bottom: 0,
//                               backgroundColor: "rgba(255, 255, 255, 0.8)",
//                               zIndex: 10,
//                             }}
//                           >
//                             <Spinner animation="border" role="status" variant="primary" />
//                           </div>
//                         ) : (
//                           <Table responsive="xxl" size="xxl">
//                             <thead className="thead-dark">
//                               <tr>
//                                 <th scope="col">First Name</th>
//                                 <th scope="col">Last Name</th>
//                                 <th scope="col">Email</th>
//                                 <th scope="col">Phone</th>
//                                 <th scope="col">Resume</th>
//                                 <th scope="col">Actions</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {currentRecords.map((application) => (
//                                 <tr key={application.id}>
//                                   <td className="text-center p-2 ">{application.first_name}</td>
//                                   <td className="text-center p-2 ">{application.last_name}</td>
//                                   <td className="text-center p-2 ">{application.email}</td>
//                                   <td className="text-center p-2 ">{application.phone}</td>
//                                   <td className="text-center p-2 ">
//                                     {application.resume && (
//                                       <button
//                                         className="button-dwn"
//                                         type="button"
//                                         onClick={() =>
//                                           handleDownloadResume(application.id, application.resume)
//                                         }
//                                       >
//                                         <span className="button-dwn__text">Download</span>
//                                       </button>
//                                     )}
//                                   </td>
//                                   <td className="text-center p-2">
//                                     <Button
//                                       variant="dark"
//                                       size="sm"
//                                       className="px-3 py-1"
//                                       onClick={() => handleViewDetails(application, jobapplications)}
//                                     >
//                                       <i className="fas fa-eye me-2"></i> View
//                                     </Button>
//                                     <Button
//                                       variant="dark"
//                                       size="sm"
//                                       className="ms-4 px-3 py-1"
//                                       onClick={() => handleViewApplicantDetails(application.id)}
//                                     >
//                                       <i className="fas fa-user me-2"></i> Details
//                                     </Button>
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </Table>
//                         )}
//                         {/* Pagination */}
//                         <div className="d-flex justify-content-center">
//                           {Array.from({ length: Math.ceil(filteredApplications.length / recordsPerPage) }).map(
//                             (_, index) => (
//                               <Button
//                                 key={index}
//                                 variant="outline-primary"
//                                 className="mx-1"
//                                 onClick={() => handlePageChange(index + 1)}
//                               >
//                                 {index + 1}
//                               </Button>
//                             )
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {/* Modals */}
//             {showModal && (
//               <ApplicantModal show={showModal} onHide={() => setShowModal(false)} applicant={selectedApplicant} />
//             )}
//             {showDetailsModal && (
//               <ApplicantDetailsModal
//                 show={showDetailsModal}
//                 onHide={() => setShowDetailsModal(false)}
//                 applicant={selectedApplicantDetails}
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }



// import React, { useState, useEffect, useRef } from "react"
// import axios from "axios"
// import "bootstrap/dist/css/bootstrap.min.css"
// import "../css/dash.css"
// import Sidebar from "../Misc/Sidebar"
// import DashNavbar from "../Misc/DashNavbar"
// import { Table, Alert, Modal, Button, Card } from "react-bootstrap"
// import Chart from "chart.js/auto"
// import ApplicantDetailsModal from "./ApplicantDetailsModal"
// import Spinner from "react-bootstrap/Spinner"

// // =====================================================================
// // ========== START: ApplicantModal Component (Unchanged) ============
// // =====================================================================
// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
//     setChartData: setModalChartData, // Note: This prop isn't used inside ApplicantModal in the provided code
// }) => {
//     const jobStatusOptions = [
//         { value: "applied", label: "Applied", bgColor: "bg-info" },
//         { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//         {
//             value: "interview_scheduled",
//             label: "Interview Scheduled",
//             bgColor: "bg-warning",
//         },
//         { value: "selected", label: "Selected", bgColor: "bg-success" },
//         { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
//     ]
//     const [applicationList, setApplicationList] = useState([]) // Note: This state seems unused based on the provided logic inside ApplicantModal
//     const [show, setShow] = useState(false)
//     const [refreshInterval, setRefreshInterval] = useState(null) // Note: This state seems unused based on the provided logic inside ApplicantModal

//     const [score, setScore] = useState([]) // Note: This state seems unused based on the provided logic inside ApplicantModal
//     const handleStatusChange = (id, newStatus) => {
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus }) // Adjust port if needed
//             .then((response) => {
//                 console.log("status changed to:", newStatus)
//                 setSuccessMessage("Job status updated successfully")
//                 updateJobApplication(id, newStatus) // Update parent state

//                 // This re-fetch logic inside the modal seems redundant if the parent handles updates.
//                 // Consider refactoring if needed, but keeping as is per request.
//                 axios.get("https://raasbackend.vetrinahealthcare.com/applicants/").then(async (response) => { // Adjust port if needed
//                     const updatedApplications = []
//                     await Promise.all(
//                         response.data.map(async (application) => {
//                             try {
//                                 // Fetching job title/score again here might not be necessary
//                                 const jobTitleResponse = await axios.get(
//                                     `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}`, // Adjust port if needed
//                                 )
//                                 const jobScore = jobTitleResponse.data.map((job) => job.similarly_score)
//                                 setScore(jobScore) // This updates a state variable not seemingly used elsewhere in this modal
//                                 console.log(score)
//                                 const updatedApplication = {
//                                     ...application,
//                                 }
//                                 updatedApplications.push(updatedApplication)
//                             } catch (error) {
//                                 console.error("Error processing application:", error)
//                             }
//                         }),
//                     )
//                     setApplicationList(updatedApplications) // This updates a state variable not seemingly used elsewhere in this modal
//                 })
//                 setTimeout(() => {
//                     setSuccessMessage("")
//                 }, 5000)
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error)
//             })
//     }
//     //const [chartData, setChartData] = useState(null)  //Old Chart Data (Commented out in original)
//     const [personalityData, setPersonalityData] = useState([]); // Array to hold multiple results
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);

//     const chartRefs = useRef([]); // Ref to store chart instances

//     const [allSubmittedAnswers, setAllSubmittedAnswers] = useState(null); // Store all response,
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null); // Store filterd answer
//     const [currentJobId, setCurrentJobId] = useState(null); //New state for current jobId

//     const [jobQuestions, setJobQuestions] = useState(null); // Store job questions from API

//     useEffect(() => {
//         if (!show) {
//             setPersonalityData([]); // Clear previous data when modal hides
//             setPersonalityJobTitles([]);
//             setAllSubmittedAnswers(null); // also clear when closing modal
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);  //Clear Job Question when close
//             setCurrentJobId(null);  // Clear currentJobId when close
//         }
//     }, [show])

//     useEffect(() => {
//         // Added check for applicant id to prevent fetch error if applicant is null initially
//         if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         } else if (show && !applicant?.id) {
//              console.warn("ApplicantModal opened without a valid applicant ID.");
//              setPersonalityData([]); // Ensure data is cleared if no ID
//              setPersonalityJobTitles([]);
//         }
//     }, [show, applicant]); // Depend on applicant object

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             // Fetch personality results for the specific applicant
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`; // Adjust port if needed
//             const personalityResponse = await axios.get(personalityUrl);
//             setPersonalityData(personalityResponse.data); // Expecting an array for the specific applicant

//             // Fetch job titles associated with this applicant's applications
//             const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicantId}`; // Adjust port if needed
//             const jobTitleResponse = await axios.get(jobTitleUrl);
//             // Map job titles based on job_id matching personality results
//              const titlesMap = jobTitleResponse.data.reduce((acc, job) => {
//                  acc[job.job_id] = job.job_title;
//                  return acc;
//              }, {});
//              const orderedTitles = personalityResponse.data.map(pData => titlesMap[pData.job_id] || 'Unknown Job');
//              setPersonalityJobTitles(orderedTitles);

//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//              setPersonalityData([]); // Clear data on error
//              setPersonalityJobTitles([]);
//         }
//     };

//     useEffect(() => {
//         // Destroy existing chart instances
//         chartRefs.current.forEach(chart => {
//             if (chart && typeof chart.destroy === 'function') { // Add check if chart exists and has destroy method
//                 chart.destroy();
//             }
//         });
//         chartRefs.current = []; // Clear the array

//         // Create charts for each personality data
//         if (Array.isArray(personalityData)) { // Ensure personalityData is an array
//             personalityData.forEach((data, index) => {
//                 const chartId = `personalityChart-${index}`;
//                 const chartContainer = document.getElementById(chartId); // Get container, not canvas directly yet

//                 // Check if container exists before trying to get context
//                 if (chartContainer && chartContainer.tagName === 'CANVAS') {
//                      // Check if a chart instance already exists for this canvas
//                     const existingChart = Chart.getChart(chartContainer);
//                     if (existingChart) {
//                         existingChart.destroy(); // Destroy existing chart if found
//                     }
//                     const newChart = createDonutChart(data, chartId, data.status); // Pass the status to the chart
//                     if (newChart) { // Ensure chart creation was successful
//                         chartRefs.current.push(newChart); // Store the chart instance
//                     }
//                 } else if (chartContainer) {
//                      console.warn(`Element with id ${chartId} is not a CANVAS element or container not found.`);
//                 }
//             });
//         }
//     }, [personalityData]); // Rerun when personalityData changes

//     // Effect to control modal visibility based on applicant prop change
//     useEffect(() => {
//         if (applicant) {
//             setShow(true);
//         } else {
//             setShow(false);
//         }
//         // The timeout logic seems intended to force re-render, might not be reliable
//         // Consider directly using the applicant prop change to control 'show' state
//         // setShow(false)
//         // setTimeout(() => {
//         //     setShow(true)
//         // }, 100)
//     // }, [applicant, jobapplications, applicant?.similarity_scores]); // Listen to applicant changes
//      }, [applicant]); // Simplified dependency: only applicant matters for showing/hiding

//     const onHide = () => {
//         setShow(false); // Controlled by state
//         // Optionally call a parent handler if needed: `props.onHide()`
//     }

//     const createDonutChart = (data, chartId, status) => {
//         const canvasElement = document.getElementById(chartId);
//         if (!canvasElement || typeof canvasElement.getContext !== 'function') {
//              console.error(`Canvas element with id ${chartId} not found or is not a canvas.`);
//              return null;
//          }
//         const ctx = canvasElement.getContext("2d");

//         const { correct_count = 0, all_count = 0, wrong_count = 0 } = data || {}; // Add default values

//         if (all_count === 0) {
//             console.warn(`Chart ${chartId}: No questions (all_count is 0). Cannot draw chart.`);
//              // Optionally display a message on the canvas
//              ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
//              ctx.textAlign = 'center';
//              ctx.fillText('No data available', canvasElement.width / 2, canvasElement.height / 2);
//             return null; // Cannot draw chart if no questions
//         }

//         // Calculate percentages safely
//         const correctPercentage = ((correct_count / all_count) * 100).toFixed(1);
//         const wrongPercentage = ((wrong_count / all_count) * 100).toFixed(1);

//         const chart = new Chart(ctx, {
//             type: 'doughnut',
//             data: {
//                 labels: ['Correct', 'Wrong'],
//                 datasets: [{
//                     label: 'Quiz Results',
//                     data: [correct_count, wrong_count],
//                     backgroundColor: [
//                         'rgba(75, 192, 192, 0.8)', // Teal/Green
//                         'rgba(255, 99, 132, 0.8)'  // Red
//                     ],
//                     borderColor: [
//                         'rgba(75, 192, 192, 1)',
//                         'rgba(255, 99, 132, 1)'
//                     ],
//                     borderWidth: 1,
//                 }]
//             },
//             options: {
//                 responsive: true,
//                 maintainAspectRatio: false, // Allows setting height/width via container
//                 cutout: '60%', // Make the donut hole larger or smaller
//                 plugins: {
//                     legend: {
//                         position: 'top',
//                     },
//                     title: {
//                         display: true,
//                         // Use status if available, otherwise calculate percentage
//                         text: `Quiz Result (${status !== undefined ? `${status}%` : `${correctPercentage}% Correct`})`,
//                         font: {
//                             size: 14
//                         }
//                     },
//                      tooltip: {
//                          callbacks: {
//                              label: function(context) {
//                                  let label = context.label || '';
//                                  if (label) {
//                                      label += ': ';
//                                  }
//                                  if (context.parsed !== null) {
//                                      const value = context.parsed;
//                                      const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                                      const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
//                                      label += `${value} (${percentage}%)`;
//                                  }
//                                  return label;
//                              }
//                          }
//                      }
//                 }
//             }
//         });
//         return chart;
//     };

//     // Handler for the "Show Submitted Answers" button click
//     const handleShowSubmittedAnswers = async (applicantId, jobId) => {
//         if (!applicantId || !jobId) {
//             console.error("Missing applicantId or jobId for showing submitted answers.");
//             return;
//         }
//         setCurrentJobId(jobId);  // Set currently selected jobId
//         setFilteredSubmittedAnswers(null); // Clear previous filtered answers
//         setJobQuestions(null); // Clear previous questions

//         try {
//              // Fetch all personality results again (or potentially use stored personalityData if guaranteed up-to-date)
//             const answersResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`); // Adjust port if needed
//             setAllSubmittedAnswers(answersResponse.data);  // Store all the API response.

//             // Fetch job questions specifically for the selected job
//             const questionResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${jobId}/`); // Adjust port if needed
//             setJobQuestions(questionResponse.data);

//             // Filter answers immediately after fetching
//              const filtered = answersResponse.data.find(item => item.job_id === jobId);
//              if (filtered) {
//                  setFilteredSubmittedAnswers(filtered);
//              } else {
//                  console.warn(`No submitted answers found for applicant ${applicantId} and job ${jobId}.`);
//                  setFilteredSubmittedAnswers(null); // Explicitly set to null if not found
//              }

//         } catch (error) {
//             console.error("Error fetching submitted answers or questions:", error);
//             setAllSubmittedAnswers(null);  // Clear any previous data in case of an error
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null); // Also Clear Question when Error occur
//         }
//     };

//     // Removed the useEffect filtering logic as it's now done directly in handleShowSubmittedAnswers
//     // useEffect(() => {
//     //     //Filter logic
//     //     if (allSubmittedAnswers) {
//     //         const filtered = allSubmittedAnswers.find(item => item.job_id === currentJobId); // only show job_id equal
//     //         setFilteredSubmittedAnswers(filtered);
//     //     } else {
//     //         setFilteredSubmittedAnswers(null);
//     //     }
//     // }, [allSubmittedAnswers, currentJobId]);

//     // Guard against rendering when applicant is null or jobapplications are not ready
//     if (!applicant) {
//         return null; // Don't render the modal if there's no applicant data
//     }

//     return (
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered>
//             <Modal.Header closeButton>
//                 {/* Added Applicant Name */}
//                 <Modal.Title className=" gradient-text">
//                     {applicant.first_name} {applicant.last_name} - Details
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 {/* Job Applications Table */}
//                 <h4 className="gradient-text text-center mb-3">Job Applications</h4>
//                 <Table bordered hover responsive size="sm" className="mb-4">
//                     <thead className="thead-dark">
//                         <tr>
//                             <th scope="col">Job Title</th>
//                             <th scope="col">Job Status</th>
//                             {/* <th scope="col">Similarity Score</th> */} {/* Commented out in original */}
//                             <th scope="col">Applied Date</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {/* Ensure jobapplications is an array before mapping */}
//                         {Array.isArray(jobapplications) && jobapplications.length > 0 ? (
//                             jobapplications.map((jobApplication, index) => {
//                                 // console.log("jobApplication:", jobApplication) // Keep if needed for debugging
//                                 // Find the correct status option for background color
//                                 const statusOption = jobStatusOptions.find((option) => option.value === jobApplication.job_status);
//                                 const selectBgColor = statusOption ? statusOption.bgColor : 'bg-light'; // Default color
//                                 return (
//                                     <tr key={jobApplication.id || index}> {/* Use unique ID if available */}
//                                         <td className="text-center p-2 align-middle">{jobApplication.job_title || 'N/A'}</td>
//                                         <td className="text-center p-2 align-middle">
//                                             <select
//                                                 className={`form-select form-select-sm ${selectBgColor}`} // Added form-select-sm for consistency
//                                                 value={jobApplication.job_status || 'applied'} // Default to 'applied' if status missing
//                                                 onChange={(e) => handleStatusChange(jobApplication.id, e.target.value)}
//                                                 style={{ minWidth: '150px' }} // Ensure dropdown is wide enough
//                                             >
//                                                 {jobStatusOptions.map((option) => (
//                                                     <option key={option.value} value={option.value}>
//                                                         {option.label}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                         </td>
//                                         {/* <td className="text-center p-2 align-middle">{applicant.similarity_scores?.[index] ?? 'N/A'}</td> */} {/* Commented out in original */}
//                                         <td className="text-center p-2 align-middle">
//                                              {jobApplication.applied_date
//                                                  ? new Date(jobApplication.applied_date).toLocaleDateString()
//                                                  : 'N/A'}
//                                          </td>
//                                     </tr>
//                                 )
//                             })
//                         ) : (
//                              <tr>
//                                  <td colSpan="3" className="text-center p-3">No job application data found for this applicant.</td>
//                              </tr>
//                         )}
//                     </tbody>
//                 </Table>

//                 {/* Personality Assessments Section */}
//                 <h4 className="gradient-text text-center mb-3">Personality Assessments</h4>
//                 <div className="row justify-content-center">
//                     <div className="d-flex flex-wrap justify-content-center"> {/* Use flexbox to wrap items */}
//                         {Array.isArray(personalityData) && personalityData.length > 0 ? (
//                             personalityData.map((data, index) => (
//                                 // Use a unique key, preferably data.job_id if unique per applicant assessment
//                                 <div key={data.job_id || index} className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center"> {/* Adjusted grid classes */}
//                                     <Card className="advanced-card shadow-sm" style={{ width: '100%', maxWidth: '350px' }}>  {/* Apply custom class and set max width */}
//                                         <Card.Body className="text-center d-flex flex-column">
//                                             <Card.Title className="mb-3">{personalityJobTitles[index] || `Assessment ${index + 1}`}</Card.Title>
//                                             {/* Chart Container */}
//                                             <div style={{ position: 'relative', width: '100%', height: '200px', marginBottom: '1rem' }}>
//                                                 <canvas id={`personalityChart-${index}`}></canvas>
//                                             </div>
//                                             {/* Details */}
//                                             <div className="mt-auto"> {/* Push button to bottom */}
//                                                 <Card.Text>
//                                                     Result: <b>{data.result === 'T' ? 'Passed' : 'Failed'}</b>
//                                                 </Card.Text>
//                                                 <Card.Text>
//                                                     Percentage: <b className="gradient-text">{data.status !== undefined ? `${data.status}%` : 'N/A'}</b>
//                                                 </Card.Text>
//                                                 {/* Added "Show Submitted Answers" button */}
//                                                 <Button
//                                                     variant="info"
//                                                     size="sm"
//                                                     onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id)}
//                                                     disabled={!data.job_id} // Disable if job_id is missing
//                                                     className="mt-2"
//                                                 >
//                                                     Show Submitted Answers
//                                                 </Button>
//                                             </div>
//                                         </Card.Body>
//                                     </Card>
//                                 </div>
//                             ))
//                         ) : (
//                             <div className="col-12">
//                                 <p className="text-center text-muted mt-3">No personality assessment data available for this applicant.</p>
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {/* Conditionally render the submitted answers */}
//                 {filteredSubmittedAnswers && currentJobId && jobQuestions && Array.isArray(jobQuestions) && (
//                     <div className="row justify-content-center mt-4">
//                         <h5 className="gradient-text text-center mb-3">
//                              Submitted Answers & Questions for Job: {personalityJobTitles[personalityData.findIndex(p => p.job_id === currentJobId)] || `Job ID ${currentJobId}`}
//                         </h5>
//                          <Table striped bordered hover responsive size="sm">
//                             <thead>
//                                 <tr>
//                                     <th>#</th>
//                                     <th>Question</th>
//                                     <th>Your Answer / Options</th>
//                                     <th>Result</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobQuestions.length > 0 ? jobQuestions.map((question, index) => {
//                                     // Find the submitted answer for this question ID
//                                     const submittedAnswer = filteredSubmittedAnswers.selected_answers?.find(
//                                         answer => answer.question_id === question.id
//                                     );

//                                     let yourAnswerDisplay = "Not Answered";
//                                     let result = <span className="text-muted">N/A</span>; // Default result
//                                     let isCorrect = false;

//                                     // Determine if the question is multiple-choice based on presence of answers array and correct_answer_index
//                                     const isMultipleChoice = Array.isArray(question.answers) && question.answers.length > 0 && question.correct_answer_index !== null && question.correct_answer_index !== undefined;

//                                     if (submittedAnswer) {
//                                         if (isMultipleChoice) {
//                                             // Handle multiple choice
//                                             const selectedIndex = submittedAnswer.selected_answer_index;
//                                             if (selectedIndex !== undefined && selectedIndex !== null && question.answers[selectedIndex]) {
//                                                  yourAnswerDisplay = (
//                                                      <ul className="list-unstyled mb-0">
//                                                          {question.answers.map((optionText, optionIndex) => {
//                                                              const isSelected = optionIndex === selectedIndex;
//                                                              const isActuallyCorrect = optionIndex === question.correct_answer_index;
//                                                              let className = "";
//                                                              if (isSelected) className += " fw-bold"; // Bold selected
//                                                              if (isActuallyCorrect) className += " text-success"; // Mark correct option green

//                                                              return (
//                                                                  <li key={optionIndex} className={className}>
//                                                                      {optionText}
//                                                                      {/* Optionally add check/cross marks */}
//                                                                      {/* {isSelected && isActuallyCorrect ? ' ✔️' : ''} */}
//                                                                      {/* {isSelected && !isActuallyCorrect ? ' ❌' : ''} */}
//                                                                  </li>
//                                                              );
//                                                          })}
//                                                      </ul>
//                                                  );

//                                                 // Determine result for MC question
//                                                 isCorrect = selectedIndex === question.correct_answer_index;
//                                                 result = isCorrect ? <span className="text-success fw-bold">Correct</span> : <span className="text-danger fw-bold">Wrong</span>;

//                                             } else {
//                                                 yourAnswerDisplay = <span className="text-warning">Invalid answer index recorded</span>;
//                                                 result = <span className="text-warning">Error</span>;
//                                             }
//                                         } else {
//                                             // Handle text-based or other types (assume text for now)
//                                             yourAnswerDisplay = submittedAnswer.selected_answer_text || <span className="text-muted">No text answer</span>;
//                                             // Result for text questions is typically manual review
//                                             result = <span className="text-info">Manual Review</span>;
//                                         }
//                                     } else {
//                                          // Handle case where question exists but no answer was submitted for it
//                                          if (isMultipleChoice) {
//                                               yourAnswerDisplay = ( // Show options even if not answered
//                                                  <ul className="list-unstyled mb-0">
//                                                      {question.answers.map((optionText, optionIndex) => (
//                                                          <li key={optionIndex} className={optionIndex === question.correct_answer_index ? 'text-success' : ''}>
//                                                              {optionText}
//                                                          </li>
//                                                      ))}
//                                                  </ul>
//                                              );
//                                          } else {
//                                              yourAnswerDisplay = <span className="text-muted">No answer provided</span>;
//                                          }
//                                          result = <span className="text-warning">Not Answered</span>;
//                                     }

//                                     return (
//                                         <tr key={question.id || index}>
//                                             <td>{index + 1}</td>
//                                             <td>{question.question_text || 'N/A'}</td>
//                                             <td>{yourAnswerDisplay}</td>
//                                             <td className="text-center align-middle">{result}</td>
//                                         </tr>
//                                     );
//                                 }) : (
//                                      <tr>
//                                          <td colSpan="4" className="text-center text-muted p-3">
//                                              No questions found for this job assessment.
//                                          </td>
//                                      </tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                     </div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={onHide}>
//                      Close
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//     )
// }
// // =====================================================================
// // ============ END: ApplicantModal Component (Unchanged) ============
// // =====================================================================


// // =====================================================================
// // ========= START: handleDownloadResume Function (Unchanged) ==========
// // =====================================================================
// const handleDownloadResume = async (applicantId, resumeFileName) => {
//     if (!applicantId || !resumeFileName) {
//         console.error("Missing applicant ID or filename for resume download.");
//         // Optionally show an error message to the user
//         return;
//     }
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, { // Adjust port if needed
//             responseType: "arraybuffer", // Use arraybuffer for binary data
//         })

//         // Create Blob from arraybuffer
//         const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/pdf" }); // Use content-type from header or default

//         // Create a URL for the blob
//         const url = window.URL.createObjectURL(blob);

//         // Create a temporary link element
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", resumeFileName); // Set the desired file name
//         document.body.appendChild(link);

//         // Programmatically click the link to trigger the download
//         link.click();

//         // Clean up: remove the link and revoke the blob URL
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);

//     } catch (error) {
//         console.error("Error downloading resume:", error);
//          // Handle specific errors if possible (e.g., 404 Not Found)
//          if (error.response && error.response.status === 404) {
//              alert(`Resume for applicant ${applicantId} not found.`);
//          } else {
//              alert(`An error occurred while downloading the resume: ${error.message}`);
//          }
//     }
// }
// // =====================================================================
// // =========== END: handleDownloadResume Function (Unchanged) ==========
// // =====================================================================


// // =====================================================================
// // ===== START: getHighestTraitIndices Function (Unchanged Helper) =====
// // =====================================================================
// // Note: This function is defined but doesn't seem to be called anywhere in the provided code.
// // Keeping it as per the request to not change existing logic.
// const getHighestTraitIndices = (traits) => {
//     // Ensure traits is an array of numbers
//     if (!Array.isArray(traits) || traits.length === 0 || !traits.every(t => typeof t === 'number')) {
//          console.warn("getHighestTraitIndices received invalid input:", traits);
//          return [];
//      }
//     const highestTrait = Math.max(...traits)
//     return traits.reduce((indices, trait, index) => {
//         if (trait === highestTrait) {
//             indices.push(index)
//         }
//         return indices
//     }, [])
// }
// // =====================================================================
// // ======= END: getHighestTraitIndices Function (Unchanged Helper) =====
// // =====================================================================


// // =====================================================================
// // ====== START: Jobapplicationresult Component (Main Component) =======
// // =====================================================================
// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([])
//     const [currentPage, setCurrentPage] = useState(1)
//     const [successMessage, setSuccessMessage] = useState("")
//     const [searchQuery, setSearchQuery] = useState("")
//     const recordsPerPage = 4
//     const [jobapplications, setjobapplications] = useState([]) // State to hold applications for the *selected* applicant modal
//     // const [score, setScore] = useState([]) // State defined but not used in this component's render/logic
//     const [showModal, setShowModal] = useState(false)
//     const [showDetailsModal, setShowDetailsModal] = useState(false)
//     const [selectedApplicant, setSelectedApplicant] = useState(null) // For ApplicantModal (job status, personality)
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null) // For ApplicantDetailsModal (basic info)
//     // const [jobTitles, setJobTitles] = useState([]) // State defined but not used directly, derived from applicationList instead
//     const [filterJobTitle, setFilterJobTitle] = useState("")
//     const [filterJobStatus, setFilterJobStatus] = useState("") // Filter by status *applied* for
//     const [sortSimilarityScore, setSortSimilarityScore] = useState("")
//     const [isLoading, setIsLoading] = useState(false) // Initially true maybe? Depends on fetch timing
//     const [error, setError] = useState(null)

//     // Function passed to ApplicantModal to update status in the main list's display data
//     // This updates the *jobapplications* state used ONLY by the ApplicantModal
//     const updateJobApplication = (jobApplicationId, newStatus) => {
//         setjobapplications((prevApplications) =>
//             prevApplications.map((application) => {
//                 if (application.id === jobApplicationId) {
//                     return { ...application, job_status: newStatus }
//                 }
//                 return application
//             })
//         );
//          // ALSO update the main applicationList if needed for consistency elsewhere (e.g., status filter)
//          // This requires knowing which applicant the jobApplicationId belongs to.
//          // Finding the applicant and updating their job_status array might be complex here.
//          // A full re-fetch might be simpler or handle updates more robustly in the main fetch effect.
//          // For now, just updating the modal's data as per original logic.
//     }

//     // Fetch initial application list
//     useEffect(() => {
//         setIsLoading(true); // Start loading
//         setError(null); // Clear previous errors
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants/") // Adjust port if needed
//             .then(async (response) => {
//                 const applicationsData = response.data;
//                 if (!Array.isArray(applicationsData)) {
//                     console.error("API response is not an array:", applicationsData);
//                     throw new Error("Received invalid data format from API.");
//                 }

//                 const updatedApplications = [];
//                 // Using Promise.allSettled to handle potential errors for individual applicants gracefully
//                 const results = await Promise.allSettled(
//                     applicationsData.map(async (application) => {
//                         // Basic validation of applicant data
//                         if (!application || typeof application.id === 'undefined') {
//                              console.warn("Skipping invalid applicant data:", application);
//                              return null; // Skip this applicant
//                          }
//                         try {
//                             // Fetch job titles, scores, statuses for this applicant
//                             // It seems /applicant/job-title/ returns an array of job applications for that user
//                             const jobTitleResponse = await axios.get(
//                                 `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}`, // Adjust port if needed
//                             );

//                             if (!Array.isArray(jobTitleResponse.data)) {
//                                  console.warn(`Invalid job title data for applicant ${application.id}:`, jobTitleResponse.data);
//                                  // Assign empty arrays or default values if job data fetch fails or is invalid
//                                  return {
//                                      ...application,
//                                      job_titles: [],
//                                      similarity_scores: [],
//                                      job_status: [], // This holds the status from the JobApplication model
//                                      job_application_details: [], // Store the raw job application details
//                                  };
//                              }

//                             const jobDetails = jobTitleResponse.data;
//                             const jobTitles = jobDetails.map((job) => job.job_title);
//                             const similarityScores = jobDetails.map((job) => job.similarly_score); // Ensure this key exists
//                             const jobStatuses = jobDetails.map((job) => job.job_status); // Status from JobApplication

//                             // Combine applicant data with their job application details
//                             return {
//                                 ...application, // Spread basic applicant info (id, name, email, etc.)
//                                 job_titles: jobTitles,
//                                 similarity_scores: similarityScores,
//                                 job_status: jobStatuses, // Array of statuses for jobs they applied to
//                                 job_application_details: jobDetails, // Store raw details if needed later
//                             };

//                         } catch (error) {
//                             console.error(`Error processing application details for applicant ${application.id}:`, error);
//                              // Return the applicant data with empty job details on error
//                              return {
//                                  ...application,
//                                  job_titles: [],
//                                  similarity_scores: [],
//                                  job_status: [],
//                                  job_application_details: [],
//                              };
//                         }
//                     })
//                 );

//                 // Filter out null results from Promise.allSettled (e.g., invalid initial applicant data)
//                 // and push fulfilled promises' values to updatedApplications
//                 results.forEach(result => {
//                     if (result.status === 'fulfilled' && result.value !== null) {
//                         updatedApplications.push(result.value);
//                     } else if (result.status === 'rejected') {
//                         console.error("A promise was rejected:", result.reason);
//                     }
//                 });

//                 setApplicationList(updatedApplications); // Update state with successfully processed applicants
//             })
//             .catch((error) => {
//                 console.error("Error fetching initial applicant list:", error);
//                 setError(error.message || "Failed to fetch applicant data."); // Set error state
//                 setApplicationList([]); // Clear list on error
//             })
//             .finally(() => {
//                 setIsLoading(false); // Stop loading regardless of success or error
//             });
//     }, []); // Empty dependency array means this runs once on mount


//     // Handle filtering logic
//     const handleFilter = () => {
//         // Start with the full list
//         let filteredList = [...applicationList];

//         // Filter by Search Query (Name, Email)
//         if (searchQuery) {
//             const lowerCaseQuery = searchQuery.toLowerCase();
//             filteredList = filteredList.filter((application) =>
//                 application.first_name?.toLowerCase().includes(lowerCaseQuery) ||
//                 application.middle_name?.toLowerCase().includes(lowerCaseQuery) ||
//                 application.last_name?.toLowerCase().includes(lowerCaseQuery) ||
//                 application.email?.toLowerCase().includes(lowerCaseQuery)
//             );
//         }

//         // Filter by Job Title Applied For
//         if (filterJobTitle) {
//             const lowerCaseJobTitle = filterJobTitle.toLowerCase();
//             filteredList = filteredList.filter(application =>
//                  // Check if *any* of the job titles they applied for match the filter
//                  Array.isArray(application.job_titles) &&
//                  application.job_titles.some(jobTitle =>
//                      jobTitle?.toLowerCase().includes(lowerCaseJobTitle)
//                  )
//              );
//         }

//         // Filter by Job Application Status
//         if (filterJobStatus) {
//             const lowerCaseJobStatus = filterJobStatus.toLowerCase();
//              filteredList = filteredList.filter(application =>
//                  // Check if *any* of their job applications match the status filter
//                  Array.isArray(application.job_status) &&
//                  application.job_status.some(status =>
//                      status?.toLowerCase() === lowerCaseJobStatus // Exact match for status
//                  )
//              );
//         }


//         // Sort by Similarity Score (Highest score across all their applications)
//         if (sortSimilarityScore) {
//             filteredList = filteredList.sort((a, b) => {
//                  // Find the maximum similarity score for applicant A, default to -Infinity if no scores
//                 const maxScoreA = Array.isArray(a.similarity_scores) && a.similarity_scores.length > 0
//                      ? Math.max(...a.similarity_scores.map(s => Number(s) || -Infinity))
//                      : -Infinity;
//                  // Find the maximum similarity score for applicant B
//                  const maxScoreB = Array.isArray(b.similarity_scores) && b.similarity_scores.length > 0
//                      ? Math.max(...b.similarity_scores.map(s => Number(s) || -Infinity))
//                      : -Infinity;

//                 if (sortSimilarityScore === "asc") {
//                     return maxScoreA - maxScoreB; // Ascending order
//                 } else {
//                     return maxScoreB - maxScoreA; // Descending order
//                 }
//             });
//         }
//         return filteredList;
//     };

//     // Calculate filtered applications and current page records
//     const filteredApplications = handleFilter(); // Apply filters and sorting
//     const indexOfLastRecord = currentPage * recordsPerPage;
//     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//     const currentRecords = filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     // Handle page change for pagination
//     const handlePageChange = (pageNumber) => {
//          if (pageNumber >= 1 && pageNumber <= totalPages) {
//              setCurrentPage(pageNumber);
//          }
//      };

//     // State for chart data - seems unused in this component based on provided code
//     // const [chartData, setChartData] = useState(null);

//     // Function to extract PDF text - Note: This fetches ALL applicants again. Consider if needed on demand.
//     // Kept as per original code, including the re-fetch logic.
//     const extractPDFText = async () => {
//         console.log("Attempting to trigger PDF text extraction for all applicants...");
//         setIsLoading(true); // Show loading indicator during extraction
//         try {
//             // Re-fetch the list of applicants first - as per original logic
//             const applicantResponse = await axios.get("https://raasbackend.vetrinahealthcare.com/applicants/"); // Adjust port if needed
//             const applications = applicantResponse.data;

//             if (!Array.isArray(applications)) {
//                 console.error("Invalid response when fetching applicants for PDF extraction.");
//                 return;
//             }

//             // Process each applicant sequentially (can be slow for many applicants)
//             // Consider parallel processing (Promise.all) if performance is critical and backend supports it
//             for (const application of applications) {
//                  if (!application || !application.id || !application.resume) {
//                      console.warn("Skipping applicant due to missing ID or resume filename:", application);
//                      continue;
//                  }

//                 try {
//                      // Fetch the resume blob first - Necessary to create the File object
//                     const resumeBlobResponse = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${application.id}/`, { // Adjust port if needed
//                         responseType: "blob"
//                     });
//                     const pdfFile = new File([resumeBlobResponse.data], application.resume, {
//                         type: "application/pdf",
//                     });

//                     // Fetch the job titles associated with this applicant - needed for the POST request body
//                     const jobTitleResponse = await axios.get(
//                         `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}`, // Adjust port if needed
//                     );
//                     const jobTitles = jobTitleResponse.data.map((job) => job.job_title);
//                      // Assuming applicant ID is consistent, take it from the first job detail or the applicant object itself
//                      // const applicant_id = jobTitleResponse.data.map((job) => job.applicant)[0]; // Original logic - assumes at least one job
//                      const applicant_id = application.id; // Safer: use the ID from the applicant object itself

//                     // Prepare FormData for the extraction endpoint
//                     const formData = new FormData();
//                     formData.append("pdf_file", pdfFile);
//                     formData.append("job_titles", JSON.stringify(jobTitles)); // Send as JSON string
//                     formData.append("applicant_id", applicant_id);

//                     // Send the POST request to trigger extraction for this applicant
//                     // The URL includes applicant_id again - check if backend requires it in both URL and form data
//                     await axios.post(`https://raasbackend.vetrinahealthcare.com/extract-pdf-text/${applicant_id}`, formData, { // Adjust port if needed
//                         headers: { "Content-Type": "multipart/form-data" },
//                     });
//                     console.log(`PDF extraction triggered for applicant ${applicant_id}`);

//                 } catch (error) {
//                     // Log errors for individual applicant processing but continue with others
//                     console.error(`Error processing PDF extraction for applicant ${application.id}:`, error);
//                 }
//             }
//              console.log("Finished attempting PDF text extraction for all applicants.");
//              // Optionally show a success message, but extraction happens async on backend usually
//              // setSuccessMessage("PDF text analysis initiated for all applicants.");
//              // setTimeout(() => setSuccessMessage(""), 5000);

//              // Maybe re-fetch data here if extraction immediately updates similarity scores?
//              // fetchInitialData(); // Or trigger the useEffect fetch again if needed

//         } catch (error) {
//             console.error("Error fetching applicants list during PDF extraction process:", error);
//             setError("Failed to fetch applicants for PDF processing.");
//         } finally {
//             setIsLoading(false); // Hide loading indicator
//         }
//     };

//     // Call extractPDFText on component mount - As per original logic
//     // Consider if this should be manually triggered instead. Running for all applicants on every mount can be heavy.
//     useEffect(() => {
//         // extractPDFText(); // Commenting out automatic trigger - uncomment if needed
//         console.log("Component mounted. PDF extraction trigger is currently commented out.");
//     }, []); // Empty array ensures this effect runs only once on mount


//     // Handler to open the main ApplicantModal (Job Status, Personality)
//     const handleViewDetails = async (applicant) => {
//          if (!applicant || !applicant.id) {
//              console.error("Invalid applicant data passed to handleViewDetails");
//              return;
//          }
//         setSelectedApplicant(applicant); // Set the applicant for the modal

//         // Fetch the specific job applications for *this* applicant to pass to the modal
//         try {
//             // The endpoint returns job application details (title, status, date) for the given applicant ID
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`); // Adjust port if needed
//             if (Array.isArray(response.data)) {
//                  setjobapplications(response.data); // Set state used by ApplicantModal
//              } else {
//                  console.warn(`Received non-array job applications for applicant ${applicant.id}:`, response.data);
//                  setjobapplications([]); // Set empty array if data is invalid
//              }
//         } catch (error) {
//             console.error(`Error fetching job applications for applicant ${applicant.id}:`, error);
//             setjobapplications([]); // Clear on error
//         }

//         setShowModal(true); // Open the modal
//     };


//     // Handler to open the ApplicantDetailsModal (Basic Info)
//     const handleViewApplicantDetails = async (applicantId) => {
//          if (!applicantId) {
//              console.error("No applicant ID provided for viewing details.");
//              return;
//          }
//          setShowDetailsModal(true); // Show modal immediately
//          setSelectedApplicantDetails(null); // Clear previous details while fetching

//          try {
//             // Fetch full details for the specific applicant
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`); // Adjust port if needed
//             setSelectedApplicantDetails(response.data); // Set data for ApplicantDetailsModal
//         } catch (error) {
//             console.error(`Error fetching applicant details for ID ${applicantId}:`, error);
//             setSelectedApplicantDetails(null); // Clear on error
//              setShowDetailsModal(false); // Hide modal again if fetch fails
//              alert(`Failed to load details for applicant ${applicantId}.`);
//         }
//     };

//     // =====================================================================
//     // ============ START: New Handler for Resume Bank Button ============
//     // =====================================================================
//     const handleResumeBankClick = () => {
//         // Construct the full URL to your Django backend endpoint
//         // *** IMPORTANT: Adjust the port (8000) if your Django server runs elsewhere ***
//         const downloadUrl = "https://raasbackend.vetrinahealthcare.com/resume-bank-download/";
//         // Open the URL in a new tab. The backend view should handle the download.
//         window.open(downloadUrl, '_blank', 'noopener,noreferrer');
//     };
//     // =====================================================================
//     // ============ END: New Handler for Resume Bank Button ==============
//     // =====================================================================


//     // Get unique job titles and statuses for filter dropdowns
//     const uniqueJobTitles = [...new Set(applicationList.flatMap(app => app.job_titles || []))].filter(Boolean); // Filter out null/undefined
//     const uniqueJobStatuses = [...new Set(applicationList.flatMap(app => app.job_status || []))].filter(Boolean); // Filter out null/undefined


//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <div className="main">
//                     <div className="container-fluid mt-2 px-md-4"> {/* Use container-fluid and padding */}
//                         <div className="d-flex justify-content-center align-items-center applicationlist">
//                             <div className="auth-inner w-100" style={{ padding: "0px", maxWidth: '100%', overflowX: 'hidden' }}> {/* Allow full width */}
//                                 <div className="row justify-content-center">
//                                     <div className="col-lg-12"> {/* Use full width */}
//                                         <div className="bg-white rounded p-3 p-md-4 shadow-sm"> {/* Add shadow and responsive padding */}

//                                             {/* --- Header with Title and Resume Bank Button --- */}
//                                             <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
//                                                 <h2 className="display-6 gradient-text mb-3 mb-md-0">Application List</h2>
//                                                 {/* =============================================== */}
//                                                 {/* =========== START: Resume Bank Button ========= */}
//                                                 {/* =============================================== */}
//                                                 <Button
//                                                     variant="outline-success" // Or choose a different variant
//                                                     onClick={handleResumeBankClick}
//                                                 >
//                                                     <i className="fas fa-file-excel me-2"></i> {/* Excel Icon */}
//                                                     Resume Bank (Excel)
//                                                 </Button>
//                                                 {/* =============================================== */}
//                                                 {/* ============ END: Resume Bank Button ========== */}
//                                                 {/* =============================================== */}
//                                             </div>

//                                             {/* Success Message Alert */}
//                                             {successMessage && (
//                                                 <div
//                                                     style={{
//                                                         position: "fixed",
//                                                         top: "80px", /* Adjusted top position */
//                                                         right: "20px",
//                                                         zIndex: "1050", /* Ensure it's above other elements */
//                                                         minWidth: "250px" /* Ensure minimum width */
//                                                     }}
//                                                 >
//                                                     <Alert variant="success" onClose={() => setSuccessMessage("")} dismissible>
//                                                         {successMessage}
//                                                     </Alert>
//                                                 </div>
//                                             )}

//                                             {/* Search Input */}
//                                             <div className="row justify-content-center mb-3">
//                                                 <div className="col-md-6">
//                                                     <div className="input-group">
//                                                         <input
//                                                             id="search-input"
//                                                             type="search"
//                                                             className="form-control text-xs"
//                                                             placeholder="Search by Name or Email..."
//                                                             value={searchQuery}
//                                                             onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }} // Reset page on search
//                                                         />
//                                                         <button
//                                                             id="search-button"
//                                                             type="button"
//                                                             className="btn btn-primary text-xs"
//                                                             disabled // Button doesn't do anything currently, search is live
//                                                         >
//                                                             <i className="fas fa-search"></i>
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             {/* Filter Dropdowns */}
//                                             <div className="row g-2 mb-4 align-items-center">
//                                                 <div className="col-md-4">
//                                                     <select
//                                                         className="form-select form-select-sm" // Small select
//                                                         value={filterJobTitle}
//                                                         onChange={(e) => { setFilterJobTitle(e.target.value); setCurrentPage(1); }} // Reset page on filter change
//                                                     >
//                                                         <option value="">Filter by Job Title...</option>
//                                                          {uniqueJobTitles.map((title, index) => (
//                                                              <option key={index} value={title}>
//                                                                  {title}
//                                                              </option>
//                                                          ))}
//                                                     </select>
//                                                 </div>
//                                                 <div className="col-md-4">
//                                                     <select
//                                                         className="form-select form-select-sm"
//                                                         value={sortSimilarityScore}
//                                                         onChange={(e) => { setSortSimilarityScore(e.target.value); setCurrentPage(1); }}
//                                                     >
//                                                         <option value="">Sort by Similarity Score...</option>
//                                                         <option value="desc">Score: High to Low</option>
//                                                         <option value="asc">Score: Low to High</option>
//                                                     </select>
//                                                 </div>
//                                                 <div className="col-md-4">
//                                                     <select
//                                                         className="form-select form-select-sm"
//                                                         value={filterJobStatus}
//                                                         onChange={(e) => { setFilterJobStatus(e.target.value); setCurrentPage(1); }}
//                                                     >
//                                                         <option value="">Filter by Job Status...</option>
//                                                         {uniqueJobStatuses.map((status, index) => (
//                                                              <option key={index} value={status}>
//                                                                  {/* Capitalize status for display */}
//                                                                  {status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
//                                                              </option>
//                                                          ))}
//                                                     </select>
//                                                 </div>
//                                             </div>

//                                             {/* Loading Indicator / Error Message / Table */}
//                                             <div style={{ position: "relative", minHeight: "300px" }}>
//                                                 {isLoading ? (
//                                                     <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
//                                                         <Spinner animation="border" role="status" variant="primary">
//                                                             <span className="visually-hidden">Loading...</span>
//                                                         </Spinner>
//                                                     </div>
//                                                 ) : error ? (
//                                                      <Alert variant="danger" className="text-center">
//                                                          Error loading applications: {error}
//                                                      </Alert>
//                                                  ) : currentRecords.length > 0 ? (
//                                                     <Table responsive="lg" hover size="sm"> {/* Responsive table */}
//                                                         <thead className="thead-dark">
//                                                             <tr>
//                                                                 <th scope="col">First Name</th>
//                                                                 <th scope="col">Middle Name</th>
//                                                                 <th scope="col">Last Name</th>
//                                                                 <th scope="col">Email</th>
//                                                                 <th scope="col">Phone</th>
//                                                                 <th scope="col">Resume</th>
//                                                                 <th scope="col" className="text-center">Actions</th>
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody>
//                                                             {currentRecords.map((application) => (
//                                                                 <tr key={application.id}>
//                                                                     <td className="align-middle p-2">{application.first_name || '-'}</td>
//                                                                     <td className="align-middle p-2">{application.middle_name || '-'}</td>
//                                                                     <td className="align-middle p-2">{application.last_name || '-'}</td>
//                                                                     <td className="align-middle p-2">{application.email || '-'}</td>
//                                                                     <td className="align-middle p-2">{application.phone || '-'}</td>
//                                                                     <td className="align-middle p-2">
//                                                                         {application.resume ? (
//                                                                             <button
//                                                                                 className="button-dwn btn btn-outline-secondary btn-sm py-0 px-2" /* Adjusted styling */
//                                                                                 type="button"
//                                                                                 onClick={() => handleDownloadResume(application.id, application.resume)}
//                                                                                 title={`Download ${application.resume}`}
//                                                                             >
//                                                                                  <i className="fas fa-download me-1"></i> {/* Icon */}
//                                                                                 {/* <span className="button-dwn__text">Download</span> */} {/* Original Text */}
//                                                                             </button>
//                                                                         ) : (
//                                                                             <span className="text-muted">N/A</span>
//                                                                         )}
//                                                                     </td>
//                                                                     <td className="text-center align-middle p-2">
//                                                                         <Button
//                                                                             variant="dark"
//                                                                             size="sm"
//                                                                             className="me-2 px-2 py-1 mt-1" // Reduced padding/margin
//                                                                             onClick={() => handleViewDetails(application)} // Pass the full applicant object
//                                                                             title="Check Job Results & Personality"
//                                                                         >
//                                                                             <i className="fas fa-clipboard-check me-1"></i> Results
//                                                                         </Button>
//                                                                         <Button
//                                                                             variant="secondary" // Changed variant
//                                                                             size="sm"
//                                                                             className="px-2 py-1 mt-1" // Reduced padding/margin
//                                                                             onClick={() => handleViewApplicantDetails(application.id)}
//                                                                             title="View Applicant Details"
//                                                                         >
//                                                                             <i className="fas fa-user me-1"></i> Details
//                                                                         </Button>
//                                                                     </td>
//                                                                 </tr>
//                                                             ))}
//                                                         </tbody>
//                                                     </Table>
//                                                 ) : (
//                                                      <div className="text-center text-muted mt-5">No applications found matching your criteria.</div>
//                                                 )}

//                                                 {/* Pagination - Only show if more than one page */}
//                                                 { !isLoading && !error && filteredApplications.length > recordsPerPage && (
//                                                     <div className="d-flex justify-content-center mt-4">
//                                                         <Button
//                                                             variant="outline-primary"
//                                                             size="sm"
//                                                             className="mx-1"
//                                                             onClick={() => handlePageChange(currentPage - 1)}
//                                                             disabled={currentPage === 1}
//                                                         >
//                                                             « Prev
//                                                         </Button>
//                                                         {/* Generate page numbers (simplified for brevity) */}
//                                                          {/* You might want a more sophisticated pagination component here */}
//                                                         <span className="align-self-center mx-2">
//                                                              Page {currentPage} of {totalPages}
//                                                          </span>
//                                                         <Button
//                                                             variant="outline-primary"
//                                                             size="sm"
//                                                             className="mx-1"
//                                                             onClick={() => handlePageChange(currentPage + 1)}
//                                                             disabled={currentPage === totalPages}
//                                                         >
//                                                             Next »
//                                                         </Button>
//                                                     </div>
//                                                 )}
//                                             </div> {/* End loading/table container */}
//                                         </div> {/* End bg-white */}
//                                     </div> {/* End col-lg-12 */}
//                                 </div> {/* End row */}
//                             </div> {/* End auth-inner */}
//                         </div> {/* End applicationlist container */}

//                         {/* Modals */}
//                         {/* Applicant Modal (Job Status, Personality) */}
//                         {showModal && selectedApplicant && (
//                             <ApplicantModal
//                                 // key={selectedApplicant.id} // Add key to force remount on applicant change if needed
//                                 show={showModal}
//                                 onHide={() => { setShowModal(false); setSelectedApplicant(null); setjobapplications([]); }} // Clear state on hide
//                                 applicant={selectedApplicant}
//                                 jobapplications={jobapplications} // Pass the fetched job applications for this specific user
//                                 setSuccessMessage={setSuccessMessage}
//                                 updateJobApplication={updateJobApplication} // Pass update function
//                                 // setChartData={setChartData} // Prop defined but seems unused in original code
//                             />
//                         )}

//                         {/* Applicant Details Modal (Basic Info) */}
//                         {showDetailsModal && (
//                             <ApplicantDetailsModal
//                                 show={showDetailsModal}
//                                 onHide={() => { setShowDetailsModal(false); setSelectedApplicantDetails(null); }} // Clear state on hide
//                                 applicant={selectedApplicantDetails} // Pass fetched detailed info
//                             />
//                         )}
//                     </div> {/* End container-fluid */}
//                 </div> {/* End main */}
//             </div> {/* End wrapper */}
//         </>
//     )
// }
// // =====================================================================
// // ======== END: Jobapplicationresult Component (Main Component) =======
// // =====================================================================


// // ====================================================================
// // ==== START: getOptionStyle Helper Function (Unchanged, Unused) ====
// // =====================================================================
// // Note: This function is defined but doesn't seem to be called anywhere in the provided code.
// // Keeping it as per the request to not change existing logic.
// const getOptionStyle = (option, isCorrect, isSelected) => {
//     let style = {};
//     if (isCorrect) {
//         style.color = 'green';  // Correct answer is green
//     }
//     if (isSelected) {
//         style.fontWeight = 'bold'; // Selected answer is bold
//     }
//     return style;
// };
// // =====================================================================
// // ===== END: getOptionStyle Helper Function (Unchanged, Unused) =====
// // =====================================================================